/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PlanningAssignmentBaseFragment = { id: string, courseId: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null };

export type PlanningAssignmentDetailFragment = { id: string, studentAssignments: Array<{ pointsEarned: number | null, id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }> };

export type PlanningAssignmentFragment = { id: string, courseId: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null };

export type CoursePlanCardAssignmentFragment = { id: string, day: number | null, week: number | null };

export type CourseAssignmentScheduleFragment = { id: string, day: number | null, week: number | null, duration: number };

export type AssignmentInfoFragment = { courseId: string, id: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null };

export type AssignmentTypeWeightInfoFragment = { id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null };

export type AssignmentTypeWeightsInfoFragment = { __typename: 'courses', id: string, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> };

export type CommentInfoFragment = { id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null };

export type CourseInfoAssignmentFragment = { id: string, day: number | null, week: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType: { id: string } | null };

export type CourseInfoStudentAssignmentFragment = { id: string, freeForm: boolean, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, assignmentId: string, studentId: string, studentCourseId: string, courseDayOffset: number | null };

export type CourseInfoStudentCourseFragment = { id: string, studentId: string, status: Types.Student_Course_Status_Enum, start: string, end: string, courseId: string | null, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null } };

export type CourseInfoFragment = { __typename: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, color: string, picture: string | null, subjects: object | null, labels: object | null, gradeYears: object | null, description: string | null, introduction: string | null, gradingStyle: Types.Grading_Style_Enum, credits: number | null, archived: boolean, useAssignmentTypeWeights: boolean | null, assignments: Array<{ id: string, day: number | null, week: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType: { id: string } | null }>, studentCourses?: Array<{ id: string, studentId: string, status: Types.Student_Course_Status_Enum, start: string, end: string, courseId: string | null, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null } }>, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string } }>, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> };

export type CourseCardInfoFragment = { id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, color: string, picture: string | null, archived: boolean, description: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, importedFromOrganizationId: string | null, copiedFromCourseId: string | null, studentCourses?: Array<{ id: string, student: { id: string, name: string, picture: string | null } }>, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string } }> };

export type CoursePlanCardInfoFragment = { id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, day: number | null, week: number | null }>, studentCourses?: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> };

export type CalendarCourseFragment = { id: string, name: string, color: string, subjects: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> };

export type CalendarWeekCourseFragment = { id: string, name: string, color: string, subjects: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> };

export type CalendarMonthCourseFragment = { id: string, name: string, color: string, subjects: object | null, studentCourses: Array<{ id: string, dailySortOrder: object, student: { id: string }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> };

export type ClaimedParrotRequestCourseInfoFragment = { assignments: Array<{ id: string, day: number | null, week: number | null, duration: number }>, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> };

export type CourseOptionFragment = { id: string, name: string, color: string, subjects: object | null, labels: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null };

export type CustomAssignmentTypeFragment = { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean };

export type EventInfoFragment = { id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> };

export type StudentEventInfoFragment = { id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } };

export type CalendarVacationFragment = { id: string, name: string | null, ignoredCourses: Array<{ course: { id: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string } }> };

export type CalendarWeekVacationFragment = { id: string, name: string | null, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string } }> };

export type OrganizationFragment = { id: string, name: string, supportLink: string | null };

export type OrganizationAdminInfoFragment = { id: string, email: string, organization: { icon: string | null, id: string, name: string, supportLink: string | null } };

export type OrganizationCourseGroupInfoFragment = { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean };

export type OrganizationCourseGroupInfoWithCoursesAndMembersFragment = { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, public: boolean, default: boolean, courses: Array<{ course: { id: string } }>, teachers: Array<{ teacher: { id: string } }>, organizationCodes: Array<{ organizationCode: { id: string } }> };

export type OrganizationCourseCardInfoFragment = { id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, color: string, picture: string | null, archived: boolean, description: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }> };

export type OrganizationCourseInfoFragment = { id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, color: string, picture: string | null, subjects: object | null, labels: object | null, gradeYears: object | null, description: string | null, introduction: string | null, gradingStyle: string, credits: number | null, archived: boolean, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: string | null, sortOrder: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }>, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }> };

export type ParrotRequestInfoFragment = { id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } };

export type PrintingJobInfoFragment = { id: string, teacherId: string | null, studentAccountId: string | null, status: Types.Printing_Job_Status_Enum, file: { id: string, url: string } | null };

export type RescheduleActionFragment = { id: string, type: Types.Reschedule_Action_Types_Enum, status: Types.Reschedule_Action_Statuses_Enum, data: object, created: string, updated: string };

export type StudentInfoFragment = { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null };

export type StudentOptionFragment = { id: string, name: string, picture: string | null };

export type StudentsEventsFragment = { id: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> };

export type HomeStudentAssignmentFragment = { id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, assignment: { id: string, name: string, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string, name: string, color: string, subjects: object | null } }, student: { id: string, name: string, picture: string | null }, studentCourse: { id: string } };

export type CalendarStudentAssignmentsFragment = { id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } };

export type CalendarMonthStudentAssignmentFragment = { id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } };

export type PlanningStudentAssignmentFragment = { id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } };

export type GradebookStudentAssignmentFragment = { id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } };

export type StudentAssignmentToRescheduleFragment = { id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } };

export type PlanningStudentAssignmentRescheduleFragment = { id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null };

export type PlanningAssignmentStudentAssignmentFragment = { pointsEarned: number | null, id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } };

export type StudentAssignmentDetailsFragment = { id: string, start: string | null, end: string | null, pointsEarned: number | null, pointsAvailable: number | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, courseDayOffset: number | null, assignment: { id: string, name: string, week: number | null, day: number | null, description: string | null, teachersNote?: string | null, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }>, course: { id: string, name: string, color: string, subjects: object | null } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, start: string, course: { id: string, gradingStyle: Types.Grading_Style_Enum } | null }, submissions: Array<{ id: string, url: string }>, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> };

export type StudentAssignmentToUpdateGradingStyleFragment = { id: string, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned: number | null, pointsAvailable: number | null };

export type CompletedStudentCourseCardInfoFragment = { id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseSnapshot: object | null, student: { id: string, name: string, picture: string | null } };

export type CourseSnapshotFragment = { course: { __typename: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, color: string, description: string | null, teacherId: string | null, credits: number | null, gradingStyle: Types.Grading_Style_Enum, defaultDaysOfTheWeek: object | null, subjects: object | null, labels: object | null, gradeYears: object | null, introduction: string | null, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, completed: string | null, submissions: Array<{ id: string, url: string }>, assignment: { id: string, name: string, week: number | null, day: number | null, duration: number, graded: boolean, description: string | null, teachersNote: string | null, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }> }, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> }> };

export type ActiveStudentCoursesInfoFragment = { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, course: { numberOfDaysPerWeek: number, numberOfWeeks: number } | null, student: { id: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> } };

export type ActiveStudentCourseCardInfoFragment = { id: string, start: string, end: string, daysOfTheWeek: object, status: Types.Student_Course_Status_Enum, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> };

export type StudentCourseInfoFragment = { id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseDayOffsets: object | null, courseSnapshot: object | null, student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> };

export type CourseStudentCardInfoFragment = { id: string, student: { id: string, name: string, picture: string | null } };

export type CoursePlanCardStudentCourseFragment = { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null };

export type PlanningStudentCourseFragment = { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null };

export type CalendarStudentCourseFragment = { id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> };

export type CalendarWeekStudentCourseFragment = { id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> };

export type CalendarMonthStudentCourseFragment = { id: string, dailySortOrder: object, student: { id: string }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> };

export type StudentCourseToRescheduleFragment = { id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } }> };

export type StudentCourseToReoffsetFragment = { id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } }> };

export type StudentCoursesToUpdateGradingStyleFragment = { id: string, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned: number | null, pointsAvailable: number | null }> };

export type RequiredStudentCourseInfoFragment = { id: string, studentId: string, status: Types.Student_Course_Status_Enum, start: string, end: string, courseId: string | null, daysOfTheWeek: object, courseDayOffsets: object | null };

export type ActiveStudentTranscriptCourseFragment = { id: string, courseSnapshot: object | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }>, course: { __typename: 'courses', id: string, name: string, color: string, credits: number | null, gradingStyle: Types.Grading_Style_Enum, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type CompletedStudentTranscriptCourseFragment = { id: string, calendarYear: string | null, courseSnapshot: object | null };

export type TeacherInfoFragment = { id: string, email: string | null, name: string | null, picture: string | null, organization: { id: string, name: string, supportLink: string | null } | null };

export type ThemeDetailsFragment = { id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null };

export type UserSettingsFragment = { id: string, showEmptyAssignmentDays: boolean, weekStartDay: number, selectedThemeId: string | null };

export type BatchRescheduleStudentAssignmentsMutationVariables = Exact<{
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type BatchRescheduleStudentAssignmentsMutation = { insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null, courseDayOffset: number | null, freeForm: boolean, displayOrder: number | null, endDisplayOrder: number | null }> } | null };

export type BulkDeleteCoursesMutationVariables = Exact<{
  courseIds: Array<string> | string;
}>;


export type BulkDeleteCoursesMutation = { delete_courses: { returning: Array<{ id: string }> } | null };

export type BulkDeleteStudentCoursesMutationVariables = Exact<{
  studentCourseIds: Array<string> | string;
}>;


export type BulkDeleteStudentCoursesMutation = { delete_student_courses: { returning: Array<{ id: string }> } | null };

export type BulkSetCoursesArchiveStatusMutationVariables = Exact<{
  courseIds: Array<string> | string;
  archived: boolean;
}>;


export type BulkSetCoursesArchiveStatusMutation = { update_courses: { returning: Array<{ id: string, archived: boolean, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, subjects: object | null, labels: object | null, assignments: Array<{ id: string, day: number | null, week: number | null }> }> } | null };

export type BulkUpdateAssignmentsMutationVariables = Exact<{
  assignments: Array<Types.Assignments_Insert_Input> | Types.Assignments_Insert_Input;
}>;


export type BulkUpdateAssignmentsMutation = { insert_assignments: { returning: Array<{ id: string, name: string, description: string | null, teachersNote: string | null, graded: boolean, day: number | null, week: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type CompleteStudentCourseMutationVariables = Exact<{
  studentCourseId: string;
  schoolYear: Types.School_Year_Enum;
  calendarYear: string;
  courseSnapshot: object;
}>;


export type CompleteStudentCourseMutation = { studentCourse: { id: string, schoolYear: Types.School_Year_Enum | null, calendarYear: string | null, courseSnapshot: object | null, status: Types.Student_Course_Status_Enum, courseId: string | null, start: string, end: string, student: { id: string, name: string, picture: string | null } } | null, studentAssignments: { returning: Array<{ id: string }> } | null };

export type CreateAssignmentTypeWeightsMutationVariables = Exact<{
  assignmentTypeWeights: Array<Types.Assignment_Type_Weights_Insert_Input> | Types.Assignment_Type_Weights_Insert_Input;
}>;


export type CreateAssignmentTypeWeightsMutation = { assignmentTypeWeights: { returning: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type CreateAssignmentMutationVariables = Exact<{
  assignment: Types.Assignments_Insert_Input;
  includeStudentData?: boolean | null | undefined;
}>;


export type CreateAssignmentMutation = { assignment: { courseId: string, id: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null } | null };

export type CreateAssignmentsMutationVariables = Exact<{
  assignments: Array<Types.Assignments_Insert_Input> | Types.Assignments_Insert_Input;
  includeStudentData?: boolean | null | undefined;
}>;


export type CreateAssignmentsMutation = { assignments: { returning: Array<{ courseId: string, id: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null }> } | null };

export type CreateAttachmentsMutationVariables = Exact<{
  attachments: Array<Types.Files_Insert_Input> | Types.Files_Insert_Input;
}>;


export type CreateAttachmentsMutation = { attachments: { returning: Array<{ id: string, url: string, size: number, assignmentId: string | null }> } | null };

export type NewAttachmentFragment = { id: string, url: string, assignmentId: string | null };

export type CreateCommentMutationVariables = Exact<{
  comment: Types.Comments_Insert_Input;
}>;


export type CreateCommentMutation = { comment: { id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null } | null };

export type CreateCourseMutationVariables = Exact<{
  course: Types.Courses_Insert_Input;
  includeStudentData?: boolean | null | undefined;
  includeOrganizationCourseGroups?: boolean | null | undefined;
}>;


export type CreateCourseMutation = { course: { id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, color: string, picture: string | null, archived: boolean, description: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, importedFromOrganizationId: string | null, copiedFromCourseId: string | null, defaultDaysOfTheWeek: object | null, studentCourses?: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }>, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string } }>, assignments: Array<{ id: string, day: number | null, week: number | null }> } | null };

export type CreateCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentType: Types.Custom_Assignment_Types_Insert_Input;
}>;


export type CreateCustomAssignmentTypeMutation = { customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null };

export type CreateCustomAssignmentTypesMutationVariables = Exact<{
  customAssignmentTypes: Array<Types.Custom_Assignment_Types_Insert_Input> | Types.Custom_Assignment_Types_Insert_Input;
}>;


export type CreateCustomAssignmentTypesMutation = { customAssignmentTypes: { returning: Array<{ id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean }> } | null };

export type CreateEventMutationVariables = Exact<{
  start: string;
  end: string;
  eventType: Types.Event_T_Enum;
  teacherId: string;
  name?: string | null | undefined;
  studentEvents: Array<Types.Student_Events_Insert_Input> | Types.Student_Events_Insert_Input;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
  ignoredCourses: Array<Types.Event_Ignored_Courses_Insert_Input> | Types.Event_Ignored_Courses_Insert_Input;
}>;


export type CreateEventMutation = { event: { id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null }> } | null };

export type CreateOrganizationCourseGroupMutationVariables = Exact<{
  organizationCourseGroup: Types.Organization_Course_Groups_Insert_Input;
}>;


export type CreateOrganizationCourseGroupMutation = { organizationCourseGroup: { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean, public: boolean, courses: Array<{ course: { id: string } }>, teachers: Array<{ teacher: { id: string } }>, organizationCodes: Array<{ organizationCode: { id: string } }> } | null };

export type CreateParrotRequestMutationVariables = Exact<{
  teacherId: string;
  customerId: string;
  parrotRequestWeeksUsed: number;
  courseId: string;
  startWeek: number;
  endWeek: number;
  status: Types.Parrot_Request_Status_Enum;
  queuePosition?: number | null | undefined;
  userNotes?: string | null | undefined;
  files: Array<Types.Files_Insert_Input> | Types.Files_Insert_Input;
}>;


export type CreateParrotRequestMutation = { parrotRequest: { id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } } | null, customer: { id: string, parrotCredits: number } | null };

export type CreateParrotRequestFilesMutationVariables = Exact<{
  files: Array<Types.Files_Insert_Input> | Types.Files_Insert_Input;
}>;


export type CreateParrotRequestFilesMutation = { files: { returning: Array<{ id: string, url: string, size: number, parrotRequestId: string | null }> } | null };

export type NewParrotRequstFileFragment = { id: string, url: string, parrotRequestId: string | null };

export type CreatePrintingJobMutationVariables = Exact<{
  teacherId?: string | null | undefined;
  studentAccountId?: string | null | undefined;
  printingJobType: Types.Printing_Job_Type_Enum;
  data: object;
}>;


export type CreatePrintingJobMutation = { printingJob: { id: string } | null };

export type CreateRescheduleActionMutationVariables = Exact<{
  teacherId: string;
  type: Types.Reschedule_Action_Types_Enum;
  data: object;
  status?: Types.Reschedule_Action_Statuses_Enum | null | undefined;
}>;


export type CreateRescheduleActionMutation = { rescheduleAction: { id: string, type: Types.Reschedule_Action_Types_Enum, status: Types.Reschedule_Action_Statuses_Enum, data: object, created: string, updated: string } | null };

export type CreateStudentMutationVariables = Exact<{
  teacherId: string;
  name: string;
  schoolYear?: Types.School_Year_Enum | null | undefined;
  picture?: string | null | undefined;
}>;


export type CreateStudentMutation = { student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null } | null };

export type CreateStudentAssignmentMutationVariables = Exact<{
  studentAssignment: Types.Student_Assignments_Insert_Input;
}>;


export type CreateStudentAssignmentMutation = { studentAssignment: { pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } } | null };

export type CreateSubmissionsMutationVariables = Exact<{
  submissions: Array<Types.Files_Insert_Input> | Types.Files_Insert_Input;
}>;


export type CreateSubmissionsMutation = { submissions: { returning: Array<{ id: string, url: string, size: number, studentAssignmentId: string | null }> } | null };

export type CreateThemeMutationVariables = Exact<{
  object: Types.Themes_Insert_Input;
}>;


export type CreateThemeMutation = { insert_themes_one: { id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null } | null };

export type DeleteAssignmentMutationVariables = Exact<{
  assignmentId: string;
  includeStudentData?: boolean | null | undefined;
}>;


export type DeleteAssignmentMutation = { assignment: { courseId: string, id: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null } | null };

export type DeleteAssignmentTypeWeightsMutationVariables = Exact<{
  courseId: string;
}>;


export type DeleteAssignmentTypeWeightsMutation = { assignmentTypeWeight: { returning: Array<{ id: string }> } | null };

export type DeleteAssignmentTypeWeightsByIdsMutationVariables = Exact<{
  assignmentTypeWeightsIds?: Array<string> | string | null | undefined;
}>;


export type DeleteAssignmentTypeWeightsByIdsMutation = { assignmentTypeWeights: { returning: Array<{ id: string }> } | null };

export type DeleteAssignmentsMutationVariables = Exact<{
  assignmentIds?: Array<string> | string | null | undefined;
}>;


export type DeleteAssignmentsMutation = { assignments: { returning: Array<{ id: string }> } | null };

export type DeleteCommentMutationVariables = Exact<{
  commentId: string;
}>;


export type DeleteCommentMutation = { comment: { id: string } | null };

export type DeleteCourseMutationVariables = Exact<{
  courseId: string;
}>;


export type DeleteCourseMutation = { course: { id: string } | null };

export type DeleteCourseShareLinkMutationVariables = Exact<{
  id: string;
}>;


export type DeleteCourseShareLinkMutation = { delete_course_share_link: { id: string } | null };

export type DeleteCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentTypeId: string;
}>;


export type DeleteCustomAssignmentTypeMutation = { customAssignmentType: { id: string } | null };

export type DeleteEventMutationVariables = Exact<{
  eventId: string;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type DeleteEventMutation = { event: { id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null }> } | null };

export type DeleteFileMutationVariables = Exact<{
  fileId: string;
}>;


export type DeleteFileMutation = { file: { id: string, size: number, parrotRequestId: string | null } | null };

export type DeleteOrganizationCodeMutationVariables = Exact<{
  id: string;
}>;


export type DeleteOrganizationCodeMutation = { delete_organization_code: { id: string } | null };

export type DeleteOrganizationCourseGroupMutationVariables = Exact<{
  id: string;
}>;


export type DeleteOrganizationCourseGroupMutation = { organizationCourseGroup: { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean } | null };

export type DeleteParrotRequestMutationVariables = Exact<{
  requestId: string;
  customerId: string;
  parrotCreditsToAdd: number;
}>;


export type DeleteParrotRequestMutation = { parrotRequest: { id: string } | null, customer: { id: string, parrotCredits: number } | null };

export type DeleteStudentMutationVariables = Exact<{
  studentId: string;
}>;


export type DeleteStudentMutation = { student: { id: string } | null };

export type DeleteStudentAccountMutationVariables = Exact<{
  studentAccountId: string;
}>;


export type DeleteStudentAccountMutation = { studentAccount: { id: string } | null };

export type DeleteStudentAssignmentMutationVariables = Exact<{
  studentAssignmentId: string;
}>;


export type DeleteStudentAssignmentMutation = { studentAssignment: { id: string } | null };

export type DeleteStudentCourseMutationVariables = Exact<{
  studentCourseId: string;
}>;


export type DeleteStudentCourseMutation = { studentCourse: { id: string } | null };

export type DeleteThemeMutationVariables = Exact<{
  themeId: string;
}>;


export type DeleteThemeMutation = { delete_themes_by_pk: { id: string } | null };

export type EnrollStudentInCourseMutationVariables = Exact<{
  studentId: string;
  courseId: string;
  start: string;
  end: string;
  daysOfTheWeek: object;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type EnrollStudentInCourseMutation = { studentCourse: { id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseDayOffsets: object | null, courseSnapshot: object | null, dailySortOrder: object, studentId: string, courseId: string | null, student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> } | null };

export type EnrollStudentInCoursesMutationVariables = Exact<{
  studentCourses: Array<Types.Student_Courses_Insert_Input> | Types.Student_Courses_Insert_Input;
}>;


export type EnrollStudentInCoursesMutation = { studentCourses: { returning: Array<{ id: string }> } | null };

export type RevokeOrganizationCodeMutationVariables = Exact<{
  organizationCodeId: string;
  teacherId: string;
  organizationId: string;
}>;


export type RevokeOrganizationCodeMutation = { delete_organization_code: { id: string } | null, update_customers: { returning: Array<{ id: string, subscriptionStatus: string | null, organizationSubscriptionExpiration: string | null }> } | null, update_user_settings: { affected_rows: number } | null, update_teacher: { id: string, organizationId: string | null } | null, delete_organization_course_groups_teachers: { returning: Array<{ id: string }> } | null };

export type SetCourseArchiveStatusMutationVariables = Exact<{
  courseId: string;
  archived: boolean;
}>;


export type SetCourseArchiveStatusMutation = { course: { id: string, archived: boolean, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, subjects: object | null, labels: object | null, defaultDaysOfTheWeek: object | null, assignments: Array<{ id: string, day: number | null, week: number | null }> } | null };

export type SetPrimaryThemeMutationVariables = Exact<{
  organizationId: string;
  themeId: string;
}>;


export type SetPrimaryThemeMutation = { setNew: { id: string, isPrimary: boolean } | null, clearExisting: { affected_rows: number } | null };

export type SetTeacherHasDemoDataMutationVariables = Exact<{
  teacherId: string;
}>;


export type SetTeacherHasDemoDataMutation = { update_teacher: { id: string, needsDemoData: boolean } | null };

export type UnscheduleCourseAssignmentsMutationVariables = Exact<{
  assignments: Array<Types.Assignments_Insert_Input> | Types.Assignments_Insert_Input;
}>;


export type UnscheduleCourseAssignmentsMutation = { insert_assignments: { returning: Array<{ id: string, day: number | null, week: number | null }> } | null };

export type UnscheduleCourseAndStudentCourseAssignmentsMutationVariables = Exact<{
  assignments: Array<Types.Assignments_Insert_Input> | Types.Assignments_Insert_Input;
  courseId: string;
  maxDay: number;
  maxWeek: number;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
  studentCourses: Array<Types.Student_Courses_Insert_Input> | Types.Student_Courses_Insert_Input;
}>;


export type UnscheduleCourseAndStudentCourseAssignmentsMutation = { update_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null, courseDayOffset: number | null }> } | null, insert_assignments: { returning: Array<{ id: string, day: number | null, week: number | null }> } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null }> } | null, insert_student_courses: { returning: Array<{ id: string, courseDayOffsets: object | null, daysOfTheWeek: object }> } | null };

export type UpdateAssignmentMutationVariables = Exact<{
  assignmentId: string;
  name: string;
  description?: string | null | undefined;
  teachersNote?: string | null | undefined;
  duration: number;
  graded: boolean;
  day?: number | null | undefined;
  week?: number | null | undefined;
  customAssignmentTypeId?: string | null | undefined;
  includeStudentData?: boolean | null | undefined;
}>;


export type UpdateAssignmentMutation = { assignment: { courseId: string, id: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, studentAssignments?: Array<{ pointsEarned: number | null, id: string, status: Types.Student_Assignment_Status_Enum, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }>, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null } | null };

export type UpdateAssignmentDayWeekMutationVariables = Exact<{
  assignments: Array<Types.Assignments_Insert_Input> | Types.Assignments_Insert_Input;
  includeStudentData?: boolean | null | undefined;
}>;


export type UpdateAssignmentDayWeekMutation = { insert_assignments: { returning: Array<{ id: string, day: number | null, week: number | null, studentAssignments?: Array<{ id: string, student: { id: string } }> }> } | null };

export type UpdateCourseMutationVariables = Exact<{
  courseId: string;
  name?: string | null | undefined;
  subjects?: object | null | undefined;
  labels?: object | null | undefined;
  gradeYears?: object | null | undefined;
  numberOfWeeks?: number | null | undefined;
  numberOfDaysPerWeek?: number | null | undefined;
  defaultDaysOfTheWeek?: object | null | undefined;
  description?: string | null | undefined;
  introduction?: string | null | undefined;
  gradingStyle: Types.Grading_Style_Enum;
  credits?: number | null | undefined;
  color: string;
  useAssignmentTypeWeights?: boolean | null | undefined;
  assignmentTypeWeights: Array<Types.Assignment_Type_Weights_Insert_Input> | Types.Assignment_Type_Weights_Insert_Input;
  organizationCourseGroupsToAdd: Array<Types.Organization_Course_Groups_Courses_Insert_Input> | Types.Organization_Course_Groups_Courses_Insert_Input;
  organizationCourseGroupIdsToRemove?: Array<string> | string | null | undefined;
  isOrgAdmin: boolean;
}>;


export type UpdateCourseMutation = { delete_organization_course_groups_courses?: { returning: Array<{ id: string }> } | null, insert_organization_course_groups_courses?: { returning: Array<{ id: string, organizationCourseGroup: { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean } }> } | null, update_course: { id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, description: string | null, introduction: string | null, gradingStyle: Types.Grading_Style_Enum, credits: number | null, color: string, useAssignmentTypeWeights: boolean | null, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean } }> } | null, insert_assignment_type_weights: { returning: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, course: { id: string }, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type UpdateCoursePictureMutationVariables = Exact<{
  courseId: string;
  picture?: string | null | undefined;
}>;


export type UpdateCoursePictureMutation = { update_course: { id: string, picture: string | null } | null };

export type UpdateCustomAssignmentTypeMutationVariables = Exact<{
  customAssignmentTypeId: string;
  name: string;
  color: string;
  hidden: boolean;
}>;


export type UpdateCustomAssignmentTypeMutation = { customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null };

export type UpdateCustomAssignmentTypesSortOrderMutationVariables = Exact<{
  updates: Array<Types.Custom_Assignment_Types_Updates> | Types.Custom_Assignment_Types_Updates;
}>;


export type UpdateCustomAssignmentTypesSortOrderMutation = { update_custom_assignment_types_many: Array<{ __typename: 'custom_assignment_types_mutation_response', affected_rows: number, returning: Array<{ __typename: 'custom_assignment_types', id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean }> } | null> | null };

export type UpdateOrganizationAdminMutationVariables = Exact<{
  organizationAdminId: string;
  email: string;
}>;


export type UpdateOrganizationAdminMutation = { update_organization_admin: { id: string, email: string, organization: { icon: string | null, id: string, name: string, supportLink: string | null } } | null };

export type UpdateOrganizationAllowDefaultSyllabirdThemesMutationVariables = Exact<{
  organizationId: string;
  allowDefaultSyllabirdThemes: boolean;
}>;


export type UpdateOrganizationAllowDefaultSyllabirdThemesMutation = { update_organization: { id: string, allowDefaultSyllabirdThemes: boolean } | null };

export type UpdateOrganizationCourseGroupMutationVariables = Exact<{
  id: string;
  name: string;
  description?: string | null | undefined;
  releaseDate?: string | null | undefined;
  expirationDate?: string | null | undefined;
  public?: boolean | null | undefined;
  default?: boolean | null | undefined;
}>;


export type UpdateOrganizationCourseGroupMutation = { organizationCourseGroup: { public: boolean, id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean } | null };

export type UpdateOrganizationMemberCodeMutationVariables = Exact<{
  codeId: string;
  originalUserEmail?: string | null | undefined;
  subscriptionExpiration?: string | null | undefined;
  organizationCourseGroupsToAdd: Array<Types.Organization_Course_Groups_Organization_Codes_Insert_Input> | Types.Organization_Course_Groups_Organization_Codes_Insert_Input;
  organizationCourseGroupsToRemove: Array<string> | string;
}>;


export type UpdateOrganizationMemberCodeMutation = { update_organization_code: { id: string, originalUserEmail: string | null, subscriptionExpiration: string | null } | null, delete_organization_course_groups_organization_codes: { returning: Array<{ id: string }> } | null, insert_organization_course_groups_organization_codes: { returning: Array<{ id: string }> } | null };

export type UpdateOrganizationMemberTeacherMutationVariables = Exact<{
  codeId: string;
  teacherId: string;
  originalUserEmail?: string | null | undefined;
  subscriptionExpiration?: string | null | undefined;
  organizationCourseGroupsToAdd: Array<Types.Organization_Course_Groups_Teachers_Insert_Input> | Types.Organization_Course_Groups_Teachers_Insert_Input;
  organizationCourseGroupsToRemove: Array<string> | string;
  subscriptionStatus: string;
}>;


export type UpdateOrganizationMemberTeacherMutation = { update_organization_code: { id: string, originalUserEmail: string | null, subscriptionExpiration: string | null } | null, update_customers: { returning: Array<{ id: string, teacherId: string, organizationSubscriptionExpiration: string | null }> } | null, delete_organization_course_groups_teachers: { returning: Array<{ id: string }> } | null, insert_organization_course_groups_teachers: { returning: Array<{ id: string }> } | null };

export type UpdateParrotRequestMutationVariables = Exact<{
  requestId: string;
  customerId: string;
  startWeek: number;
  endWeek: number;
  userNotes?: string | null | undefined;
  parrotCreditsDifference: number;
}>;


export type UpdateParrotRequestMutation = { update_parrot_request: { id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } } | null, update_customer: { id: string, parrotCredits: number } | null };

export type SetParrotRequestStatusMutationVariables = Exact<{
  requestId: string;
  status: Types.Parrot_Request_Status_Enum;
}>;


export type SetParrotRequestStatusMutation = { parrotRequest: { id: string, status: Types.Parrot_Request_Status_Enum } | null };

export type CompleteParrotRequestMutationVariables = Exact<{
  requestId: string;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type CompleteParrotRequestMutation = { parrotRequest: { id: string, status: Types.Parrot_Request_Status_Enum } | null, update_assignments: { returning: Array<{ id: string, visible: boolean }> } | null, insert_student_assignments: { returning: Array<{ id: string }> } | null };

export type ReopenParrotRequestMutationVariables = Exact<{
  requestId: string;
}>;


export type ReopenParrotRequestMutation = { parrotRequest: { id: string, status: Types.Parrot_Request_Status_Enum } | null, update_assignments: { returning: Array<{ id: string, visible: boolean }> } | null, deletedStudentAssignments: { returning: Array<{ id: string }> } | null };

export type ClaimParrotRequestMutationVariables = Exact<{
  requestId: string;
  claimerId: string;
}>;


export type ClaimParrotRequestMutation = { parrotRequest: { claimerId: string | null, id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { numberOfDaysPerWeek: number, id: string, name: string, color: string, numberOfWeeks: number, assignments: Array<{ id: string, day: number | null, week: number | null, duration: number }>, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } } | null };

export type UpdateRescheduleActionMutationVariables = Exact<{
  id: string;
  status?: Types.Reschedule_Action_Statuses_Enum | null | undefined;
  data?: object | null | undefined;
}>;


export type UpdateRescheduleActionMutation = { rescheduleAction: { id: string, type: Types.Reschedule_Action_Types_Enum, status: Types.Reschedule_Action_Statuses_Enum, data: object, created: string, updated: string } | null };

export type UpdateStudentMutationVariables = Exact<{
  studentId: string;
  name: string;
  schoolYear?: Types.School_Year_Enum | null | undefined;
}>;


export type UpdateStudentMutation = { update_student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null } | null };

export type UpdateStudentAccountMutationVariables = Exact<{
  studentAccountId: string;
  email: string;
  name?: string | null | undefined;
  picture?: string | null | undefined;
}>;


export type UpdateStudentAccountMutation = { update_student_account: { id: string, email: string, name: string | null, picture: string | null } | null };

export type UpdateStudentAssignmentDatesMutationVariables = Exact<{
  studentAssignmentId: string;
  start?: string | null | undefined;
  end?: string | null | undefined;
  courseDayOffset?: number | null | undefined;
}>;


export type UpdateStudentAssignmentDatesMutation = { update_student_assignment: { id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } } | null };

export type UpdateStudentAssignmentDatesOnRescheduleMutationVariables = Exact<{
  studentAssignmentId: string;
  start: string;
  end: string;
  freeForm?: boolean | null | undefined;
  courseDayOffset?: number | null | undefined;
  displayOrder?: number | null | undefined;
  endDisplayOrder?: number | null | undefined;
}>;


export type UpdateStudentAssignmentDatesOnRescheduleMutation = { update_student_assignment: { displayOrder: number | null, endDisplayOrder: number | null, id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } } | null };

export type UpdateStudentAssignmentDisplayOrdersMutationVariables = Exact<{
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type UpdateStudentAssignmentDisplayOrdersMutation = { insert_student_assignments: { returning: Array<{ id: string, displayOrder: number | null, endDisplayOrder: number | null }> } | null };

export type UpdateStudentAssignmentGradeMutationVariables = Exact<{
  studentAssignmentId: string;
  pointsEarned: number;
  pointsAvailable: number;
}>;


export type UpdateStudentAssignmentGradeMutation = { update_student_assignment: { id: string, pointsEarned: number | null, pointsAvailable: number | null } | null };

export type UpdateStudentAssignmentStatusMutationVariables = Exact<{
  studentAssignmentId: string;
  status: Types.Student_Assignment_Status_Enum;
  completed?: string | null | undefined;
}>;


export type UpdateStudentAssignmentStatusMutation = { update_student_assignment: { __typename: 'student_assignments', id: string, status: Types.Student_Assignment_Status_Enum, completed: string | null } | null };

export type UpdateStudentAssignmentsStatusMutationVariables = Exact<{
  studentAssignmentIds: Array<string> | string;
  status: Types.Student_Assignment_Status_Enum;
  completed?: string | null | undefined;
}>;


export type UpdateStudentAssignmentsStatusMutation = { update_student_assignments: { returning: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, completed: string | null }> } | null };

export type UpdateStudentCourseDayOffsetsMutationVariables = Exact<{
  studentCourseId: string;
  studentCourseDayOffsets: object;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type UpdateStudentCourseDayOffsetsMutation = { update_student_course: { id: string, courseDayOffsets: object | null } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null, courseDayOffset: number | null }> } | null };

export type UpdateStudentCourseScheduleMutationVariables = Exact<{
  studentCourseId: string;
  daysOfTheWeek: object;
  start: string;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type UpdateStudentCourseScheduleMutation = { update_student_course: { id: string, daysOfTheWeek: object, start: string } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null }> } | null };

export type UpdateStudentCoursesDailyOrderMutationVariables = Exact<{
  studentCourses: Array<Types.Student_Courses_Insert_Input> | Types.Student_Courses_Insert_Input;
}>;


export type UpdateStudentCoursesDailyOrderMutation = { insert_student_courses: { returning: Array<{ id: string, dailySortOrder: object }> } | null };

export type UpdateStudentPictureMutationVariables = Exact<{
  studentId: string;
  picture?: string | null | undefined;
}>;


export type UpdateStudentPictureMutation = { update_student: { id: string, picture: string | null } | null };

export type UpdateTeacherMutationVariables = Exact<{
  teacherId: string;
  email: string;
  name?: string | null | undefined;
  picture?: string | null | undefined;
}>;


export type UpdateTeacherMutation = { update_teacher: { id: string, email: string | null, name: string | null, picture: string | null, organization: { id: string, name: string, supportLink: string | null } | null } | null };

export type UpdateThemeMutationVariables = Exact<{
  themeId: string;
  name?: string | null | undefined;
  visible?: boolean | null | undefined;
  headerBackground?: string | null | undefined;
  headerForeground?: string | null | undefined;
  headerForegroundActive?: string | null | undefined;
  primary?: string | null | undefined;
  primaryContrast?: string | null | undefined;
  appBackground?: string | null | undefined;
  contentBackground?: string | null | undefined;
  faintBorder?: string | null | undefined;
  mediumBorder?: string | null | undefined;
  elementBorder?: string | null | undefined;
  elementBackground?: string | null | undefined;
  surfaceBorder?: string | null | undefined;
  colorPalette?: object | null | undefined;
  contentContrast?: string | null | undefined;
  contentPrimary?: string | null | undefined;
  contentSecondary?: string | null | undefined;
  contentTertiary?: string | null | undefined;
  positive?: string | null | undefined;
  negative?: string | null | undefined;
  info?: string | null | undefined;
  vacation?: string | null | undefined;
  logoUrl?: string | null | undefined;
  portalIconUrl?: string | null | undefined;
  rescheduleNormal?: string | null | undefined;
  rescheduleShift?: string | null | undefined;
  rescheduleFreeform?: string | null | undefined;
  rescheduleSetEnd?: string | null | undefined;
}>;


export type UpdateThemeMutation = { update_themes_by_pk: { id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null } | null };

export type UpdateVacationMutationVariables = Exact<{
  eventId: string;
  start: string;
  end: string;
  name?: string | null | undefined;
  studentEvents: Array<Types.Student_Events_Insert_Input> | Types.Student_Events_Insert_Input;
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
  ignoredCourses: Array<Types.Event_Ignored_Courses_Insert_Input> | Types.Event_Ignored_Courses_Insert_Input;
}>;


export type UpdateVacationMutation = { update_event: { id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> } | null, deletedStudentEvents: { returning: Array<{ id: string }> } | null, deletedIgnoredCourses: { returning: Array<{ courseId: string }> } | null, insert_event_ignored_courses: { returning: Array<{ courseId: string }> } | null, newStudentEvents: { returning: Array<{ id: string, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, event: { id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> } }> } | null, insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null }> } | null };

export type UpsertStudentAssignmentsDatesMutationVariables = Exact<{
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type UpsertStudentAssignmentsDatesMutation = { insert_student_assignments: { returning: Array<{ id: string, start: string | null, end: string | null, courseDayOffset: number | null }> } | null };

export type UpsertStudentAssignmentsGradingStylesMutationVariables = Exact<{
  studentAssignments: Array<Types.Student_Assignments_Insert_Input> | Types.Student_Assignments_Insert_Input;
}>;


export type UpsertStudentAssignmentsGradingStylesMutation = { insert_student_assignments: { returning: Array<{ id: string, pointsEarned: number | null, pointsAvailable: number | null }> } | null };

export type UpsertTranscriptDraftMutationVariables = Exact<{
  studentId: string;
  teacherId: string;
  draftData: object;
}>;


export type UpsertTranscriptDraftMutation = { transcriptDraft: { id: string, studentId: string, teacherId: string, draftData: object, updated: string } | null };

export type UpsertTeacherSettingsMutationVariables = Exact<{
  teacherId: string;
  userSettings: Types.User_Settings_Insert_Input;
}>;


export type UpsertTeacherSettingsMutation = { insert_teacher: { id: string, userSettings: { id: string, showEmptyAssignmentDays: boolean, weekStartDay: number, selectedThemeId: string | null } | null } | null };

export type UpsertStudentSettingsMutationVariables = Exact<{
  userId: string;
  userSettings: Types.User_Settings_Insert_Input;
}>;


export type UpsertStudentSettingsMutation = { insert_student_account: { id: string, userSettings: { id: string, showEmptyAssignmentDays: boolean, weekStartDay: number, selectedThemeId: string | null } | null } | null };

export type GetActiveCourseStudentsQueryVariables = Exact<{
  courseId: string;
}>;


export type GetActiveCourseStudentsQuery = { course: { id: string, studentCourses: Array<{ id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseDayOffsets: object | null, courseSnapshot: object | null, student: { id: string, name: string, picture: string | null, schoolYear: Types.School_Year_Enum | null }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> }> } | null };

export type GetActiveCourseOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCourseOptionsQuery = { courses: Array<{ id: string, name: string, color: string, subjects: object | null, labels: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null }> };

export type GetActiveStudentCoursesQueryVariables = Exact<{
  studentId: string;
}>;


export type GetActiveStudentCoursesQuery = { student: { id: string, name: string, picture: string | null, studentCourses: Array<{ id: string, start: string, end: string, daysOfTheWeek: object, status: Types.Student_Course_Status_Enum, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> }>, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> } | null };

export type GetActiveStudentCoursesForTranscriptQueryVariables = Exact<{
  studentId: string;
}>;


export type GetActiveStudentCoursesForTranscriptQuery = { student: { id: string, studentCourses: Array<{ id: string, courseSnapshot: object | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }>, course: { __typename: 'courses', id: string, name: string, color: string, credits: number | null, gradingStyle: Types.Grading_Style_Enum, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null }> } | null };

export type GetAllActiveStudentCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveStudentCoursesQuery = { studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, course: { id: string, numberOfWeeks: number, numberOfDaysPerWeek: number } | null, student: { id: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> } }> };

export type GetAllEventsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEventsInfoQuery = { events: Array<{ id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> }> };

export type GetAllParrotRequestsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllParrotRequestsInfoQuery = { parrotRequests: Array<{ id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } }> };

export type GetAllParrotRequestsByClaimerIdQueryVariables = Exact<{
  claimerId: string;
}>;


export type GetAllParrotRequestsByClaimerIdQuery = { parrotRequests: Array<{ id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, course: { id: string, name: string, color: string, numberOfWeeks: number, assignments: Array<{ id: string, day: number | null, week: number | null, duration: number }>, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> }, files: Array<{ id: string, url: string }>, teacher: { id: string, email: string | null } }> };

export type GetAllStudentsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStudentsInfoQuery = { students: Array<{ id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentCourses: Array<{ id: string, status: Types.Student_Course_Status_Enum }>, studentAccount: { id: string, email: string } | null }> };

export type GetAssignmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssignmentTypesQuery = { assignmentTypes: Array<{ value: string }> };

export type GetAttendanceDayCountQueryVariables = Exact<{
  studentId: string;
}>;


export type GetAttendanceDayCountQuery = { student_assignments_aggregate: { aggregate: { count: number } | null } };

export type GetCalendarMonthDataQueryVariables = Exact<{
  startDay: string;
  endDay: string;
}>;


export type GetCalendarMonthDataQuery = { courses: Array<{ id: string, name: string, color: string, subjects: object | null, studentCourses: Array<{ id: string, dailySortOrder: object, student: { id: string }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> }>, events: Array<{ id: string, name: string | null, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string } }> }> };

export type GetCalendarStudentAssignmentsQueryVariables = Exact<{
  day: string;
}>;


export type GetCalendarStudentAssignmentsQuery = { courses: Array<{ id: string, name: string, color: string, subjects: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> }> };

export type GetStudentOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentOptionsQuery = { students: Array<{ id: string, name: string, picture: string | null }> };

export type GetCalendarVacationsQueryVariables = Exact<{
  day: string;
}>;


export type GetCalendarVacationsQuery = { events: Array<{ id: string, name: string | null, ignoredCourses: Array<{ course: { id: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string } }> }> };

export type GetCalendarWeekDataQueryVariables = Exact<{
  days: Array<string> | string;
  startDay: string;
  endDay: string;
}>;


export type GetCalendarWeekDataQuery = { courses: Array<{ id: string, name: string, color: string, subjects: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null }, studentAssignments: Array<{ id: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, displayOrder: number | null, endDisplayOrder: number | null, courseDayOffset: number | null, student: { id: string, name: string, picture: string | null }, assignment: { id: string, name: string, description: string | null, week: number | null, day: number | null, graded: boolean, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null } }> }> }>, events: Array<{ id: string, name: string | null, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string } }> }> };

export type GetCompletedCourseStudentsQueryVariables = Exact<{
  courseId: string;
}>;


export type GetCompletedCourseStudentsQuery = { studentCourses: Array<{ id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseSnapshot: object | null, student: { id: string, name: string, picture: string | null } }> };

export type GetCompletedStudentCourseInfoQueryVariables = Exact<{
  studentCourseId: string;
}>;


export type GetCompletedStudentCourseInfoQuery = { studentCourse: { id: string, course: { __typename: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, color: string, description: string | null, teacherId: string | null, credits: number | null, gradingStyle: Types.Grading_Style_Enum, defaultDaysOfTheWeek: object | null, subjects: object | null, labels: object | null, gradeYears: object | null, introduction: string | null, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, completed: string | null, submissions: Array<{ id: string, url: string }>, assignment: { id: string, name: string, week: number | null, day: number | null, duration: number, graded: boolean, description: string | null, teachersNote: string | null, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }> }, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> }> } | null };

export type GetCompletedStudentCoursesQueryVariables = Exact<{
  studentId: string;
}>;


export type GetCompletedStudentCoursesQuery = { student: { id: string, name: string, picture: string | null, studentCourses: Array<{ id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseSnapshot: object | null, student: { id: string, name: string, picture: string | null } }> } | null };

export type GetCompletedStudentCoursesForYearQueryVariables = Exact<{
  studentId: string;
  calendarYears: Array<string> | string;
}>;


export type GetCompletedStudentCoursesForYearQuery = { student: { id: string, studentCourses: Array<{ id: string, calendarYear: string | null, courseSnapshot: object | null }> } | null };

export type GetCourseAssignmentsScheduleQueryVariables = Exact<{
  courseId: string;
}>;


export type GetCourseAssignmentsScheduleQuery = { course: { id: string, assignments: Array<{ id: string, day: number | null, week: number | null, duration: number }> } | null };

export type GetCoursesAssignmentsScheduleQueryVariables = Exact<{
  courseIds: Array<string> | string;
}>;


export type GetCoursesAssignmentsScheduleQuery = { courses: Array<{ id: string, numberOfDaysPerWeek: number, numberOfWeeks: number, assignments: Array<{ id: string, day: number | null, week: number | null, duration: number }> }> };

export type GetCourseCardsQueryVariables = Exact<{
  includeStudentData?: boolean | null | undefined;
  includeOrganizationCourseGroups?: boolean | null | undefined;
}>;


export type GetCourseCardsQuery = { courses: Array<{ id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, color: string, picture: string | null, archived: boolean, description: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, importedFromOrganizationId: string | null, copiedFromCourseId: string | null, studentCourses?: Array<{ id: string, student: { id: string, name: string, picture: string | null } }>, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string } }> }> };

export type GetCourseInfoQueryVariables = Exact<{
  courseId: string;
  includeStudentData?: boolean | null | undefined;
  includeOrganizationCourseGroups?: boolean | null | undefined;
}>;


export type GetCourseInfoQuery = { course: { __typename: 'courses', id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, color: string, picture: string | null, subjects: object | null, labels: object | null, gradeYears: object | null, description: string | null, introduction: string | null, gradingStyle: Types.Grading_Style_Enum, credits: number | null, archived: boolean, useAssignmentTypeWeights: boolean | null, assignments: Array<{ id: string, day: number | null, week: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType: { id: string } | null }>, studentCourses?: Array<{ id: string, studentId: string, status: Types.Student_Course_Status_Enum, start: string, end: string, courseId: string | null, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null } }>, organizationCourseGroups?: Array<{ organizationCourseGroup: { id: string, name: string } }>, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type GetCourseLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseLabelsQuery = { courses: Array<{ id: string, labels: object | null }> };

export type GetCoursePlanCardQueryVariables = Exact<{
  courseId: string;
}>;


export type GetCoursePlanCardQuery = { course: { id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, day: number | null, week: number | null }> } | null };

export type GetCoursePlanCardsQueryVariables = Exact<{
  includeStudentData?: boolean | null | undefined;
}>;


export type GetCoursePlanCardsQuery = { courses: Array<{ id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, day: number | null, week: number | null }>, studentCourses?: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> }> };

export type GetCoursePlanCardsFromParrotRequestsQueryVariables = Exact<{
  userId: string;
  includeStudentData?: boolean | null | undefined;
}>;


export type GetCoursePlanCardsFromParrotRequestsQuery = { parrotRequests: Array<{ id: string, status: Types.Parrot_Request_Status_Enum, course: { id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, day: number | null, week: number | null }>, studentCourses?: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> } }> };

export type GetCourseRescheduleInfoQueryVariables = Exact<{
  courseId: string;
  studentCourseIds?: Array<string> | string | null | undefined;
  includeStudentData?: boolean | null | undefined;
}>;


export type GetCourseRescheduleInfoQuery = { course: { id: string, assignments: Array<{ id: string, day: number | null, week: number | null, name: string, duration: number, graded: boolean, courseId: string, customAssignmentType: { id: string } | null }>, studentCourses?: Array<{ id: string, studentId: string, status: Types.Student_Course_Status_Enum, start: string, end: string, courseId: string | null, daysOfTheWeek: object, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, freeForm: boolean, start: string | null, end: string | null, status: Types.Student_Assignment_Status_Enum, assignmentId: string, studentId: string, studentCourseId: string, courseDayOffset: number | null }>, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> } }> } | null };

export type GetCourseShareLinksQueryVariables = Exact<{
  courseId: string;
}>;


export type GetCourseShareLinksQuery = { courseShareLinks: Array<{ id: string, code: string, label: string | null, public: boolean, maxUses: number | null, remainingUses: number | null }> };

export type GetCourseSubjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseSubjectsQuery = { courses: Array<{ id: string, subjects: object | null }> };

export type GetCoursesByAssignmentTypeQueryVariables = Exact<{
  customAssignmentTypeId: string;
}>;


export type GetCoursesByAssignmentTypeQuery = { courses: Array<{ id: string, assignmentTypeWeights: Array<{ id: string, customAssignmentTypeId: string | null }> }> };

export type GetCustomAssignmentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomAssignmentTypesQuery = { customAssignmentTypes: Array<{ id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean }> };

export type GetCustomerInfoQueryVariables = Exact<{
  teacherId: string;
}>;


export type GetCustomerInfoQuery = { teacher: { id: string, needsDemoData: boolean, customer: { id: string, subscriptionStatus: string | null, freeTrialEnd: string, planTier: Types.Plan_Tier_Enum, parrotCredits: number, extendedTrial: boolean } | null } | null };

export type GetCustomerInfoByStudentQueryVariables = Exact<{
  studentId: string;
}>;


export type GetCustomerInfoByStudentQuery = { student: { id: string, teachers: Array<{ teacher: { id: string, customer: { id: string, subscriptionStatus: string | null, planTier: Types.Plan_Tier_Enum } | null } }> } | null };

export type GetEventsInfoQueryVariables = Exact<{
  studentIds?: Array<string> | string | null | undefined;
}>;


export type GetEventsInfoQuery = { events: Array<{ id: string, name: string | null, start: string, end: string, eventType: Types.Event_T_Enum, ignoredCourses: Array<{ course: { id: string, name: string } }>, studentEvents: Array<{ id: string, student: { id: string, name: string, picture: string | null } }> }> };

export type GetFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterOptionsQuery = { students: Array<{ id: string, name: string, picture: string | null }>, courses: Array<{ id: string, name: string, color: string, subjects: object | null, labels: object | null, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null }>, customAssignmentTypes: Array<{ id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean }> };

export type GetHomeStudentAssignmentsQueryVariables = Exact<{
  isStudent: boolean;
  dueDateBounds: Types.Date_Comparison_Exp;
  startBounds: Types.Date_Comparison_Exp;
  completedTodayFilter: Types.Student_Assignments_Bool_Exp;
}>;


export type GetHomeStudentAssignmentsQuery = { studentAssignments: Array<{ id: string, start: string | null, end: string | null, pointsEarned: number | null, pointsAvailable: number | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, courseDayOffset: number | null, assignment: { id: string, name: string, week: number | null, day: number | null, description: string | null, teachersNote?: string | null, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }>, course: { id: string, name: string, color: string, subjects: object | null } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, start: string, course: { id: string, gradingStyle: Types.Grading_Style_Enum } | null }, submissions: Array<{ id: string, url: string }>, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> }>, studentAssignmentsForGrading: Array<{ id: string, start: string | null, end: string | null, pointsEarned: number | null, pointsAvailable: number | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, courseDayOffset: number | null, assignment: { id: string, name: string, week: number | null, day: number | null, description: string | null, teachersNote?: string | null, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }>, course: { id: string, name: string, color: string, subjects: object | null } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, start: string, course: { id: string, gradingStyle: Types.Grading_Style_Enum } | null }, submissions: Array<{ id: string, url: string }>, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> }> };

export type GetOrganizationAdminInfoQueryVariables = Exact<{
  organizationAdminId: string;
}>;


export type GetOrganizationAdminInfoQuery = { organizationAdmin: { id: string, email: string, organization: { icon: string | null, id: string, name: string, supportLink: string | null } } | null };

export type GetOrganizationCourseCardsQueryVariables = Exact<{
  organizationId: string;
}>;


export type GetOrganizationCourseCardsQuery = { organizationCourses: Array<{ id: string, name: string, subjects: object | null, labels: object | null, gradeYears: object | null, color: string, picture: string | null, archived: boolean, description: string | null, numberOfWeeks: number, numberOfDaysPerWeek: number, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }> }> };

export type GetOrganizationCourseGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationCourseGroupsQuery = { organizationCourseGroups: Array<{ id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, default: boolean }> };

export type GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationCourseGroupsWithCoursesAndMembersQuery = { organizationCourseGroups: Array<{ id: string, name: string, description: string | null, releaseDate: string | null, expirationDate: string | null, public: boolean, default: boolean, courses: Array<{ course: { id: string } }>, teachers: Array<{ teacher: { id: string } }>, organizationCodes: Array<{ organizationCode: { id: string } }> }> };

export type GetOrganizationCourseInfoQueryVariables = Exact<{
  organizationId: string;
  courseId: string;
}>;


export type GetOrganizationCourseInfoQuery = { organizationCourse: { id: string, name: string, numberOfWeeks: number, numberOfDaysPerWeek: number, defaultDaysOfTheWeek: object | null, color: string, picture: string | null, subjects: object | null, labels: object | null, gradeYears: object | null, description: string | null, introduction: string | null, gradingStyle: string, credits: number | null, archived: boolean, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: string | null, sortOrder: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }>, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }> } | null };

export type GetOrganizationCourseLabelsQueryVariables = Exact<{
  organizationId: string;
}>;


export type GetOrganizationCourseLabelsQuery = { organizationCourses: Array<{ id: string, labels: object | null }> };

export type GetOrganizationCourseSubjectsQueryVariables = Exact<{
  organizationId: string;
}>;


export type GetOrganizationCourseSubjectsQuery = { organizationCourses: Array<{ id: string, subjects: object | null }> };

export type GetOrganizationInfoQueryVariables = Exact<{
  organizationId: string;
}>;


export type GetOrganizationInfoQuery = { organization: { id: string, name: string, supportLink: string | null } | null };

export type GetOrganizationMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationMembersQuery = { organizationCodes: Array<{ id: string, code: string, originalUserEmail: string | null, subscriptionExpiration: string | null, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }>, teacher: { id: string, email: string | null, name: string | null, customer: { id: string, subscriptionStatus: string | null, organizationSubscriptionExpiration: string | null } | null, organizationCourseGroups: Array<{ organizationCourseGroup: { id: string, name: string } }> } | null }> };

export type GetOrganizationSeatUsageInfoQueryVariables = Exact<{
  adminId: string;
}>;


export type GetOrganizationSeatUsageInfoQuery = { organizationAdmin: { organization: { id: string, ignoredEmails: Array<string> | null, freeEmails: Array<string> | null, numberOfSeatsAvailable: number | null } } | null };

export type GetOrganizationThemeForOrganizationAdminQueryVariables = Exact<{
  organizationAdminId: string;
}>;


export type GetOrganizationThemeForOrganizationAdminQuery = { organizationAdmin: { id: string, organization: { id: string, themes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }> } } | null };

export type GetOrganizationThemeForStudentQueryVariables = Exact<{
  studentAccountId: string;
}>;


export type GetOrganizationThemeForStudentQuery = { studentAccount: { id: string, student: { id: string, teachers: Array<{ teacher: { id: string, organization: { id: string, themes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }> } | null } }> }, userSettings: { id: string, selectedTheme: { id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null } | null } | null } | null };

export type GetOrganizationThemeForTeacherQueryVariables = Exact<{
  teacherId: string;
}>;


export type GetOrganizationThemeForTeacherQuery = { teacher: { id: string, organization: { id: string, themes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }> } | null, userSettings: { id: string, selectedTheme: { id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null } | null } | null } | null };

export type GetOrganizationThemesQueryVariables = Exact<{
  organizationId: string;
}>;


export type GetOrganizationThemesQuery = { organization: { id: string, allowDefaultSyllabirdThemes: boolean, themes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }> } | null };

export type GetParrotRequestQueueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParrotRequestQueueQuery = { parrotRequests: Array<{ id: string, startWeek: number, endWeek: number, status: Types.Parrot_Request_Status_Enum, queuePosition: number | null, userNotes: string | null, created: string, teacher: { id: string, email: string | null }, course: { id: string, name: string, color: string, numberOfWeeks: number }, files: Array<{ id: string, url: string }> }> };

export type GetPlanningAssignmentQueryVariables = Exact<{
  assignmentId: string;
}>;


export type GetPlanningAssignmentQuery = { assignment: { id: string, studentAssignments: Array<{ pointsEarned: number | null, id: string, start: string | null, end: string | null, freeForm: boolean, courseDayOffset: number | null, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null } }> } | null };

export type GetPlanningCourseQueryVariables = Exact<{
  courseId: string;
}>;


export type GetPlanningCourseQuery = { course: { id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, courseId: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null }> } | null };

export type GetPlanningCourseForParrotQueryVariables = Exact<{
  courseId: string;
  parrotRequestId: string;
}>;


export type GetPlanningCourseForParrotQuery = { course: { id: string, name: string, color: string, numberOfWeeks: number, numberOfDaysPerWeek: number, assignments: Array<{ id: string, courseId: string, name: string, description: string | null, teachersNote: string | null, duration: number, graded: boolean, created: string, day: number | null, week: number | null, parrotRequestId: string | null, attachments: Array<{ id: string, url: string, size: number }>, customAssignmentType: { id: string, name: string, color: string } | null }> } | null };

export type GetPlanningCourseStudentCoursesQueryVariables = Exact<{
  courseId: string;
}>;


export type GetPlanningCourseStudentCoursesQuery = { course: { id: string, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, course: { id: string } | null }> } | null };

export type GetPlanningCourseAssignmentTypeWeightsQueryVariables = Exact<{
  courseId: string;
}>;


export type GetPlanningCourseAssignmentTypeWeightsQuery = { course: { __typename: 'courses', id: string, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null };

export type GetPreviousPrintingJobsQueryVariables = Exact<{
  printingJobType?: Types.Printing_Job_Type_Enum | null | undefined;
}>;


export type GetPreviousPrintingJobsQuery = { exports: Array<{ id: string, file: { id: string, url: string } | null }> };

export type GetQuotasUsageQueryVariables = Exact<{
  teacherId: string;
}>;


export type GetQuotasUsageQuery = { files: { aggregate: { sum: { size: number | null } | null } | null }, teacher: { id: string, customer: { id: string, parrotCredits: number } | null } | null };

export type GetRecentRescheduleActionsQueryVariables = Exact<{
  since: string;
}>;


export type GetRecentRescheduleActionsQuery = { rescheduleActions: Array<{ id: string, type: Types.Reschedule_Action_Types_Enum, status: Types.Reschedule_Action_Statuses_Enum, data: object, created: string, updated: string }> };

export type GetSelectableThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectableThemesQuery = { organizations: Array<{ id: string, allowDefaultSyllabirdThemes: boolean }>, syllabirdThemes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }>, organizationThemes: Array<{ id: string, name: string | null, isSyllabirdTheme: boolean, organizationId: string | null, visible: boolean, isPrimary: boolean, headerBackground: string | null, headerForeground: string | null, headerForegroundActive: string | null, primary: string | null, primaryContrast: string | null, appBackground: string | null, contentBackground: string | null, faintBorder: string | null, mediumBorder: string | null, elementBorder: string | null, elementBackground: string | null, surfaceBorder: string | null, colorPalette: object | null, contentContrast: string | null, contentPrimary: string | null, contentSecondary: string | null, contentTertiary: string | null, positive: string | null, negative: string | null, info: string | null, vacation: string | null, logoUrl: string | null, portalIconUrl: string | null, fontUrl: string | null, fontFamily: string | null, baseFontSize: number | null, rescheduleNormal: string | null, rescheduleShift: string | null, rescheduleFreeform: string | null, rescheduleSetEnd: string | null }> };

export type GetStorageUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStorageUsageQuery = { files: { aggregate: { sum: { size: number | null } | null } | null } };

export type GetStudentAccountInfoQueryVariables = Exact<{
  studentAccountId: string;
}>;


export type GetStudentAccountInfoQuery = { studentAccount: { id: string, email: string, name: string | null, picture: string | null, userSettings: { id: string, showEmptyAssignmentDays: boolean, weekStartDay: number, selectedThemeId: string | null } | null, student: { teachers: Array<{ teacher: { id: string, organization: { id: string, name: string, supportLink: string | null } | null } }> } } | null };

export type GetStudentAssignmentQueryVariables = Exact<{
  studentAssignmentId: string;
  isStudent: boolean;
}>;


export type GetStudentAssignmentQuery = { studentAssignment: { id: string, start: string | null, end: string | null, pointsEarned: number | null, pointsAvailable: number | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, courseDayOffset: number | null, assignment: { id: string, name: string, week: number | null, day: number | null, description: string | null, teachersNote?: string | null, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, attachments: Array<{ id: string, url: string }>, course: { id: string, name: string, color: string, subjects: object | null } }, student: { id: string, name: string, picture: string | null, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentCourse: { id: string, daysOfTheWeek: object, dailySortOrder: object, courseDayOffsets: object | null, start: string, course: { id: string, gradingStyle: Types.Grading_Style_Enum } | null }, submissions: Array<{ id: string, url: string }>, comments: Array<{ id: string, content: string, created: string, studentAccount: { id: string, name: string | null, picture: string | null } | null, teacher: { id: string, name: string | null, picture: string | null } | null, studentAssignment: { id: string } | null }> } | null };

export type GetStudentAssignmentsForRescheduleQueryVariables = Exact<{
  courseId: string;
  assignmentIds: Array<string> | string;
}>;


export type GetStudentAssignmentsForRescheduleQuery = { course: { id: string, studentCourses: Array<{ id: string, start: string, daysOfTheWeek: object, courseDayOffsets: object | null, student: { id: string, studentEvents: Array<{ id: string, event: { id: string, start: string, end: string, ignoredCourses: Array<{ course: { id: string } }> } }> }, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null }> }> } | null };

export type GetStudentCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentCardsQuery = { students: Array<{ id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null }> };

export type GetStudentCourseQueryVariables = Exact<{
  studentCourseId: string;
}>;


export type GetStudentCourseQuery = { studentCourse: { id: string, status: Types.Student_Course_Status_Enum, start: string, end: string, daysOfTheWeek: object, calendarYear: string | null, schoolYear: Types.School_Year_Enum | null, courseDayOffsets: object | null, courseSnapshot: object | null, student: { id: string, name: string, picture: string | null, schoolYear: Types.School_Year_Enum | null }, course: { __typename: 'courses', id: string, name: string, color: string, gradingStyle: Types.Grading_Style_Enum, numberOfDaysPerWeek: number, numberOfWeeks: number, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }> } | null };

export type GetStudentCourseToRescheduleForCourseShiftQueryVariables = Exact<{
  date: string;
  week: number;
  day: number;
  courseId: string;
  studentAssignmentId: string;
}>;


export type GetStudentCourseToRescheduleForCourseShiftQuery = { studentCourseToReschedule: { id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } }> } | null, studentCourseToReoffset: { id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } }> } | null };

export type GetStudentCoursesByIdsQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GetStudentCoursesByIdsQuery = { studentCourses: Array<{ id: string, courseSnapshot: object | null, studentAssignments: Array<{ id: string, status: Types.Student_Assignment_Status_Enum, pointsEarned: number | null, pointsAvailable: number | null, start: string | null, completed: string | null, studentId: string, assignmentId: string, end: string | null, freeForm: boolean, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, name: string, assignmentType: Types.Assignment_Type_Enum | null, graded: boolean, created: string, week: number | null, day: number | null, duration: number, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null, course: { id: string } } }>, course: { __typename: 'courses', id: string, name: string, color: string, credits: number | null, gradingStyle: Types.Grading_Style_Enum, useAssignmentTypeWeights: boolean | null, assignmentTypeWeights: Array<{ id: string, weight: number, assignmentType: Types.Assignment_Type_Enum | null, sortOrder: number | null, customAssignmentType: { id: string, name: string, color: string, created: string, sortOrder: number | null, hidden: boolean } | null }> } | null }> };

export type GetStudentCoursesToConvertGradingStyleQueryVariables = Exact<{
  courseId: string;
}>;


export type GetStudentCoursesToConvertGradingStyleQuery = { studentCourses: Array<{ id: string, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, pointsEarned: number | null, pointsAvailable: number | null }> }> };

export type GetStudentCoursesToRescheduleQueryVariables = Exact<{
  date: string;
  studentIds?: Array<string> | string | null | undefined;
}>;


export type GetStudentCoursesToRescheduleQuery = { studentCourses: Array<{ id: string, daysOfTheWeek: object, studentId: string, start: string, courseDayOffsets: object | null, studentAssignments: Array<{ id: string, studentId: string, assignmentId: string, start: string | null, end: string | null, freeForm: boolean, status: Types.Student_Assignment_Status_Enum, studentCourseId: string, courseDayOffset: number | null, assignment: { id: string, week: number | null, day: number | null, duration: number, course: { id: string } } }> }> };

export type GetStudentInfoQueryVariables = Exact<{
  studentId: string;
}>;


export type GetStudentInfoQuery = { student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null } | null };

export type GetStudentInfoForStudentAccountQueryVariables = Exact<{
  studentAccountId: string;
}>;


export type GetStudentInfoForStudentAccountQuery = { student_account: { student: { id: string, name: string, schoolYear: Types.School_Year_Enum | null, picture: string | null, studentAccount: { id: string, email: string } | null } } | null };

export type GetTeacherInfoQueryVariables = Exact<{
  teacherId: string;
}>;


export type GetTeacherInfoQuery = { teacher: { id: string, email: string | null, name: string | null, picture: string | null, userSettings: { id: string, showEmptyAssignmentDays: boolean, weekStartDay: number, selectedThemeId: string | null } | null, customer: { id: string, subscriptionStatus: string | null, freeTrialEnd: string, planTier: Types.Plan_Tier_Enum } | null, organization: { id: string, name: string, supportLink: string | null } | null } | null };

export type GetTranscriptDraftQueryVariables = Exact<{
  studentId: string;
  teacherId: string;
}>;


export type GetTranscriptDraftQuery = { transcriptDrafts: Array<{ id: string, studentId: string, teacherId: string, draftData: object, created: string, updated: string }> };

export type GetPrintingJobsByIdsSubscriptionVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GetPrintingJobsByIdsSubscription = { printingJobs: Array<{ id: string, teacherId: string | null, studentAccountId: string | null, status: Types.Printing_Job_Status_Enum, file: { id: string, url: string } | null }> };

export const PlanningAssignmentBaseFragmentDoc = gql`
    fragment PlanningAssignmentBase on assignments {
  id
  courseId
  name
  description
  teachersNote
  duration
  graded
  created
  day
  week
  parrotRequestId
  attachments {
    id
    url
    size
  }
  customAssignmentType {
    id
    name
    color
  }
}
    `;
export const StudentsEventsFragmentDoc = gql`
    fragment StudentsEvents on students {
  id
  studentEvents {
    id
    event {
      id
      start
      end
      ignoredCourses {
        course {
          id
        }
      }
    }
  }
}
    `;
export const PlanningStudentAssignmentFragmentDoc = gql`
    fragment PlanningStudentAssignment on student_assignments {
  id
  start
  end
  freeForm
  courseDayOffset
  student {
    id
    name
    picture
    ...StudentsEvents
  }
  studentCourse {
    id
    start
    daysOfTheWeek
    courseDayOffsets
  }
}
    `;
export const PlanningStudentAssignmentRescheduleFragmentDoc = gql`
    fragment PlanningStudentAssignmentReschedule on student_assignments {
  id
  studentId
  assignmentId
  start
  end
  freeForm
  status
  studentCourseId
  courseDayOffset
}
    `;
export const PlanningAssignmentStudentAssignmentFragmentDoc = gql`
    fragment PlanningAssignmentStudentAssignment on student_assignments {
  ...PlanningStudentAssignment
  ...PlanningStudentAssignmentReschedule
  pointsEarned
}
    `;
export const PlanningAssignmentDetailFragmentDoc = gql`
    fragment PlanningAssignmentDetail on assignments {
  id
  studentAssignments(order_by: {student: {name: asc}}) {
    ...PlanningAssignmentStudentAssignment
  }
}
    `;
export const CourseAssignmentScheduleFragmentDoc = gql`
    fragment CourseAssignmentSchedule on assignments {
  id
  day
  week
  duration
}
    `;
export const CustomAssignmentTypeFragmentDoc = gql`
    fragment CustomAssignmentType on custom_assignment_types {
  id
  name
  color
  created
  sortOrder
  hidden
}
    `;
export const GradebookStudentAssignmentFragmentDoc = gql`
    fragment GradebookStudentAssignment on student_assignments {
  id
  assignment {
    id
    name
    assignmentType
    customAssignmentType {
      ...CustomAssignmentType
    }
    graded
    created
  }
  status
  pointsEarned
  pointsAvailable
  start
  completed
}
    `;
export const StudentAssignmentToRescheduleFragmentDoc = gql`
    fragment StudentAssignmentToReschedule on student_assignments {
  id
  studentId
  assignmentId
  start
  end
  freeForm
  status
  studentCourseId
  courseDayOffset
  assignment {
    id
    week
    day
    duration
    course {
      id
    }
  }
}
    `;
export const PlanningAssignmentFragmentDoc = gql`
    fragment PlanningAssignment on assignments {
  id
  courseId
  name
  description
  teachersNote
  duration
  graded
  created
  day
  week
  parrotRequestId
  studentAssignments(order_by: {student: {name: asc}}) @include(if: $includeStudentData) {
    ...PlanningAssignmentStudentAssignment
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
  attachments {
    id
    url
    size
  }
  customAssignmentType {
    id
    name
    color
  }
}
    `;
export const CoursePlanCardAssignmentFragmentDoc = gql`
    fragment CoursePlanCardAssignment on assignments {
  id
  day
  week
}
    `;
export const AssignmentInfoFragmentDoc = gql`
    fragment AssignmentInfo on assignments {
  courseId
  ...PlanningAssignment
  ...CoursePlanCardAssignment
}
    `;
export const CourseInfoStudentAssignmentFragmentDoc = gql`
    fragment CourseInfoStudentAssignment on student_assignments {
  id
  freeForm
  start
  end
  status
  assignmentId
  studentId
  studentCourseId
  courseDayOffset
}
    `;
export const CourseInfoAssignmentFragmentDoc = gql`
    fragment CourseInfoAssignment on assignments {
  id
  day
  week
  name
  duration
  graded
  courseId
  customAssignmentType {
    id
  }
}
    `;
export const AssignmentTypeWeightInfoFragmentDoc = gql`
    fragment AssignmentTypeWeightInfo on assignment_type_weights {
  id
  weight
  assignmentType
  customAssignmentType {
    ...CustomAssignmentType
  }
  sortOrder
}
    `;
export const AssignmentTypeWeightsInfoFragmentDoc = gql`
    fragment AssignmentTypeWeightsInfo on courses {
  __typename
  id
  assignmentTypeWeights {
    ...AssignmentTypeWeightInfo
  }
}
    `;
export const RequiredStudentCourseInfoFragmentDoc = gql`
    fragment RequiredStudentCourseInfo on student_courses {
  id
  studentId
  status
  start
  end
  courseId
  daysOfTheWeek
  courseDayOffsets
}
    `;
export const CourseInfoStudentCourseFragmentDoc = gql`
    fragment CourseInfoStudentCourse on student_courses {
  id
  ...RequiredStudentCourseInfo
  student {
    id
    name
    picture
  }
}
    `;
export const CourseInfoFragmentDoc = gql`
    fragment CourseInfo on courses {
  id
  name
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
  color
  picture
  subjects
  labels
  gradeYears
  description
  introduction
  gradingStyle
  credits
  archived
  defaultDaysOfTheWeek
  assignments {
    ...CourseInfoAssignment
  }
  useAssignmentTypeWeights
  ...AssignmentTypeWeightsInfo
  studentCourses(where: {status: {_eq: ENROLLED}}) @include(if: $includeStudentData) {
    ...CourseInfoStudentCourse
  }
  organizationCourseGroups @include(if: $includeOrganizationCourseGroups) {
    organizationCourseGroup {
      id
      name
    }
  }
}
    `;
export const CourseStudentCardInfoFragmentDoc = gql`
    fragment CourseStudentCardInfo on student_courses {
  id
  student {
    id
    name
    picture
  }
}
    `;
export const CourseCardInfoFragmentDoc = gql`
    fragment CourseCardInfo on courses {
  id
  name
  subjects
  labels
  gradeYears
  color
  picture
  archived
  description
  numberOfWeeks
  numberOfDaysPerWeek
  importedFromOrganizationId
  copiedFromCourseId
  studentCourses(where: {status: {_eq: ENROLLED}}) @include(if: $includeStudentData) {
    ...CourseStudentCardInfo
  }
  organizationCourseGroups @include(if: $includeOrganizationCourseGroups) {
    organizationCourseGroup {
      id
      name
    }
  }
}
    `;
export const CoursePlanCardStudentCourseFragmentDoc = gql`
    fragment CoursePlanCardStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  courseDayOffsets
  student {
    id
    name
    ...StudentsEvents
  }
  course {
    id
  }
}
    `;
export const CoursePlanCardInfoFragmentDoc = gql`
    fragment CoursePlanCardInfo on courses {
  id
  name
  color
  numberOfWeeks
  numberOfDaysPerWeek
  assignments {
    ...CoursePlanCardAssignment
  }
  studentCourses(where: {status: {_eq: ENROLLED}}) @include(if: $includeStudentData) {
    ...CoursePlanCardStudentCourse
  }
}
    `;
export const CalendarStudentAssignmentsFragmentDoc = gql`
    fragment CalendarStudentAssignments on student_assignments {
  id
  start
  end
  freeForm
  status
  pointsEarned
  displayOrder
  endDisplayOrder
  courseDayOffset
  student {
    id
    name
    picture
  }
  assignment {
    id
    name
    description
    customAssignmentType {
      ...CustomAssignmentType
    }
    week
    day
    graded
  }
}
    `;
export const CalendarStudentCourseFragmentDoc = gql`
    fragment CalendarStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  dailySortOrder
  courseDayOffsets
  student {
    id
    name
    picture
  }
  studentAssignments(
    where: {_or: [{start: {_eq: $day}}, {end: {_eq: $day}}]}
    order_by: [{assignment: {created: asc}}]
  ) {
    ...CalendarStudentAssignments
  }
}
    `;
export const CalendarCourseFragmentDoc = gql`
    fragment CalendarCourse on courses {
  id
  name
  color
  subjects
  numberOfWeeks
  numberOfDaysPerWeek
  studentCourses(where: {status: {_eq: ENROLLED}}) {
    ...CalendarStudentCourse
  }
}
    `;
export const CalendarWeekStudentCourseFragmentDoc = gql`
    fragment CalendarWeekStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  dailySortOrder
  courseDayOffsets
  student {
    id
    name
    picture
  }
  studentAssignments(
    where: {_or: [{start: {_in: $days}}, {end: {_in: $days}}]}
    order_by: [{assignment: {created: asc}}]
  ) {
    ...CalendarStudentAssignments
  }
}
    `;
export const CalendarWeekCourseFragmentDoc = gql`
    fragment CalendarWeekCourse on courses {
  id
  name
  color
  subjects
  numberOfWeeks
  numberOfDaysPerWeek
  studentCourses(where: {status: {_eq: ENROLLED}}) {
    ...CalendarWeekStudentCourse
  }
}
    `;
export const CalendarMonthStudentAssignmentFragmentDoc = gql`
    fragment CalendarMonthStudentAssignment on student_assignments {
  id
  start
  end
  status
  pointsEarned
  displayOrder
  endDisplayOrder
  student {
    id
    name
    picture
  }
  assignment {
    id
    name
    graded
    customAssignmentType {
      ...CustomAssignmentType
    }
  }
}
    `;
export const CalendarMonthStudentCourseFragmentDoc = gql`
    fragment CalendarMonthStudentCourse on student_courses {
  id
  dailySortOrder
  student {
    id
  }
  studentAssignments(
    where: {_or: [{start: {_gte: $startDay, _lte: $endDay}}, {end: {_gte: $startDay, _lte: $endDay}}]}
    order_by: [{assignment: {created: asc}}]
  ) {
    ...CalendarMonthStudentAssignment
  }
}
    `;
export const CalendarMonthCourseFragmentDoc = gql`
    fragment CalendarMonthCourse on courses {
  id
  name
  color
  subjects
  studentCourses(where: {status: {_eq: ENROLLED}}) {
    ...CalendarMonthStudentCourse
  }
}
    `;
export const ClaimedParrotRequestCourseInfoFragmentDoc = gql`
    fragment ClaimedParrotRequestCourseInfo on courses {
  assignments {
    id
    day
    week
    duration
  }
  studentCourses(where: {status: {_in: [ENROLLED]}}) {
    id
    start
    daysOfTheWeek
    courseDayOffsets
    student {
      id
      name
      ...StudentsEvents
    }
    course {
      id
    }
  }
}
    `;
export const CourseOptionFragmentDoc = gql`
    fragment CourseOption on courses {
  id
  name
  color
  subjects
  labels
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
}
    `;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on events {
  id
  name
  start
  end
  eventType
  ignoredCourses {
    course {
      id
      name
    }
  }
  studentEvents {
    id
    student {
      id
      name
      picture
    }
  }
}
    `;
export const StudentEventInfoFragmentDoc = gql`
    fragment StudentEventInfo on student_events {
  id
  event {
    id
    start
    end
    ignoredCourses {
      course {
        id
      }
    }
  }
}
    `;
export const CalendarVacationFragmentDoc = gql`
    fragment CalendarVacation on events {
  id
  name
  ignoredCourses {
    course {
      id
    }
  }
  studentEvents {
    id
    student {
      id
      name
    }
  }
}
    `;
export const CalendarWeekVacationFragmentDoc = gql`
    fragment CalendarWeekVacation on events {
  id
  name
  start
  end
  ignoredCourses {
    course {
      id
    }
  }
  studentEvents {
    id
    student {
      id
      name
    }
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on organizations {
  id
  name
  supportLink
}
    `;
export const OrganizationAdminInfoFragmentDoc = gql`
    fragment OrganizationAdminInfo on organization_admins {
  id
  email
  organization {
    ...Organization
    icon
  }
}
    `;
export const OrganizationCourseGroupInfoFragmentDoc = gql`
    fragment OrganizationCourseGroupInfo on organization_course_groups {
  id
  name
  description
  releaseDate
  expirationDate
  default
}
    `;
export const OrganizationCourseGroupInfoWithCoursesAndMembersFragmentDoc = gql`
    fragment OrganizationCourseGroupInfoWithCoursesAndMembers on organization_course_groups {
  id
  name
  description
  releaseDate
  expirationDate
  public
  default
  courses {
    course {
      id
    }
  }
  teachers {
    teacher {
      id
    }
  }
  organizationCodes {
    organizationCode {
      id
    }
  }
}
    `;
export const OrganizationCourseCardInfoFragmentDoc = gql`
    fragment OrganizationCourseCardInfo on OrganizationCourse {
  id
  name
  subjects
  labels
  gradeYears
  color
  picture
  archived
  description
  numberOfWeeks
  numberOfDaysPerWeek
  organizationCourseGroups {
    organizationCourseGroup {
      id
      name
    }
  }
}
    `;
export const OrganizationCourseInfoFragmentDoc = gql`
    fragment OrganizationCourseInfo on OrganizationCourse {
  id
  name
  numberOfWeeks
  numberOfDaysPerWeek
  defaultDaysOfTheWeek
  color
  picture
  subjects
  labels
  gradeYears
  description
  introduction
  gradingStyle
  credits
  archived
  useAssignmentTypeWeights
  assignmentTypeWeights {
    id
    weight
    assignmentType
    customAssignmentType {
      id
      name
      color
      created
      sortOrder
      hidden
    }
    sortOrder
  }
  organizationCourseGroups {
    organizationCourseGroup {
      id
      name
    }
  }
}
    `;
export const ParrotRequestInfoFragmentDoc = gql`
    fragment ParrotRequestInfo on parrot_requests {
  id
  course {
    id
    name
    color
    numberOfWeeks
  }
  startWeek
  endWeek
  status
  queuePosition
  userNotes
  files {
    id
    url
  }
  teacher {
    id
    email
  }
  created
}
    `;
export const PrintingJobInfoFragmentDoc = gql`
    fragment PrintingJobInfo on printing_jobs {
  id
  teacherId
  studentAccountId
  status
  file {
    id
    url
  }
}
    `;
export const RescheduleActionFragmentDoc = gql`
    fragment RescheduleAction on reschedule_actions {
  id
  type
  status
  data
  created
  updated
}
    `;
export const StudentInfoFragmentDoc = gql`
    fragment StudentInfo on students {
  id
  name
  schoolYear
  picture
  studentAccount {
    id
    email
  }
}
    `;
export const StudentOptionFragmentDoc = gql`
    fragment StudentOption on students {
  id
  name
  picture
}
    `;
export const HomeStudentAssignmentFragmentDoc = gql`
    fragment HomeStudentAssignment on student_assignments {
  id
  start
  end
  freeForm
  status
  pointsEarned
  assignment {
    id
    name
    customAssignmentType {
      ...CustomAssignmentType
    }
    graded
    course {
      id
      name
      color
      subjects
    }
  }
  student {
    id
    name
    picture
  }
  studentCourse {
    id
  }
}
    `;
export const CommentInfoFragmentDoc = gql`
    fragment CommentInfo on comments {
  id
  content
  created
  studentAccount {
    id
    name
    picture
  }
  teacher {
    id
    name
    picture
  }
  studentAssignment {
    id
  }
}
    `;
export const StudentAssignmentDetailsFragmentDoc = gql`
    fragment StudentAssignmentDetails on student_assignments {
  id
  start
  end
  pointsEarned
  pointsAvailable
  freeForm
  status
  courseDayOffset
  assignment {
    id
    name
    week
    day
    description
    teachersNote @skip(if: $isStudent)
    customAssignmentType {
      ...CustomAssignmentType
    }
    assignmentType
    graded
    created
    attachments {
      id
      url
    }
    course {
      id
      name
      color
      subjects
    }
  }
  student {
    id
    name
    picture
    ...StudentsEvents
  }
  studentCourse {
    id
    daysOfTheWeek
    dailySortOrder
    courseDayOffsets
    start
    course {
      id
      gradingStyle
    }
  }
  submissions {
    id
    url
  }
  comments {
    ...CommentInfo
  }
}
    `;
export const CompletedStudentCourseCardInfoFragmentDoc = gql`
    fragment CompletedStudentCourseCardInfo on student_courses {
  id
  status
  start
  end
  calendarYear
  schoolYear
  courseSnapshot
  student {
    id
    name
    picture
  }
}
    `;
export const CourseSnapshotFragmentDoc = gql`
    fragment CourseSnapshot on student_courses {
  course {
    id
    name
    numberOfWeeks
    numberOfDaysPerWeek
    color
    description
    teacherId
    credits
    gradingStyle
    defaultDaysOfTheWeek
    subjects
    labels
    gradeYears
    introduction
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    id
    start
    end
    status
    pointsEarned
    pointsAvailable
    completed
    submissions {
      id
      url
    }
    assignment {
      id
      name
      week
      day
      duration
      graded
      customAssignmentType {
        ...CustomAssignmentType
      }
      description
      teachersNote
      created
      attachments {
        id
        url
      }
    }
    comments {
      ...CommentInfo
    }
  }
}
    `;
export const ActiveStudentCoursesInfoFragmentDoc = gql`
    fragment ActiveStudentCoursesInfo on student_courses {
  id
  start
  daysOfTheWeek
  courseDayOffsets
  course {
    numberOfDaysPerWeek
    numberOfWeeks
  }
  student {
    ...StudentsEvents
  }
}
    `;
export const ActiveStudentCourseCardInfoFragmentDoc = gql`
    fragment ActiveStudentCourseCardInfo on student_courses {
  id
  start
  end
  daysOfTheWeek
  status
  dailySortOrder
  courseDayOffsets
  student {
    id
    name
    schoolYear
    picture
  }
  course {
    id
    name
    color
    gradingStyle
    numberOfDaysPerWeek
    numberOfWeeks
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
}
    `;
export const StudentCourseInfoFragmentDoc = gql`
    fragment StudentCourseInfo on student_courses {
  id
  status
  start
  end
  daysOfTheWeek
  calendarYear
  schoolYear
  courseDayOffsets
  courseSnapshot
  student {
    id
    name
    schoolYear
    picture
  }
  course {
    id
    name
    color
    gradingStyle
    numberOfDaysPerWeek
    numberOfWeeks
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
}
    `;
export const PlanningStudentCourseFragmentDoc = gql`
    fragment PlanningStudentCourse on student_courses {
  id
  start
  daysOfTheWeek
  courseDayOffsets
  student {
    id
    name
    picture
    ...StudentsEvents
  }
  course {
    id
  }
}
    `;
export const StudentCourseToRescheduleFragmentDoc = gql`
    fragment StudentCourseToReschedule on student_courses {
  id
  daysOfTheWeek
  studentId
  start
  courseDayOffsets
  studentAssignments(
    where: {_and: [{start: {_gte: $date}}, {freeForm: {_eq: false}}, {status: {_neq: COMPLETE}}]}
  ) {
    ...StudentAssignmentToReschedule
  }
}
    `;
export const StudentCourseToReoffsetFragmentDoc = gql`
    fragment StudentCourseToReoffset on student_courses {
  id
  daysOfTheWeek
  studentId
  start
  courseDayOffsets
  studentAssignments(
    where: {_and: [{start: {_lt: $date}}, {assignment: {_or: [{week: {_gt: $week}}, {_and: [{week: {_eq: $week}}, {day: {_gte: $day}}]}]}}, {id: {_neq: $studentAssignmentId}}]}
  ) {
    ...StudentAssignmentToReschedule
  }
}
    `;
export const StudentAssignmentToUpdateGradingStyleFragmentDoc = gql`
    fragment StudentAssignmentToUpdateGradingStyle on student_assignments {
  id
  studentId
  assignmentId
  status
  studentCourseId
  pointsEarned
  pointsAvailable
}
    `;
export const StudentCoursesToUpdateGradingStyleFragmentDoc = gql`
    fragment StudentCoursesToUpdateGradingStyle on student_courses {
  id
  studentAssignments {
    ...StudentAssignmentToUpdateGradingStyle
  }
}
    `;
export const ActiveStudentTranscriptCourseFragmentDoc = gql`
    fragment ActiveStudentTranscriptCourse on student_courses {
  id
  courseSnapshot
  studentAssignments {
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
  course {
    id
    name
    color
    credits
    gradingStyle
    useAssignmentTypeWeights
    ...AssignmentTypeWeightsInfo
  }
}
    `;
export const CompletedStudentTranscriptCourseFragmentDoc = gql`
    fragment CompletedStudentTranscriptCourse on student_courses {
  id
  calendarYear
  courseSnapshot
}
    `;
export const TeacherInfoFragmentDoc = gql`
    fragment TeacherInfo on teachers {
  id
  email
  name
  picture
  organization {
    ...Organization
  }
}
    `;
export const ThemeDetailsFragmentDoc = gql`
    fragment ThemeDetails on themes {
  id
  name
  isSyllabirdTheme
  organizationId
  visible
  isPrimary
  headerBackground
  headerForeground
  headerForegroundActive
  primary
  primaryContrast
  appBackground
  contentBackground
  faintBorder
  mediumBorder
  elementBorder
  elementBackground
  surfaceBorder
  colorPalette
  contentContrast
  contentPrimary
  contentSecondary
  contentTertiary
  positive
  negative
  info
  vacation
  logoUrl
  portalIconUrl
  fontUrl
  fontFamily
  baseFontSize
  rescheduleNormal
  rescheduleShift
  rescheduleFreeform
  rescheduleSetEnd
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on user_settings {
  id
  showEmptyAssignmentDays
  weekStartDay
  selectedThemeId
}
    `;
export const NewAttachmentFragmentDoc = gql`
    fragment NewAttachment on files {
  id
  url
  assignmentId
}
    `;
export const NewParrotRequstFileFragmentDoc = gql`
    fragment NewParrotRequstFile on files {
  id
  url
  parrotRequestId
}
    `;
export const BatchRescheduleStudentAssignmentsDocument = gql`
    mutation BatchRescheduleStudentAssignments($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end, courseDayOffset, freeForm, displayOrder, endDisplayOrder]}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
      freeForm
      displayOrder
      endDisplayOrder
    }
  }
}
    `;
export type BatchRescheduleStudentAssignmentsMutationFn = Apollo.MutationFunction<BatchRescheduleStudentAssignmentsMutation, BatchRescheduleStudentAssignmentsMutationVariables>;

/**
 * __useBatchRescheduleStudentAssignmentsMutation__
 *
 * To run a mutation, you first call `useBatchRescheduleStudentAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchRescheduleStudentAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchRescheduleStudentAssignmentsMutation, { data, loading, error }] = useBatchRescheduleStudentAssignmentsMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useBatchRescheduleStudentAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<BatchRescheduleStudentAssignmentsMutation, BatchRescheduleStudentAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchRescheduleStudentAssignmentsMutation, BatchRescheduleStudentAssignmentsMutationVariables>(BatchRescheduleStudentAssignmentsDocument, options);
      }
export type BatchRescheduleStudentAssignmentsMutationHookResult = ReturnType<typeof useBatchRescheduleStudentAssignmentsMutation>;
export type BatchRescheduleStudentAssignmentsMutationResult = Apollo.MutationResult<BatchRescheduleStudentAssignmentsMutation>;
export type BatchRescheduleStudentAssignmentsMutationOptions = Apollo.BaseMutationOptions<BatchRescheduleStudentAssignmentsMutation, BatchRescheduleStudentAssignmentsMutationVariables>;
export const BulkDeleteCoursesDocument = gql`
    mutation BulkDeleteCourses($courseIds: [uuid!]!) {
  delete_courses(where: {id: {_in: $courseIds}}) {
    returning {
      id
    }
  }
}
    `;
export type BulkDeleteCoursesMutationFn = Apollo.MutationFunction<BulkDeleteCoursesMutation, BulkDeleteCoursesMutationVariables>;

/**
 * __useBulkDeleteCoursesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteCoursesMutation, { data, loading, error }] = useBulkDeleteCoursesMutation({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useBulkDeleteCoursesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteCoursesMutation, BulkDeleteCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteCoursesMutation, BulkDeleteCoursesMutationVariables>(BulkDeleteCoursesDocument, options);
      }
export type BulkDeleteCoursesMutationHookResult = ReturnType<typeof useBulkDeleteCoursesMutation>;
export type BulkDeleteCoursesMutationResult = Apollo.MutationResult<BulkDeleteCoursesMutation>;
export type BulkDeleteCoursesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteCoursesMutation, BulkDeleteCoursesMutationVariables>;
export const BulkDeleteStudentCoursesDocument = gql`
    mutation BulkDeleteStudentCourses($studentCourseIds: [uuid!]!) {
  delete_student_courses(where: {id: {_in: $studentCourseIds}}) {
    returning {
      id
    }
  }
}
    `;
export type BulkDeleteStudentCoursesMutationFn = Apollo.MutationFunction<BulkDeleteStudentCoursesMutation, BulkDeleteStudentCoursesMutationVariables>;

/**
 * __useBulkDeleteStudentCoursesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteStudentCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteStudentCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteStudentCoursesMutation, { data, loading, error }] = useBulkDeleteStudentCoursesMutation({
 *   variables: {
 *      studentCourseIds: // value for 'studentCourseIds'
 *   },
 * });
 */
export function useBulkDeleteStudentCoursesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteStudentCoursesMutation, BulkDeleteStudentCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteStudentCoursesMutation, BulkDeleteStudentCoursesMutationVariables>(BulkDeleteStudentCoursesDocument, options);
      }
export type BulkDeleteStudentCoursesMutationHookResult = ReturnType<typeof useBulkDeleteStudentCoursesMutation>;
export type BulkDeleteStudentCoursesMutationResult = Apollo.MutationResult<BulkDeleteStudentCoursesMutation>;
export type BulkDeleteStudentCoursesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteStudentCoursesMutation, BulkDeleteStudentCoursesMutationVariables>;
export const BulkSetCoursesArchiveStatusDocument = gql`
    mutation BulkSetCoursesArchiveStatus($courseIds: [uuid!]!, $archived: Boolean!) {
  update_courses(where: {id: {_in: $courseIds}}, _set: {archived: $archived}) {
    returning {
      id
      archived
      name
      color
      numberOfWeeks
      numberOfDaysPerWeek
      defaultDaysOfTheWeek
      subjects
      labels
      assignments {
        ...CoursePlanCardAssignment
      }
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;
export type BulkSetCoursesArchiveStatusMutationFn = Apollo.MutationFunction<BulkSetCoursesArchiveStatusMutation, BulkSetCoursesArchiveStatusMutationVariables>;

/**
 * __useBulkSetCoursesArchiveStatusMutation__
 *
 * To run a mutation, you first call `useBulkSetCoursesArchiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSetCoursesArchiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSetCoursesArchiveStatusMutation, { data, loading, error }] = useBulkSetCoursesArchiveStatusMutation({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useBulkSetCoursesArchiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkSetCoursesArchiveStatusMutation, BulkSetCoursesArchiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkSetCoursesArchiveStatusMutation, BulkSetCoursesArchiveStatusMutationVariables>(BulkSetCoursesArchiveStatusDocument, options);
      }
export type BulkSetCoursesArchiveStatusMutationHookResult = ReturnType<typeof useBulkSetCoursesArchiveStatusMutation>;
export type BulkSetCoursesArchiveStatusMutationResult = Apollo.MutationResult<BulkSetCoursesArchiveStatusMutation>;
export type BulkSetCoursesArchiveStatusMutationOptions = Apollo.BaseMutationOptions<BulkSetCoursesArchiveStatusMutation, BulkSetCoursesArchiveStatusMutationVariables>;
export const BulkUpdateAssignmentsDocument = gql`
    mutation BulkUpdateAssignments($assignments: [assignments_insert_input!]!) {
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [name, description, teachersNote, graded, customAssignmentTypeId, day, week, duration]}
  ) {
    returning {
      id
      name
      description
      teachersNote
      graded
      customAssignmentType {
        ...CustomAssignmentType
      }
      day
      week
      duration
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type BulkUpdateAssignmentsMutationFn = Apollo.MutationFunction<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>;

/**
 * __useBulkUpdateAssignmentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateAssignmentsMutation, { data, loading, error }] = useBulkUpdateAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useBulkUpdateAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>(BulkUpdateAssignmentsDocument, options);
      }
export type BulkUpdateAssignmentsMutationHookResult = ReturnType<typeof useBulkUpdateAssignmentsMutation>;
export type BulkUpdateAssignmentsMutationResult = Apollo.MutationResult<BulkUpdateAssignmentsMutation>;
export type BulkUpdateAssignmentsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateAssignmentsMutation, BulkUpdateAssignmentsMutationVariables>;
export const CompleteStudentCourseDocument = gql`
    mutation CompleteStudentCourse($studentCourseId: uuid!, $schoolYear: school_year_enum!, $calendarYear: String!, $courseSnapshot: jsonb!) {
  studentCourse: update_student_course(
    pk_columns: {id: $studentCourseId}
    _set: {schoolYear: $schoolYear, calendarYear: $calendarYear, courseSnapshot: $courseSnapshot, status: COMPLETED, courseId: null}
  ) {
    id
    schoolYear
    calendarYear
    courseSnapshot
    status
    courseId
    student {
      id
    }
    ...CompletedStudentCourseCardInfo
  }
  studentAssignments: delete_student_assignments(
    where: {studentCourseId: {_eq: $studentCourseId}}
  ) {
    returning {
      id
    }
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;
export type CompleteStudentCourseMutationFn = Apollo.MutationFunction<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>;

/**
 * __useCompleteStudentCourseMutation__
 *
 * To run a mutation, you first call `useCompleteStudentCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStudentCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStudentCourseMutation, { data, loading, error }] = useCompleteStudentCourseMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      schoolYear: // value for 'schoolYear'
 *      calendarYear: // value for 'calendarYear'
 *      courseSnapshot: // value for 'courseSnapshot'
 *   },
 * });
 */
export function useCompleteStudentCourseMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>(CompleteStudentCourseDocument, options);
      }
export type CompleteStudentCourseMutationHookResult = ReturnType<typeof useCompleteStudentCourseMutation>;
export type CompleteStudentCourseMutationResult = Apollo.MutationResult<CompleteStudentCourseMutation>;
export type CompleteStudentCourseMutationOptions = Apollo.BaseMutationOptions<CompleteStudentCourseMutation, CompleteStudentCourseMutationVariables>;
export const CreateAssignmentTypeWeightsDocument = gql`
    mutation CreateAssignmentTypeWeights($assignmentTypeWeights: [assignment_type_weights_insert_input!]!) {
  assignmentTypeWeights: insert_assignment_type_weights(
    objects: $assignmentTypeWeights
  ) {
    returning {
      ...AssignmentTypeWeightInfo
    }
  }
}
    ${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;
export type CreateAssignmentTypeWeightsMutationFn = Apollo.MutationFunction<CreateAssignmentTypeWeightsMutation, CreateAssignmentTypeWeightsMutationVariables>;

/**
 * __useCreateAssignmentTypeWeightsMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentTypeWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentTypeWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentTypeWeightsMutation, { data, loading, error }] = useCreateAssignmentTypeWeightsMutation({
 *   variables: {
 *      assignmentTypeWeights: // value for 'assignmentTypeWeights'
 *   },
 * });
 */
export function useCreateAssignmentTypeWeightsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentTypeWeightsMutation, CreateAssignmentTypeWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentTypeWeightsMutation, CreateAssignmentTypeWeightsMutationVariables>(CreateAssignmentTypeWeightsDocument, options);
      }
export type CreateAssignmentTypeWeightsMutationHookResult = ReturnType<typeof useCreateAssignmentTypeWeightsMutation>;
export type CreateAssignmentTypeWeightsMutationResult = Apollo.MutationResult<CreateAssignmentTypeWeightsMutation>;
export type CreateAssignmentTypeWeightsMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentTypeWeightsMutation, CreateAssignmentTypeWeightsMutationVariables>;
export const CreateAssignmentDocument = gql`
    mutation CreateAssignment($assignment: assignments_insert_input!, $includeStudentData: Boolean = true) {
  assignment: insert_assignment(object: $assignment) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}
${PlanningAssignmentFragmentDoc}
${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type CreateAssignmentMutationFn = Apollo.MutationFunction<CreateAssignmentMutation, CreateAssignmentMutationVariables>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      assignment: // value for 'assignment'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, options);
      }
export type CreateAssignmentMutationHookResult = ReturnType<typeof useCreateAssignmentMutation>;
export type CreateAssignmentMutationResult = Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>;
export const CreateAssignmentsDocument = gql`
    mutation CreateAssignments($assignments: [assignments_insert_input!]!, $includeStudentData: Boolean = true) {
  assignments: insert_assignments(objects: $assignments) {
    returning {
      ...AssignmentInfo
    }
  }
}
    ${AssignmentInfoFragmentDoc}
${PlanningAssignmentFragmentDoc}
${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type CreateAssignmentsMutationFn = Apollo.MutationFunction<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>;

/**
 * __useCreateAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentsMutation, { data, loading, error }] = useCreateAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useCreateAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>(CreateAssignmentsDocument, options);
      }
export type CreateAssignmentsMutationHookResult = ReturnType<typeof useCreateAssignmentsMutation>;
export type CreateAssignmentsMutationResult = Apollo.MutationResult<CreateAssignmentsMutation>;
export type CreateAssignmentsMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentsMutation, CreateAssignmentsMutationVariables>;
export const CreateAttachmentsDocument = gql`
    mutation CreateAttachments($attachments: [files_insert_input!]!) {
  attachments: insert_files(objects: $attachments) {
    returning {
      id
      url
      size
      assignmentId
    }
  }
}
    `;
export type CreateAttachmentsMutationFn = Apollo.MutationFunction<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>;

/**
 * __useCreateAttachmentsMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentsMutation, { data, loading, error }] = useCreateAttachmentsMutation({
 *   variables: {
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useCreateAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>(CreateAttachmentsDocument, options);
      }
export type CreateAttachmentsMutationHookResult = ReturnType<typeof useCreateAttachmentsMutation>;
export type CreateAttachmentsMutationResult = Apollo.MutationResult<CreateAttachmentsMutation>;
export type CreateAttachmentsMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentsMutation, CreateAttachmentsMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($comment: comments_insert_input!) {
  comment: insert_comment(object: $comment) {
    ...CommentInfo
  }
}
    ${CommentInfoFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($course: courses_insert_input!, $includeStudentData: Boolean = true, $includeOrganizationCourseGroups: Boolean = false) {
  course: insert_course(object: $course) {
    ...CourseCardInfo
    ...CoursePlanCardInfo
    ...CourseOption
  }
}
    ${CourseCardInfoFragmentDoc}
${CourseStudentCardInfoFragmentDoc}
${CoursePlanCardInfoFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}
${CoursePlanCardStudentCourseFragmentDoc}
${StudentsEventsFragmentDoc}
${CourseOptionFragmentDoc}`;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      course: // value for 'course'
 *      includeStudentData: // value for 'includeStudentData'
 *      includeOrganizationCourseGroups: // value for 'includeOrganizationCourseGroups'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const CreateCustomAssignmentTypeDocument = gql`
    mutation CreateCustomAssignmentType($customAssignmentType: custom_assignment_types_insert_input!) {
  customAssignmentType: insert_custom_assignment_type(
    object: $customAssignmentType
  ) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type CreateCustomAssignmentTypeMutationFn = Apollo.MutationFunction<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>;

/**
 * __useCreateCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useCreateCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAssignmentTypeMutation, { data, loading, error }] = useCreateCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentType: // value for 'customAssignmentType'
 *   },
 * });
 */
export function useCreateCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>(CreateCustomAssignmentTypeDocument, options);
      }
export type CreateCustomAssignmentTypeMutationHookResult = ReturnType<typeof useCreateCustomAssignmentTypeMutation>;
export type CreateCustomAssignmentTypeMutationResult = Apollo.MutationResult<CreateCustomAssignmentTypeMutation>;
export type CreateCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<CreateCustomAssignmentTypeMutation, CreateCustomAssignmentTypeMutationVariables>;
export const CreateCustomAssignmentTypesDocument = gql`
    mutation CreateCustomAssignmentTypes($customAssignmentTypes: [custom_assignment_types_insert_input!]!) {
  customAssignmentTypes: insert_custom_assignment_types(
    objects: $customAssignmentTypes
  ) {
    returning {
      ...CustomAssignmentType
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type CreateCustomAssignmentTypesMutationFn = Apollo.MutationFunction<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>;

/**
 * __useCreateCustomAssignmentTypesMutation__
 *
 * To run a mutation, you first call `useCreateCustomAssignmentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAssignmentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAssignmentTypesMutation, { data, loading, error }] = useCreateCustomAssignmentTypesMutation({
 *   variables: {
 *      customAssignmentTypes: // value for 'customAssignmentTypes'
 *   },
 * });
 */
export function useCreateCustomAssignmentTypesMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>(CreateCustomAssignmentTypesDocument, options);
      }
export type CreateCustomAssignmentTypesMutationHookResult = ReturnType<typeof useCreateCustomAssignmentTypesMutation>;
export type CreateCustomAssignmentTypesMutationResult = Apollo.MutationResult<CreateCustomAssignmentTypesMutation>;
export type CreateCustomAssignmentTypesMutationOptions = Apollo.BaseMutationOptions<CreateCustomAssignmentTypesMutation, CreateCustomAssignmentTypesMutationVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($start: date!, $end: date!, $eventType: event_t_enum!, $teacherId: String!, $name: String, $studentEvents: [student_events_insert_input!]!, $studentAssignments: [student_assignments_insert_input!]!, $ignoredCourses: [event_ignored_courses_insert_input!]!) {
  event: insert_event(
    object: {start: $start, end: $end, eventType: $eventType, teacherId: $teacherId, name: $name, studentEvents: {data: $studentEvents}, ignoredCourses: {data: $ignoredCourses}}
  ) {
    ...EventInfo
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      eventType: // value for 'eventType'
 *      teacherId: // value for 'teacherId'
 *      name: // value for 'name'
 *      studentEvents: // value for 'studentEvents'
 *      studentAssignments: // value for 'studentAssignments'
 *      ignoredCourses: // value for 'ignoredCourses'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const CreateOrganizationCourseGroupDocument = gql`
    mutation CreateOrganizationCourseGroup($organizationCourseGroup: organization_course_groups_insert_input!) {
  organizationCourseGroup: insert_organization_course_group(
    object: $organizationCourseGroup
  ) {
    ...OrganizationCourseGroupInfo
    ...OrganizationCourseGroupInfoWithCoursesAndMembers
  }
}
    ${OrganizationCourseGroupInfoFragmentDoc}
${OrganizationCourseGroupInfoWithCoursesAndMembersFragmentDoc}`;
export type CreateOrganizationCourseGroupMutationFn = Apollo.MutationFunction<CreateOrganizationCourseGroupMutation, CreateOrganizationCourseGroupMutationVariables>;

/**
 * __useCreateOrganizationCourseGroupMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationCourseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationCourseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationCourseGroupMutation, { data, loading, error }] = useCreateOrganizationCourseGroupMutation({
 *   variables: {
 *      organizationCourseGroup: // value for 'organizationCourseGroup'
 *   },
 * });
 */
export function useCreateOrganizationCourseGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationCourseGroupMutation, CreateOrganizationCourseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationCourseGroupMutation, CreateOrganizationCourseGroupMutationVariables>(CreateOrganizationCourseGroupDocument, options);
      }
export type CreateOrganizationCourseGroupMutationHookResult = ReturnType<typeof useCreateOrganizationCourseGroupMutation>;
export type CreateOrganizationCourseGroupMutationResult = Apollo.MutationResult<CreateOrganizationCourseGroupMutation>;
export type CreateOrganizationCourseGroupMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationCourseGroupMutation, CreateOrganizationCourseGroupMutationVariables>;
export const CreateParrotRequestDocument = gql`
    mutation CreateParrotRequest($teacherId: String!, $customerId: String!, $parrotRequestWeeksUsed: Int!, $courseId: uuid!, $startWeek: Int!, $endWeek: Int!, $status: parrot_request_status_enum!, $queuePosition: Int, $userNotes: String, $files: [files_insert_input!]!) {
  parrotRequest: insert_parrot_request(
    object: {teacherId: $teacherId, courseId: $courseId, startWeek: $startWeek, endWeek: $endWeek, status: $status, queuePosition: $queuePosition, userNotes: $userNotes, files: {data: $files}}
  ) {
    ...ParrotRequestInfo
  }
  customer: update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotRequestWeeksUsed}
  ) {
    id
    parrotCredits
  }
}
    ${ParrotRequestInfoFragmentDoc}`;
export type CreateParrotRequestMutationFn = Apollo.MutationFunction<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>;

/**
 * __useCreateParrotRequestMutation__
 *
 * To run a mutation, you first call `useCreateParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParrotRequestMutation, { data, loading, error }] = useCreateParrotRequestMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      customerId: // value for 'customerId'
 *      parrotRequestWeeksUsed: // value for 'parrotRequestWeeksUsed'
 *      courseId: // value for 'courseId'
 *      startWeek: // value for 'startWeek'
 *      endWeek: // value for 'endWeek'
 *      status: // value for 'status'
 *      queuePosition: // value for 'queuePosition'
 *      userNotes: // value for 'userNotes'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>(CreateParrotRequestDocument, options);
      }
export type CreateParrotRequestMutationHookResult = ReturnType<typeof useCreateParrotRequestMutation>;
export type CreateParrotRequestMutationResult = Apollo.MutationResult<CreateParrotRequestMutation>;
export type CreateParrotRequestMutationOptions = Apollo.BaseMutationOptions<CreateParrotRequestMutation, CreateParrotRequestMutationVariables>;
export const CreateParrotRequestFilesDocument = gql`
    mutation CreateParrotRequestFiles($files: [files_insert_input!]!) {
  files: insert_files(objects: $files) {
    returning {
      id
      url
      size
      parrotRequestId
    }
  }
}
    `;
export type CreateParrotRequestFilesMutationFn = Apollo.MutationFunction<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>;

/**
 * __useCreateParrotRequestFilesMutation__
 *
 * To run a mutation, you first call `useCreateParrotRequestFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParrotRequestFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParrotRequestFilesMutation, { data, loading, error }] = useCreateParrotRequestFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateParrotRequestFilesMutation(baseOptions?: Apollo.MutationHookOptions<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>(CreateParrotRequestFilesDocument, options);
      }
export type CreateParrotRequestFilesMutationHookResult = ReturnType<typeof useCreateParrotRequestFilesMutation>;
export type CreateParrotRequestFilesMutationResult = Apollo.MutationResult<CreateParrotRequestFilesMutation>;
export type CreateParrotRequestFilesMutationOptions = Apollo.BaseMutationOptions<CreateParrotRequestFilesMutation, CreateParrotRequestFilesMutationVariables>;
export const CreatePrintingJobDocument = gql`
    mutation CreatePrintingJob($teacherId: String, $studentAccountId: String, $printingJobType: printing_job_type_enum!, $data: jsonb!) {
  printingJob: insert_printing_job(
    object: {teacherId: $teacherId, studentAccountId: $studentAccountId, status: GENERATING, type: $printingJobType, data: $data}
  ) {
    id
  }
}
    `;
export type CreatePrintingJobMutationFn = Apollo.MutationFunction<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>;

/**
 * __useCreatePrintingJobMutation__
 *
 * To run a mutation, you first call `useCreatePrintingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrintingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrintingJobMutation, { data, loading, error }] = useCreatePrintingJobMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      studentAccountId: // value for 'studentAccountId'
 *      printingJobType: // value for 'printingJobType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrintingJobMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>(CreatePrintingJobDocument, options);
      }
export type CreatePrintingJobMutationHookResult = ReturnType<typeof useCreatePrintingJobMutation>;
export type CreatePrintingJobMutationResult = Apollo.MutationResult<CreatePrintingJobMutation>;
export type CreatePrintingJobMutationOptions = Apollo.BaseMutationOptions<CreatePrintingJobMutation, CreatePrintingJobMutationVariables>;
export const CreateRescheduleActionDocument = gql`
    mutation CreateRescheduleAction($teacherId: String!, $type: reschedule_action_types_enum!, $data: jsonb!, $status: reschedule_action_statuses_enum = ACTIVE) {
  rescheduleAction: insert_reschedule_action(
    object: {teacherId: $teacherId, type: $type, data: $data, status: $status}
  ) {
    ...RescheduleAction
  }
}
    ${RescheduleActionFragmentDoc}`;
export type CreateRescheduleActionMutationFn = Apollo.MutationFunction<CreateRescheduleActionMutation, CreateRescheduleActionMutationVariables>;

/**
 * __useCreateRescheduleActionMutation__
 *
 * To run a mutation, you first call `useCreateRescheduleActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRescheduleActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRescheduleActionMutation, { data, loading, error }] = useCreateRescheduleActionMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCreateRescheduleActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRescheduleActionMutation, CreateRescheduleActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRescheduleActionMutation, CreateRescheduleActionMutationVariables>(CreateRescheduleActionDocument, options);
      }
export type CreateRescheduleActionMutationHookResult = ReturnType<typeof useCreateRescheduleActionMutation>;
export type CreateRescheduleActionMutationResult = Apollo.MutationResult<CreateRescheduleActionMutation>;
export type CreateRescheduleActionMutationOptions = Apollo.BaseMutationOptions<CreateRescheduleActionMutation, CreateRescheduleActionMutationVariables>;
export const CreateStudentDocument = gql`
    mutation CreateStudent($teacherId: String!, $name: String!, $schoolYear: school_year_enum, $picture: String) {
  student: insert_student(
    object: {teachers: {data: {teacherId: $teacherId}}, name: $name, schoolYear: $schoolYear, picture: $picture}
  ) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;
export type CreateStudentMutationFn = Apollo.MutationFunction<CreateStudentMutation, CreateStudentMutationVariables>;

/**
 * __useCreateStudentMutation__
 *
 * To run a mutation, you first call `useCreateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentMutation, { data, loading, error }] = useCreateStudentMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      name: // value for 'name'
 *      schoolYear: // value for 'schoolYear'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useCreateStudentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudentMutation, CreateStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudentMutation, CreateStudentMutationVariables>(CreateStudentDocument, options);
      }
export type CreateStudentMutationHookResult = ReturnType<typeof useCreateStudentMutation>;
export type CreateStudentMutationResult = Apollo.MutationResult<CreateStudentMutation>;
export type CreateStudentMutationOptions = Apollo.BaseMutationOptions<CreateStudentMutation, CreateStudentMutationVariables>;
export const CreateStudentAssignmentDocument = gql`
    mutation CreateStudentAssignment($studentAssignment: student_assignments_insert_input!) {
  studentAssignment: insert_student_assignment(object: $studentAssignment) {
    ...PlanningAssignmentStudentAssignment
    ...GradebookStudentAssignment
    ...StudentAssignmentToReschedule
  }
}
    ${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;
export type CreateStudentAssignmentMutationFn = Apollo.MutationFunction<CreateStudentAssignmentMutation, CreateStudentAssignmentMutationVariables>;

/**
 * __useCreateStudentAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateStudentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudentAssignmentMutation, { data, loading, error }] = useCreateStudentAssignmentMutation({
 *   variables: {
 *      studentAssignment: // value for 'studentAssignment'
 *   },
 * });
 */
export function useCreateStudentAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStudentAssignmentMutation, CreateStudentAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStudentAssignmentMutation, CreateStudentAssignmentMutationVariables>(CreateStudentAssignmentDocument, options);
      }
export type CreateStudentAssignmentMutationHookResult = ReturnType<typeof useCreateStudentAssignmentMutation>;
export type CreateStudentAssignmentMutationResult = Apollo.MutationResult<CreateStudentAssignmentMutation>;
export type CreateStudentAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateStudentAssignmentMutation, CreateStudentAssignmentMutationVariables>;
export const CreateSubmissionsDocument = gql`
    mutation CreateSubmissions($submissions: [files_insert_input!]!) {
  submissions: insert_files(objects: $submissions) {
    returning {
      id
      url
      size
      studentAssignmentId
    }
  }
}
    `;
export type CreateSubmissionsMutationFn = Apollo.MutationFunction<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>;

/**
 * __useCreateSubmissionsMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionsMutation, { data, loading, error }] = useCreateSubmissionsMutation({
 *   variables: {
 *      submissions: // value for 'submissions'
 *   },
 * });
 */
export function useCreateSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>(CreateSubmissionsDocument, options);
      }
export type CreateSubmissionsMutationHookResult = ReturnType<typeof useCreateSubmissionsMutation>;
export type CreateSubmissionsMutationResult = Apollo.MutationResult<CreateSubmissionsMutation>;
export type CreateSubmissionsMutationOptions = Apollo.BaseMutationOptions<CreateSubmissionsMutation, CreateSubmissionsMutationVariables>;
export const CreateThemeDocument = gql`
    mutation CreateTheme($object: themes_insert_input!) {
  insert_themes_one(object: $object) {
    ...ThemeDetails
  }
}
    ${ThemeDetailsFragmentDoc}`;
export type CreateThemeMutationFn = Apollo.MutationFunction<CreateThemeMutation, CreateThemeMutationVariables>;

/**
 * __useCreateThemeMutation__
 *
 * To run a mutation, you first call `useCreateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThemeMutation, { data, loading, error }] = useCreateThemeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateThemeMutation(baseOptions?: Apollo.MutationHookOptions<CreateThemeMutation, CreateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThemeMutation, CreateThemeMutationVariables>(CreateThemeDocument, options);
      }
export type CreateThemeMutationHookResult = ReturnType<typeof useCreateThemeMutation>;
export type CreateThemeMutationResult = Apollo.MutationResult<CreateThemeMutation>;
export type CreateThemeMutationOptions = Apollo.BaseMutationOptions<CreateThemeMutation, CreateThemeMutationVariables>;
export const DeleteAssignmentDocument = gql`
    mutation DeleteAssignment($assignmentId: uuid!, $includeStudentData: Boolean = true) {
  assignment: delete_assignment(id: $assignmentId) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}
${PlanningAssignmentFragmentDoc}
${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type DeleteAssignmentMutationFn = Apollo.MutationFunction<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;

/**
 * __useDeleteAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentMutation, { data, loading, error }] = useDeleteAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useDeleteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>(DeleteAssignmentDocument, options);
      }
export type DeleteAssignmentMutationHookResult = ReturnType<typeof useDeleteAssignmentMutation>;
export type DeleteAssignmentMutationResult = Apollo.MutationResult<DeleteAssignmentMutation>;
export type DeleteAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;
export const DeleteAssignmentTypeWeightsDocument = gql`
    mutation DeleteAssignmentTypeWeights($courseId: uuid!) {
  assignmentTypeWeight: delete_assignment_type_weights(
    where: {course_id: {_eq: $courseId}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentTypeWeightsMutationFn = Apollo.MutationFunction<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>;

/**
 * __useDeleteAssignmentTypeWeightsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentTypeWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentTypeWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentTypeWeightsMutation, { data, loading, error }] = useDeleteAssignmentTypeWeightsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDeleteAssignmentTypeWeightsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>(DeleteAssignmentTypeWeightsDocument, options);
      }
export type DeleteAssignmentTypeWeightsMutationHookResult = ReturnType<typeof useDeleteAssignmentTypeWeightsMutation>;
export type DeleteAssignmentTypeWeightsMutationResult = Apollo.MutationResult<DeleteAssignmentTypeWeightsMutation>;
export type DeleteAssignmentTypeWeightsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentTypeWeightsMutation, DeleteAssignmentTypeWeightsMutationVariables>;
export const DeleteAssignmentTypeWeightsByIdsDocument = gql`
    mutation DeleteAssignmentTypeWeightsByIds($assignmentTypeWeightsIds: [uuid!]) {
  assignmentTypeWeights: delete_assignment_type_weights(
    where: {id: {_in: $assignmentTypeWeightsIds}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentTypeWeightsByIdsMutationFn = Apollo.MutationFunction<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>;

/**
 * __useDeleteAssignmentTypeWeightsByIdsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentTypeWeightsByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentTypeWeightsByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentTypeWeightsByIdsMutation, { data, loading, error }] = useDeleteAssignmentTypeWeightsByIdsMutation({
 *   variables: {
 *      assignmentTypeWeightsIds: // value for 'assignmentTypeWeightsIds'
 *   },
 * });
 */
export function useDeleteAssignmentTypeWeightsByIdsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>(DeleteAssignmentTypeWeightsByIdsDocument, options);
      }
export type DeleteAssignmentTypeWeightsByIdsMutationHookResult = ReturnType<typeof useDeleteAssignmentTypeWeightsByIdsMutation>;
export type DeleteAssignmentTypeWeightsByIdsMutationResult = Apollo.MutationResult<DeleteAssignmentTypeWeightsByIdsMutation>;
export type DeleteAssignmentTypeWeightsByIdsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentTypeWeightsByIdsMutation, DeleteAssignmentTypeWeightsByIdsMutationVariables>;
export const DeleteAssignmentsDocument = gql`
    mutation DeleteAssignments($assignmentIds: [uuid!]) {
  assignments: delete_assignments(where: {id: {_in: $assignmentIds}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAssignmentsMutationFn = Apollo.MutationFunction<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>;

/**
 * __useDeleteAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentsMutation, { data, loading, error }] = useDeleteAssignmentsMutation({
 *   variables: {
 *      assignmentIds: // value for 'assignmentIds'
 *   },
 * });
 */
export function useDeleteAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>(DeleteAssignmentsDocument, options);
      }
export type DeleteAssignmentsMutationHookResult = ReturnType<typeof useDeleteAssignmentsMutation>;
export type DeleteAssignmentsMutationResult = Apollo.MutationResult<DeleteAssignmentsMutation>;
export type DeleteAssignmentsMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentsMutation, DeleteAssignmentsMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: uuid!) {
  comment: delete_comment(id: $commentId) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($courseId: uuid!) {
  course: delete_course(id: $courseId) {
    id
  }
}
    `;
export type DeleteCourseMutationFn = Apollo.MutationFunction<DeleteCourseMutation, DeleteCourseMutationVariables>;

/**
 * __useDeleteCourseMutation__
 *
 * To run a mutation, you first call `useDeleteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseMutation, { data, loading, error }] = useDeleteCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseMutation, DeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument, options);
      }
export type DeleteCourseMutationHookResult = ReturnType<typeof useDeleteCourseMutation>;
export type DeleteCourseMutationResult = Apollo.MutationResult<DeleteCourseMutation>;
export type DeleteCourseMutationOptions = Apollo.BaseMutationOptions<DeleteCourseMutation, DeleteCourseMutationVariables>;
export const DeleteCourseShareLinkDocument = gql`
    mutation DeleteCourseShareLink($id: uuid!) {
  delete_course_share_link(id: $id) {
    id
  }
}
    `;
export type DeleteCourseShareLinkMutationFn = Apollo.MutationFunction<DeleteCourseShareLinkMutation, DeleteCourseShareLinkMutationVariables>;

/**
 * __useDeleteCourseShareLinkMutation__
 *
 * To run a mutation, you first call `useDeleteCourseShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseShareLinkMutation, { data, loading, error }] = useDeleteCourseShareLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourseShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseShareLinkMutation, DeleteCourseShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseShareLinkMutation, DeleteCourseShareLinkMutationVariables>(DeleteCourseShareLinkDocument, options);
      }
export type DeleteCourseShareLinkMutationHookResult = ReturnType<typeof useDeleteCourseShareLinkMutation>;
export type DeleteCourseShareLinkMutationResult = Apollo.MutationResult<DeleteCourseShareLinkMutation>;
export type DeleteCourseShareLinkMutationOptions = Apollo.BaseMutationOptions<DeleteCourseShareLinkMutation, DeleteCourseShareLinkMutationVariables>;
export const DeleteCustomAssignmentTypeDocument = gql`
    mutation DeleteCustomAssignmentType($customAssignmentTypeId: uuid!) {
  customAssignmentType: delete_custom_assignment_type(id: $customAssignmentTypeId) {
    id
  }
}
    `;
export type DeleteCustomAssignmentTypeMutationFn = Apollo.MutationFunction<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>;

/**
 * __useDeleteCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomAssignmentTypeMutation, { data, loading, error }] = useDeleteCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *   },
 * });
 */
export function useDeleteCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>(DeleteCustomAssignmentTypeDocument, options);
      }
export type DeleteCustomAssignmentTypeMutationHookResult = ReturnType<typeof useDeleteCustomAssignmentTypeMutation>;
export type DeleteCustomAssignmentTypeMutationResult = Apollo.MutationResult<DeleteCustomAssignmentTypeMutation>;
export type DeleteCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCustomAssignmentTypeMutation, DeleteCustomAssignmentTypeMutationVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($eventId: uuid!, $studentAssignments: [student_assignments_insert_input!]!) {
  event: delete_event(id: $eventId) {
    ...EventInfo
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}`;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileId: uuid!) {
  file: delete_file(id: $fileId) {
    id
    size
    parrotRequestId
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const DeleteOrganizationCodeDocument = gql`
    mutation DeleteOrganizationCode($id: uuid!) {
  delete_organization_code(id: $id) {
    id
  }
}
    `;
export type DeleteOrganizationCodeMutationFn = Apollo.MutationFunction<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>;

/**
 * __useDeleteOrganizationCodeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCodeMutation, { data, loading, error }] = useDeleteOrganizationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>(DeleteOrganizationCodeDocument, options);
      }
export type DeleteOrganizationCodeMutationHookResult = ReturnType<typeof useDeleteOrganizationCodeMutation>;
export type DeleteOrganizationCodeMutationResult = Apollo.MutationResult<DeleteOrganizationCodeMutation>;
export type DeleteOrganizationCodeMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationCodeMutation, DeleteOrganizationCodeMutationVariables>;
export const DeleteOrganizationCourseGroupDocument = gql`
    mutation DeleteOrganizationCourseGroup($id: uuid!) {
  organizationCourseGroup: delete_organization_course_group(id: $id) {
    ...OrganizationCourseGroupInfo
  }
}
    ${OrganizationCourseGroupInfoFragmentDoc}`;
export type DeleteOrganizationCourseGroupMutationFn = Apollo.MutationFunction<DeleteOrganizationCourseGroupMutation, DeleteOrganizationCourseGroupMutationVariables>;

/**
 * __useDeleteOrganizationCourseGroupMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationCourseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationCourseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationCourseGroupMutation, { data, loading, error }] = useDeleteOrganizationCourseGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationCourseGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationCourseGroupMutation, DeleteOrganizationCourseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationCourseGroupMutation, DeleteOrganizationCourseGroupMutationVariables>(DeleteOrganizationCourseGroupDocument, options);
      }
export type DeleteOrganizationCourseGroupMutationHookResult = ReturnType<typeof useDeleteOrganizationCourseGroupMutation>;
export type DeleteOrganizationCourseGroupMutationResult = Apollo.MutationResult<DeleteOrganizationCourseGroupMutation>;
export type DeleteOrganizationCourseGroupMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationCourseGroupMutation, DeleteOrganizationCourseGroupMutationVariables>;
export const DeleteParrotRequestDocument = gql`
    mutation DeleteParrotRequest($requestId: uuid!, $customerId: String!, $parrotCreditsToAdd: Int!) {
  parrotRequest: delete_parrot_request(id: $requestId) {
    id
  }
  customer: update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotCreditsToAdd}
  ) {
    id
    parrotCredits
  }
}
    `;
export type DeleteParrotRequestMutationFn = Apollo.MutationFunction<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>;

/**
 * __useDeleteParrotRequestMutation__
 *
 * To run a mutation, you first call `useDeleteParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParrotRequestMutation, { data, loading, error }] = useDeleteParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      customerId: // value for 'customerId'
 *      parrotCreditsToAdd: // value for 'parrotCreditsToAdd'
 *   },
 * });
 */
export function useDeleteParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>(DeleteParrotRequestDocument, options);
      }
export type DeleteParrotRequestMutationHookResult = ReturnType<typeof useDeleteParrotRequestMutation>;
export type DeleteParrotRequestMutationResult = Apollo.MutationResult<DeleteParrotRequestMutation>;
export type DeleteParrotRequestMutationOptions = Apollo.BaseMutationOptions<DeleteParrotRequestMutation, DeleteParrotRequestMutationVariables>;
export const DeleteStudentDocument = gql`
    mutation DeleteStudent($studentId: String!) {
  student: delete_student(id: $studentId) {
    id
  }
}
    `;
export type DeleteStudentMutationFn = Apollo.MutationFunction<DeleteStudentMutation, DeleteStudentMutationVariables>;

/**
 * __useDeleteStudentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentMutation, { data, loading, error }] = useDeleteStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useDeleteStudentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentMutation, DeleteStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentMutation, DeleteStudentMutationVariables>(DeleteStudentDocument, options);
      }
export type DeleteStudentMutationHookResult = ReturnType<typeof useDeleteStudentMutation>;
export type DeleteStudentMutationResult = Apollo.MutationResult<DeleteStudentMutation>;
export type DeleteStudentMutationOptions = Apollo.BaseMutationOptions<DeleteStudentMutation, DeleteStudentMutationVariables>;
export const DeleteStudentAccountDocument = gql`
    mutation DeleteStudentAccount($studentAccountId: String!) {
  studentAccount: delete_student_account(id: $studentAccountId) {
    id
  }
}
    `;
export type DeleteStudentAccountMutationFn = Apollo.MutationFunction<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>;

/**
 * __useDeleteStudentAccountMutation__
 *
 * To run a mutation, you first call `useDeleteStudentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentAccountMutation, { data, loading, error }] = useDeleteStudentAccountMutation({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useDeleteStudentAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>(DeleteStudentAccountDocument, options);
      }
export type DeleteStudentAccountMutationHookResult = ReturnType<typeof useDeleteStudentAccountMutation>;
export type DeleteStudentAccountMutationResult = Apollo.MutationResult<DeleteStudentAccountMutation>;
export type DeleteStudentAccountMutationOptions = Apollo.BaseMutationOptions<DeleteStudentAccountMutation, DeleteStudentAccountMutationVariables>;
export const DeleteStudentAssignmentDocument = gql`
    mutation DeleteStudentAssignment($studentAssignmentId: uuid!) {
  studentAssignment: delete_student_assignment(id: $studentAssignmentId) {
    id
  }
}
    `;
export type DeleteStudentAssignmentMutationFn = Apollo.MutationFunction<DeleteStudentAssignmentMutation, DeleteStudentAssignmentMutationVariables>;

/**
 * __useDeleteStudentAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentAssignmentMutation, { data, loading, error }] = useDeleteStudentAssignmentMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *   },
 * });
 */
export function useDeleteStudentAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentAssignmentMutation, DeleteStudentAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentAssignmentMutation, DeleteStudentAssignmentMutationVariables>(DeleteStudentAssignmentDocument, options);
      }
export type DeleteStudentAssignmentMutationHookResult = ReturnType<typeof useDeleteStudentAssignmentMutation>;
export type DeleteStudentAssignmentMutationResult = Apollo.MutationResult<DeleteStudentAssignmentMutation>;
export type DeleteStudentAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteStudentAssignmentMutation, DeleteStudentAssignmentMutationVariables>;
export const DeleteStudentCourseDocument = gql`
    mutation DeleteStudentCourse($studentCourseId: uuid!) {
  studentCourse: delete_student_course(id: $studentCourseId) {
    id
  }
}
    `;
export type DeleteStudentCourseMutationFn = Apollo.MutationFunction<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>;

/**
 * __useDeleteStudentCourseMutation__
 *
 * To run a mutation, you first call `useDeleteStudentCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudentCourseMutation, { data, loading, error }] = useDeleteStudentCourseMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useDeleteStudentCourseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>(DeleteStudentCourseDocument, options);
      }
export type DeleteStudentCourseMutationHookResult = ReturnType<typeof useDeleteStudentCourseMutation>;
export type DeleteStudentCourseMutationResult = Apollo.MutationResult<DeleteStudentCourseMutation>;
export type DeleteStudentCourseMutationOptions = Apollo.BaseMutationOptions<DeleteStudentCourseMutation, DeleteStudentCourseMutationVariables>;
export const DeleteThemeDocument = gql`
    mutation DeleteTheme($themeId: uuid!) {
  delete_themes_by_pk(id: $themeId) {
    id
  }
}
    `;
export type DeleteThemeMutationFn = Apollo.MutationFunction<DeleteThemeMutation, DeleteThemeMutationVariables>;

/**
 * __useDeleteThemeMutation__
 *
 * To run a mutation, you first call `useDeleteThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThemeMutation, { data, loading, error }] = useDeleteThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useDeleteThemeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThemeMutation, DeleteThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThemeMutation, DeleteThemeMutationVariables>(DeleteThemeDocument, options);
      }
export type DeleteThemeMutationHookResult = ReturnType<typeof useDeleteThemeMutation>;
export type DeleteThemeMutationResult = Apollo.MutationResult<DeleteThemeMutation>;
export type DeleteThemeMutationOptions = Apollo.BaseMutationOptions<DeleteThemeMutation, DeleteThemeMutationVariables>;
export const EnrollStudentInCourseDocument = gql`
    mutation EnrollStudentInCourse($studentId: String!, $courseId: uuid!, $start: date!, $end: date!, $daysOfTheWeek: jsonb!, $studentAssignments: [student_assignments_insert_input!]!) {
  studentCourse: insert_student_course(
    object: {studentId: $studentId, courseId: $courseId, start: $start, end: $end, daysOfTheWeek: $daysOfTheWeek, status: ENROLLED, studentAssignments: {data: $studentAssignments}}
  ) {
    ...StudentCourseInfo
    ...ActiveStudentCourseCardInfo
    ...ActiveStudentCoursesInfo
    ...CourseStudentCardInfo
    ...RequiredStudentCourseInfo
    ...PlanningStudentCourse
  }
}
    ${StudentCourseInfoFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${ActiveStudentCourseCardInfoFragmentDoc}
${ActiveStudentCoursesInfoFragmentDoc}
${StudentsEventsFragmentDoc}
${CourseStudentCardInfoFragmentDoc}
${RequiredStudentCourseInfoFragmentDoc}
${PlanningStudentCourseFragmentDoc}`;
export type EnrollStudentInCourseMutationFn = Apollo.MutationFunction<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>;

/**
 * __useEnrollStudentInCourseMutation__
 *
 * To run a mutation, you first call `useEnrollStudentInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollStudentInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollStudentInCourseMutation, { data, loading, error }] = useEnrollStudentInCourseMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      daysOfTheWeek: // value for 'daysOfTheWeek'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useEnrollStudentInCourseMutation(baseOptions?: Apollo.MutationHookOptions<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>(EnrollStudentInCourseDocument, options);
      }
export type EnrollStudentInCourseMutationHookResult = ReturnType<typeof useEnrollStudentInCourseMutation>;
export type EnrollStudentInCourseMutationResult = Apollo.MutationResult<EnrollStudentInCourseMutation>;
export type EnrollStudentInCourseMutationOptions = Apollo.BaseMutationOptions<EnrollStudentInCourseMutation, EnrollStudentInCourseMutationVariables>;
export const EnrollStudentInCoursesDocument = gql`
    mutation EnrollStudentInCourses($studentCourses: [student_courses_insert_input!]!) {
  studentCourses: insert_student_courses(objects: $studentCourses) {
    returning {
      id
    }
  }
}
    `;
export type EnrollStudentInCoursesMutationFn = Apollo.MutationFunction<EnrollStudentInCoursesMutation, EnrollStudentInCoursesMutationVariables>;

/**
 * __useEnrollStudentInCoursesMutation__
 *
 * To run a mutation, you first call `useEnrollStudentInCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollStudentInCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollStudentInCoursesMutation, { data, loading, error }] = useEnrollStudentInCoursesMutation({
 *   variables: {
 *      studentCourses: // value for 'studentCourses'
 *   },
 * });
 */
export function useEnrollStudentInCoursesMutation(baseOptions?: Apollo.MutationHookOptions<EnrollStudentInCoursesMutation, EnrollStudentInCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollStudentInCoursesMutation, EnrollStudentInCoursesMutationVariables>(EnrollStudentInCoursesDocument, options);
      }
export type EnrollStudentInCoursesMutationHookResult = ReturnType<typeof useEnrollStudentInCoursesMutation>;
export type EnrollStudentInCoursesMutationResult = Apollo.MutationResult<EnrollStudentInCoursesMutation>;
export type EnrollStudentInCoursesMutationOptions = Apollo.BaseMutationOptions<EnrollStudentInCoursesMutation, EnrollStudentInCoursesMutationVariables>;
export const RevokeOrganizationCodeDocument = gql`
    mutation RevokeOrganizationCode($organizationCodeId: uuid!, $teacherId: String!, $organizationId: uuid!) {
  delete_organization_code(id: $organizationCodeId) {
    id
  }
  update_customers(
    where: {teacherId: {_eq: $teacherId}}
    _set: {subscriptionStatus: "expired_trial", organizationSubscriptionExpiration: null}
  ) {
    returning {
      id
      subscriptionStatus
      organizationSubscriptionExpiration
    }
  }
  update_user_settings(
    where: {teachers: {id: {_eq: $teacherId}}, selectedTheme: {organizationId: {_eq: $organizationId}}}
    _set: {selectedThemeId: null}
  ) {
    affected_rows
  }
  update_teacher(pk_columns: {id: $teacherId}, _set: {organizationId: null}) {
    id
    organizationId
  }
  delete_organization_course_groups_teachers(
    where: {_and: [{teacherId: {_eq: $teacherId}}, {organizationCourseGroup: {organizationId: {_eq: $organizationId}}}]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type RevokeOrganizationCodeMutationFn = Apollo.MutationFunction<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>;

/**
 * __useRevokeOrganizationCodeMutation__
 *
 * To run a mutation, you first call `useRevokeOrganizationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrganizationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrganizationCodeMutation, { data, loading, error }] = useRevokeOrganizationCodeMutation({
 *   variables: {
 *      organizationCodeId: // value for 'organizationCodeId'
 *      teacherId: // value for 'teacherId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRevokeOrganizationCodeMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>(RevokeOrganizationCodeDocument, options);
      }
export type RevokeOrganizationCodeMutationHookResult = ReturnType<typeof useRevokeOrganizationCodeMutation>;
export type RevokeOrganizationCodeMutationResult = Apollo.MutationResult<RevokeOrganizationCodeMutation>;
export type RevokeOrganizationCodeMutationOptions = Apollo.BaseMutationOptions<RevokeOrganizationCodeMutation, RevokeOrganizationCodeMutationVariables>;
export const SetCourseArchiveStatusDocument = gql`
    mutation SetCourseArchiveStatus($courseId: uuid!, $archived: Boolean!) {
  course: update_course(_set: {archived: $archived}, pk_columns: {id: $courseId}) {
    id
    archived
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    subjects
    labels
    defaultDaysOfTheWeek
    assignments {
      ...CoursePlanCardAssignment
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;
export type SetCourseArchiveStatusMutationFn = Apollo.MutationFunction<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>;

/**
 * __useSetCourseArchiveStatusMutation__
 *
 * To run a mutation, you first call `useSetCourseArchiveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCourseArchiveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCourseArchiveStatusMutation, { data, loading, error }] = useSetCourseArchiveStatusMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetCourseArchiveStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>(SetCourseArchiveStatusDocument, options);
      }
export type SetCourseArchiveStatusMutationHookResult = ReturnType<typeof useSetCourseArchiveStatusMutation>;
export type SetCourseArchiveStatusMutationResult = Apollo.MutationResult<SetCourseArchiveStatusMutation>;
export type SetCourseArchiveStatusMutationOptions = Apollo.BaseMutationOptions<SetCourseArchiveStatusMutation, SetCourseArchiveStatusMutationVariables>;
export const SetPrimaryThemeDocument = gql`
    mutation SetPrimaryTheme($organizationId: uuid!, $themeId: uuid!) {
  setNew: update_themes_by_pk(pk_columns: {id: $themeId}, _set: {isPrimary: true}) {
    id
    isPrimary
  }
  clearExisting: update_themes(
    where: {organizationId: {_eq: $organizationId}, id: {_neq: $themeId}}
    _set: {isPrimary: false}
  ) {
    affected_rows
  }
}
    `;
export type SetPrimaryThemeMutationFn = Apollo.MutationFunction<SetPrimaryThemeMutation, SetPrimaryThemeMutationVariables>;

/**
 * __useSetPrimaryThemeMutation__
 *
 * To run a mutation, you first call `useSetPrimaryThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryThemeMutation, { data, loading, error }] = useSetPrimaryThemeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useSetPrimaryThemeMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryThemeMutation, SetPrimaryThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryThemeMutation, SetPrimaryThemeMutationVariables>(SetPrimaryThemeDocument, options);
      }
export type SetPrimaryThemeMutationHookResult = ReturnType<typeof useSetPrimaryThemeMutation>;
export type SetPrimaryThemeMutationResult = Apollo.MutationResult<SetPrimaryThemeMutation>;
export type SetPrimaryThemeMutationOptions = Apollo.BaseMutationOptions<SetPrimaryThemeMutation, SetPrimaryThemeMutationVariables>;
export const SetTeacherHasDemoDataDocument = gql`
    mutation SetTeacherHasDemoData($teacherId: String!) {
  update_teacher(_set: {needsDemoData: false}, pk_columns: {id: $teacherId}) {
    id
    needsDemoData
  }
}
    `;
export type SetTeacherHasDemoDataMutationFn = Apollo.MutationFunction<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>;

/**
 * __useSetTeacherHasDemoDataMutation__
 *
 * To run a mutation, you first call `useSetTeacherHasDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeacherHasDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeacherHasDemoDataMutation, { data, loading, error }] = useSetTeacherHasDemoDataMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useSetTeacherHasDemoDataMutation(baseOptions?: Apollo.MutationHookOptions<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>(SetTeacherHasDemoDataDocument, options);
      }
export type SetTeacherHasDemoDataMutationHookResult = ReturnType<typeof useSetTeacherHasDemoDataMutation>;
export type SetTeacherHasDemoDataMutationResult = Apollo.MutationResult<SetTeacherHasDemoDataMutation>;
export type SetTeacherHasDemoDataMutationOptions = Apollo.BaseMutationOptions<SetTeacherHasDemoDataMutation, SetTeacherHasDemoDataMutationVariables>;
export const UnscheduleCourseAssignmentsDocument = gql`
    mutation UnscheduleCourseAssignments($assignments: [assignments_insert_input!]!) {
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [day, week]}
  ) {
    returning {
      id
      day
      week
    }
  }
}
    `;
export type UnscheduleCourseAssignmentsMutationFn = Apollo.MutationFunction<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>;

/**
 * __useUnscheduleCourseAssignmentsMutation__
 *
 * To run a mutation, you first call `useUnscheduleCourseAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleCourseAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleCourseAssignmentsMutation, { data, loading, error }] = useUnscheduleCourseAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useUnscheduleCourseAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>(UnscheduleCourseAssignmentsDocument, options);
      }
export type UnscheduleCourseAssignmentsMutationHookResult = ReturnType<typeof useUnscheduleCourseAssignmentsMutation>;
export type UnscheduleCourseAssignmentsMutationResult = Apollo.MutationResult<UnscheduleCourseAssignmentsMutation>;
export type UnscheduleCourseAssignmentsMutationOptions = Apollo.BaseMutationOptions<UnscheduleCourseAssignmentsMutation, UnscheduleCourseAssignmentsMutationVariables>;
export const UnscheduleCourseAndStudentCourseAssignmentsDocument = gql`
    mutation UnscheduleCourseAndStudentCourseAssignments($assignments: [assignments_insert_input!]!, $courseId: uuid!, $maxDay: Int!, $maxWeek: Int!, $studentAssignments: [student_assignments_insert_input!]!, $studentCourses: [student_courses_insert_input!]!) {
  update_student_assignments(
    where: {_and: [{assignment: {courseId: {_eq: $courseId}}}, {freeForm: {_eq: false}}, {_or: [{assignment: {day: {_gt: $maxDay}}}, {assignment: {week: {_gt: $maxWeek}}}]}]}
    _set: {start: null, end: null, courseDayOffset: 0}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [day, week]}
  ) {
    returning {
      id
      day
      week
    }
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
  insert_student_courses(
    objects: $studentCourses
    on_conflict: {constraint: student_courses_pkey, update_columns: [courseDayOffsets, daysOfTheWeek]}
  ) {
    returning {
      id
      courseDayOffsets
      daysOfTheWeek
    }
  }
}
    `;
export type UnscheduleCourseAndStudentCourseAssignmentsMutationFn = Apollo.MutationFunction<UnscheduleCourseAndStudentCourseAssignmentsMutation, UnscheduleCourseAndStudentCourseAssignmentsMutationVariables>;

/**
 * __useUnscheduleCourseAndStudentCourseAssignmentsMutation__
 *
 * To run a mutation, you first call `useUnscheduleCourseAndStudentCourseAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleCourseAndStudentCourseAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleCourseAndStudentCourseAssignmentsMutation, { data, loading, error }] = useUnscheduleCourseAndStudentCourseAssignmentsMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *      courseId: // value for 'courseId'
 *      maxDay: // value for 'maxDay'
 *      maxWeek: // value for 'maxWeek'
 *      studentAssignments: // value for 'studentAssignments'
 *      studentCourses: // value for 'studentCourses'
 *   },
 * });
 */
export function useUnscheduleCourseAndStudentCourseAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleCourseAndStudentCourseAssignmentsMutation, UnscheduleCourseAndStudentCourseAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleCourseAndStudentCourseAssignmentsMutation, UnscheduleCourseAndStudentCourseAssignmentsMutationVariables>(UnscheduleCourseAndStudentCourseAssignmentsDocument, options);
      }
export type UnscheduleCourseAndStudentCourseAssignmentsMutationHookResult = ReturnType<typeof useUnscheduleCourseAndStudentCourseAssignmentsMutation>;
export type UnscheduleCourseAndStudentCourseAssignmentsMutationResult = Apollo.MutationResult<UnscheduleCourseAndStudentCourseAssignmentsMutation>;
export type UnscheduleCourseAndStudentCourseAssignmentsMutationOptions = Apollo.BaseMutationOptions<UnscheduleCourseAndStudentCourseAssignmentsMutation, UnscheduleCourseAndStudentCourseAssignmentsMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation UpdateAssignment($assignmentId: uuid!, $name: String!, $description: String, $teachersNote: String, $duration: Int!, $graded: Boolean!, $day: Int, $week: Int, $customAssignmentTypeId: uuid, $includeStudentData: Boolean = true) {
  assignment: update_assignment(
    _set: {name: $name, description: $description, teachersNote: $teachersNote, duration: $duration, graded: $graded, day: $day, week: $week, customAssignmentTypeId: $customAssignmentTypeId}
    pk_columns: {id: $assignmentId}
  ) {
    ...AssignmentInfo
  }
}
    ${AssignmentInfoFragmentDoc}
${PlanningAssignmentFragmentDoc}
${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      teachersNote: // value for 'teachersNote'
 *      duration: // value for 'duration'
 *      graded: // value for 'graded'
 *      day: // value for 'day'
 *      week: // value for 'week'
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const UpdateAssignmentDayWeekDocument = gql`
    mutation UpdateAssignmentDayWeek($assignments: [assignments_insert_input!]!, $includeStudentData: Boolean = true) {
  insert_assignments(
    objects: $assignments
    on_conflict: {constraint: assignments_pkey, update_columns: [day, week]}
  ) {
    returning {
      id
      day
      week
      studentAssignments @include(if: $includeStudentData) {
        id
        student {
          id
        }
      }
    }
  }
}
    `;
export type UpdateAssignmentDayWeekMutationFn = Apollo.MutationFunction<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>;

/**
 * __useUpdateAssignmentDayWeekMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentDayWeekMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentDayWeekMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentDayWeekMutation, { data, loading, error }] = useUpdateAssignmentDayWeekMutation({
 *   variables: {
 *      assignments: // value for 'assignments'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useUpdateAssignmentDayWeekMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>(UpdateAssignmentDayWeekDocument, options);
      }
export type UpdateAssignmentDayWeekMutationHookResult = ReturnType<typeof useUpdateAssignmentDayWeekMutation>;
export type UpdateAssignmentDayWeekMutationResult = Apollo.MutationResult<UpdateAssignmentDayWeekMutation>;
export type UpdateAssignmentDayWeekMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentDayWeekMutation, UpdateAssignmentDayWeekMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($courseId: uuid!, $name: String, $subjects: jsonb, $labels: jsonb, $gradeYears: jsonb, $numberOfWeeks: Int, $numberOfDaysPerWeek: Int, $defaultDaysOfTheWeek: jsonb, $description: String, $introduction: String, $gradingStyle: grading_style_enum!, $credits: numeric, $color: String!, $useAssignmentTypeWeights: Boolean, $assignmentTypeWeights: [assignment_type_weights_insert_input!]!, $organizationCourseGroupsToAdd: [organization_course_groups_courses_insert_input!]!, $organizationCourseGroupIdsToRemove: [uuid!], $isOrgAdmin: Boolean!) {
  delete_organization_course_groups_courses(
    where: {courseId: {_eq: $courseId}, organizationCourseGroupId: {_in: $organizationCourseGroupIdsToRemove}}
  ) @include(if: $isOrgAdmin) {
    returning {
      id
    }
  }
  insert_organization_course_groups_courses(
    objects: $organizationCourseGroupsToAdd
  ) @include(if: $isOrgAdmin) {
    returning {
      id
      organizationCourseGroup {
        ...OrganizationCourseGroupInfo
      }
    }
  }
  update_course(
    _set: {name: $name, subjects: $subjects, labels: $labels, gradeYears: $gradeYears, numberOfWeeks: $numberOfWeeks, numberOfDaysPerWeek: $numberOfDaysPerWeek, defaultDaysOfTheWeek: $defaultDaysOfTheWeek, description: $description, introduction: $introduction, gradingStyle: $gradingStyle, credits: $credits, color: $color, useAssignmentTypeWeights: $useAssignmentTypeWeights}
    pk_columns: {id: $courseId}
  ) {
    id
    name
    subjects
    labels
    gradeYears
    numberOfWeeks
    numberOfDaysPerWeek
    defaultDaysOfTheWeek
    description
    introduction
    gradingStyle
    credits
    color
    useAssignmentTypeWeights
    organizationCourseGroups @include(if: $isOrgAdmin) {
      organizationCourseGroup {
        ...OrganizationCourseGroupInfo
      }
    }
  }
  insert_assignment_type_weights(
    objects: $assignmentTypeWeights
    on_conflict: {constraint: assignment_type_weights_pkey, update_columns: [weight, sortOrder]}
  ) {
    returning {
      ...AssignmentTypeWeightInfo
      course {
        id
      }
    }
  }
}
    ${OrganizationCourseGroupInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      name: // value for 'name'
 *      subjects: // value for 'subjects'
 *      labels: // value for 'labels'
 *      gradeYears: // value for 'gradeYears'
 *      numberOfWeeks: // value for 'numberOfWeeks'
 *      numberOfDaysPerWeek: // value for 'numberOfDaysPerWeek'
 *      defaultDaysOfTheWeek: // value for 'defaultDaysOfTheWeek'
 *      description: // value for 'description'
 *      introduction: // value for 'introduction'
 *      gradingStyle: // value for 'gradingStyle'
 *      credits: // value for 'credits'
 *      color: // value for 'color'
 *      useAssignmentTypeWeights: // value for 'useAssignmentTypeWeights'
 *      assignmentTypeWeights: // value for 'assignmentTypeWeights'
 *      organizationCourseGroupsToAdd: // value for 'organizationCourseGroupsToAdd'
 *      organizationCourseGroupIdsToRemove: // value for 'organizationCourseGroupIdsToRemove'
 *      isOrgAdmin: // value for 'isOrgAdmin'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const UpdateCoursePictureDocument = gql`
    mutation UpdateCoursePicture($courseId: uuid!, $picture: String) {
  update_course(_set: {picture: $picture}, pk_columns: {id: $courseId}) {
    id
    picture
  }
}
    `;
export type UpdateCoursePictureMutationFn = Apollo.MutationFunction<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>;

/**
 * __useUpdateCoursePictureMutation__
 *
 * To run a mutation, you first call `useUpdateCoursePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoursePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoursePictureMutation, { data, loading, error }] = useUpdateCoursePictureMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateCoursePictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>(UpdateCoursePictureDocument, options);
      }
export type UpdateCoursePictureMutationHookResult = ReturnType<typeof useUpdateCoursePictureMutation>;
export type UpdateCoursePictureMutationResult = Apollo.MutationResult<UpdateCoursePictureMutation>;
export type UpdateCoursePictureMutationOptions = Apollo.BaseMutationOptions<UpdateCoursePictureMutation, UpdateCoursePictureMutationVariables>;
export const UpdateCustomAssignmentTypeDocument = gql`
    mutation UpdateCustomAssignmentType($customAssignmentTypeId: uuid!, $name: String!, $color: String!, $hidden: Boolean!) {
  customAssignmentType: update_custom_assignment_type(
    _set: {name: $name, color: $color, hidden: $hidden}
    pk_columns: {id: $customAssignmentTypeId}
  ) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type UpdateCustomAssignmentTypeMutationFn = Apollo.MutationFunction<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>;

/**
 * __useUpdateCustomAssignmentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAssignmentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAssignmentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAssignmentTypeMutation, { data, loading, error }] = useUpdateCustomAssignmentTypeMutation({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useUpdateCustomAssignmentTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>(UpdateCustomAssignmentTypeDocument, options);
      }
export type UpdateCustomAssignmentTypeMutationHookResult = ReturnType<typeof useUpdateCustomAssignmentTypeMutation>;
export type UpdateCustomAssignmentTypeMutationResult = Apollo.MutationResult<UpdateCustomAssignmentTypeMutation>;
export type UpdateCustomAssignmentTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAssignmentTypeMutation, UpdateCustomAssignmentTypeMutationVariables>;
export const UpdateCustomAssignmentTypesSortOrderDocument = gql`
    mutation UpdateCustomAssignmentTypesSortOrder($updates: [custom_assignment_types_updates!]!) {
  update_custom_assignment_types_many(updates: $updates) {
    __typename
    affected_rows
    returning {
      __typename
      ...CustomAssignmentType
    }
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;
export type UpdateCustomAssignmentTypesSortOrderMutationFn = Apollo.MutationFunction<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>;

/**
 * __useUpdateCustomAssignmentTypesSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAssignmentTypesSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAssignmentTypesSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAssignmentTypesSortOrderMutation, { data, loading, error }] = useUpdateCustomAssignmentTypesSortOrderMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateCustomAssignmentTypesSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>(UpdateCustomAssignmentTypesSortOrderDocument, options);
      }
export type UpdateCustomAssignmentTypesSortOrderMutationHookResult = ReturnType<typeof useUpdateCustomAssignmentTypesSortOrderMutation>;
export type UpdateCustomAssignmentTypesSortOrderMutationResult = Apollo.MutationResult<UpdateCustomAssignmentTypesSortOrderMutation>;
export type UpdateCustomAssignmentTypesSortOrderMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAssignmentTypesSortOrderMutation, UpdateCustomAssignmentTypesSortOrderMutationVariables>;
export const UpdateOrganizationAdminDocument = gql`
    mutation UpdateOrganizationAdmin($organizationAdminId: String!, $email: String!) {
  update_organization_admin(
    _set: {email: $email}
    pk_columns: {id: $organizationAdminId}
  ) {
    ...OrganizationAdminInfo
  }
}
    ${OrganizationAdminInfoFragmentDoc}
${OrganizationFragmentDoc}`;
export type UpdateOrganizationAdminMutationFn = Apollo.MutationFunction<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;

/**
 * __useUpdateOrganizationAdminMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAdminMutation, { data, loading, error }] = useUpdateOrganizationAdminMutation({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateOrganizationAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>(UpdateOrganizationAdminDocument, options);
      }
export type UpdateOrganizationAdminMutationHookResult = ReturnType<typeof useUpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationResult = Apollo.MutationResult<UpdateOrganizationAdminMutation>;
export type UpdateOrganizationAdminMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAdminMutation, UpdateOrganizationAdminMutationVariables>;
export const UpdateOrganizationAllowDefaultSyllabirdThemesDocument = gql`
    mutation UpdateOrganizationAllowDefaultSyllabirdThemes($organizationId: uuid!, $allowDefaultSyllabirdThemes: Boolean!) {
  update_organization(
    pk_columns: {id: $organizationId}
    _set: {allowDefaultSyllabirdThemes: $allowDefaultSyllabirdThemes}
  ) {
    id
    allowDefaultSyllabirdThemes
  }
}
    `;
export type UpdateOrganizationAllowDefaultSyllabirdThemesMutationFn = Apollo.MutationFunction<UpdateOrganizationAllowDefaultSyllabirdThemesMutation, UpdateOrganizationAllowDefaultSyllabirdThemesMutationVariables>;

/**
 * __useUpdateOrganizationAllowDefaultSyllabirdThemesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAllowDefaultSyllabirdThemesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAllowDefaultSyllabirdThemesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAllowDefaultSyllabirdThemesMutation, { data, loading, error }] = useUpdateOrganizationAllowDefaultSyllabirdThemesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      allowDefaultSyllabirdThemes: // value for 'allowDefaultSyllabirdThemes'
 *   },
 * });
 */
export function useUpdateOrganizationAllowDefaultSyllabirdThemesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAllowDefaultSyllabirdThemesMutation, UpdateOrganizationAllowDefaultSyllabirdThemesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAllowDefaultSyllabirdThemesMutation, UpdateOrganizationAllowDefaultSyllabirdThemesMutationVariables>(UpdateOrganizationAllowDefaultSyllabirdThemesDocument, options);
      }
export type UpdateOrganizationAllowDefaultSyllabirdThemesMutationHookResult = ReturnType<typeof useUpdateOrganizationAllowDefaultSyllabirdThemesMutation>;
export type UpdateOrganizationAllowDefaultSyllabirdThemesMutationResult = Apollo.MutationResult<UpdateOrganizationAllowDefaultSyllabirdThemesMutation>;
export type UpdateOrganizationAllowDefaultSyllabirdThemesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAllowDefaultSyllabirdThemesMutation, UpdateOrganizationAllowDefaultSyllabirdThemesMutationVariables>;
export const UpdateOrganizationCourseGroupDocument = gql`
    mutation UpdateOrganizationCourseGroup($id: uuid!, $name: String!, $description: String, $releaseDate: timestamptz, $expirationDate: timestamptz, $public: Boolean, $default: Boolean) {
  organizationCourseGroup: update_organization_course_group(
    pk_columns: {id: $id}
    _set: {name: $name, description: $description, releaseDate: $releaseDate, expirationDate: $expirationDate, public: $public, default: $default}
  ) {
    ...OrganizationCourseGroupInfo
    public
  }
}
    ${OrganizationCourseGroupInfoFragmentDoc}`;
export type UpdateOrganizationCourseGroupMutationFn = Apollo.MutationFunction<UpdateOrganizationCourseGroupMutation, UpdateOrganizationCourseGroupMutationVariables>;

/**
 * __useUpdateOrganizationCourseGroupMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationCourseGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationCourseGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationCourseGroupMutation, { data, loading, error }] = useUpdateOrganizationCourseGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      releaseDate: // value for 'releaseDate'
 *      expirationDate: // value for 'expirationDate'
 *      public: // value for 'public'
 *      default: // value for 'default'
 *   },
 * });
 */
export function useUpdateOrganizationCourseGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationCourseGroupMutation, UpdateOrganizationCourseGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationCourseGroupMutation, UpdateOrganizationCourseGroupMutationVariables>(UpdateOrganizationCourseGroupDocument, options);
      }
export type UpdateOrganizationCourseGroupMutationHookResult = ReturnType<typeof useUpdateOrganizationCourseGroupMutation>;
export type UpdateOrganizationCourseGroupMutationResult = Apollo.MutationResult<UpdateOrganizationCourseGroupMutation>;
export type UpdateOrganizationCourseGroupMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationCourseGroupMutation, UpdateOrganizationCourseGroupMutationVariables>;
export const UpdateOrganizationMemberCodeDocument = gql`
    mutation UpdateOrganizationMemberCode($codeId: uuid!, $originalUserEmail: String, $subscriptionExpiration: timestamptz, $organizationCourseGroupsToAdd: [organization_course_groups_organization_codes_insert_input!]!, $organizationCourseGroupsToRemove: [uuid!]!) {
  update_organization_code(
    _set: {originalUserEmail: $originalUserEmail, subscriptionExpiration: $subscriptionExpiration}
    pk_columns: {id: $codeId}
  ) {
    id
    originalUserEmail
    subscriptionExpiration
  }
  delete_organization_course_groups_organization_codes(
    where: {organizationCodeId: {_eq: $codeId}, organizationCourseGroupId: {_in: $organizationCourseGroupsToRemove}}
  ) {
    returning {
      id
    }
  }
  insert_organization_course_groups_organization_codes(
    objects: $organizationCourseGroupsToAdd
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateOrganizationMemberCodeMutationFn = Apollo.MutationFunction<UpdateOrganizationMemberCodeMutation, UpdateOrganizationMemberCodeMutationVariables>;

/**
 * __useUpdateOrganizationMemberCodeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMemberCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMemberCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMemberCodeMutation, { data, loading, error }] = useUpdateOrganizationMemberCodeMutation({
 *   variables: {
 *      codeId: // value for 'codeId'
 *      originalUserEmail: // value for 'originalUserEmail'
 *      subscriptionExpiration: // value for 'subscriptionExpiration'
 *      organizationCourseGroupsToAdd: // value for 'organizationCourseGroupsToAdd'
 *      organizationCourseGroupsToRemove: // value for 'organizationCourseGroupsToRemove'
 *   },
 * });
 */
export function useUpdateOrganizationMemberCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMemberCodeMutation, UpdateOrganizationMemberCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMemberCodeMutation, UpdateOrganizationMemberCodeMutationVariables>(UpdateOrganizationMemberCodeDocument, options);
      }
export type UpdateOrganizationMemberCodeMutationHookResult = ReturnType<typeof useUpdateOrganizationMemberCodeMutation>;
export type UpdateOrganizationMemberCodeMutationResult = Apollo.MutationResult<UpdateOrganizationMemberCodeMutation>;
export type UpdateOrganizationMemberCodeMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMemberCodeMutation, UpdateOrganizationMemberCodeMutationVariables>;
export const UpdateOrganizationMemberTeacherDocument = gql`
    mutation UpdateOrganizationMemberTeacher($codeId: uuid!, $teacherId: String!, $originalUserEmail: String, $subscriptionExpiration: timestamptz, $organizationCourseGroupsToAdd: [organization_course_groups_teachers_insert_input!]!, $organizationCourseGroupsToRemove: [uuid!]!, $subscriptionStatus: String!) {
  update_organization_code(
    _set: {originalUserEmail: $originalUserEmail, subscriptionExpiration: $subscriptionExpiration}
    pk_columns: {id: $codeId}
  ) {
    id
    originalUserEmail
    subscriptionExpiration
  }
  update_customers(
    where: {teacherId: {_eq: $teacherId}}
    _set: {organizationSubscriptionExpiration: $subscriptionExpiration, subscriptionStatus: $subscriptionStatus}
  ) {
    returning {
      id
      teacherId
      organizationSubscriptionExpiration
    }
  }
  delete_organization_course_groups_teachers(
    where: {teacherId: {_eq: $teacherId}, organizationCourseGroupId: {_in: $organizationCourseGroupsToRemove}}
  ) {
    returning {
      id
    }
  }
  insert_organization_course_groups_teachers(
    objects: $organizationCourseGroupsToAdd
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateOrganizationMemberTeacherMutationFn = Apollo.MutationFunction<UpdateOrganizationMemberTeacherMutation, UpdateOrganizationMemberTeacherMutationVariables>;

/**
 * __useUpdateOrganizationMemberTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMemberTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMemberTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMemberTeacherMutation, { data, loading, error }] = useUpdateOrganizationMemberTeacherMutation({
 *   variables: {
 *      codeId: // value for 'codeId'
 *      teacherId: // value for 'teacherId'
 *      originalUserEmail: // value for 'originalUserEmail'
 *      subscriptionExpiration: // value for 'subscriptionExpiration'
 *      organizationCourseGroupsToAdd: // value for 'organizationCourseGroupsToAdd'
 *      organizationCourseGroupsToRemove: // value for 'organizationCourseGroupsToRemove'
 *      subscriptionStatus: // value for 'subscriptionStatus'
 *   },
 * });
 */
export function useUpdateOrganizationMemberTeacherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMemberTeacherMutation, UpdateOrganizationMemberTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMemberTeacherMutation, UpdateOrganizationMemberTeacherMutationVariables>(UpdateOrganizationMemberTeacherDocument, options);
      }
export type UpdateOrganizationMemberTeacherMutationHookResult = ReturnType<typeof useUpdateOrganizationMemberTeacherMutation>;
export type UpdateOrganizationMemberTeacherMutationResult = Apollo.MutationResult<UpdateOrganizationMemberTeacherMutation>;
export type UpdateOrganizationMemberTeacherMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMemberTeacherMutation, UpdateOrganizationMemberTeacherMutationVariables>;
export const UpdateParrotRequestDocument = gql`
    mutation UpdateParrotRequest($requestId: uuid!, $customerId: String!, $startWeek: Int!, $endWeek: Int!, $userNotes: String, $parrotCreditsDifference: Int!) {
  update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {startWeek: $startWeek, endWeek: $endWeek, userNotes: $userNotes}
  ) {
    ...ParrotRequestInfo
  }
  update_customer(
    pk_columns: {id: $customerId}
    _inc: {parrotCredits: $parrotCreditsDifference}
  ) {
    id
    parrotCredits
  }
}
    ${ParrotRequestInfoFragmentDoc}`;
export type UpdateParrotRequestMutationFn = Apollo.MutationFunction<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>;

/**
 * __useUpdateParrotRequestMutation__
 *
 * To run a mutation, you first call `useUpdateParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParrotRequestMutation, { data, loading, error }] = useUpdateParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      customerId: // value for 'customerId'
 *      startWeek: // value for 'startWeek'
 *      endWeek: // value for 'endWeek'
 *      userNotes: // value for 'userNotes'
 *      parrotCreditsDifference: // value for 'parrotCreditsDifference'
 *   },
 * });
 */
export function useUpdateParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>(UpdateParrotRequestDocument, options);
      }
export type UpdateParrotRequestMutationHookResult = ReturnType<typeof useUpdateParrotRequestMutation>;
export type UpdateParrotRequestMutationResult = Apollo.MutationResult<UpdateParrotRequestMutation>;
export type UpdateParrotRequestMutationOptions = Apollo.BaseMutationOptions<UpdateParrotRequestMutation, UpdateParrotRequestMutationVariables>;
export const SetParrotRequestStatusDocument = gql`
    mutation SetParrotRequestStatus($requestId: uuid!, $status: parrot_request_status_enum!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: $status}
  ) {
    id
    status
  }
}
    `;
export type SetParrotRequestStatusMutationFn = Apollo.MutationFunction<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>;

/**
 * __useSetParrotRequestStatusMutation__
 *
 * To run a mutation, you first call `useSetParrotRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetParrotRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setParrotRequestStatusMutation, { data, loading, error }] = useSetParrotRequestStatusMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetParrotRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>(SetParrotRequestStatusDocument, options);
      }
export type SetParrotRequestStatusMutationHookResult = ReturnType<typeof useSetParrotRequestStatusMutation>;
export type SetParrotRequestStatusMutationResult = Apollo.MutationResult<SetParrotRequestStatusMutation>;
export type SetParrotRequestStatusMutationOptions = Apollo.BaseMutationOptions<SetParrotRequestStatusMutation, SetParrotRequestStatusMutationVariables>;
export const CompleteParrotRequestDocument = gql`
    mutation CompleteParrotRequest($requestId: uuid!, $studentAssignments: [student_assignments_insert_input!]!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: COMPLETE}
  ) {
    id
    status
  }
  update_assignments(
    where: {parrotRequestId: {_eq: $requestId}}
    _set: {visible: true}
  ) {
    returning {
      id
      visible
    }
  }
  insert_student_assignments(objects: $studentAssignments) {
    returning {
      id
    }
  }
}
    `;
export type CompleteParrotRequestMutationFn = Apollo.MutationFunction<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>;

/**
 * __useCompleteParrotRequestMutation__
 *
 * To run a mutation, you first call `useCompleteParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeParrotRequestMutation, { data, loading, error }] = useCompleteParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useCompleteParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>(CompleteParrotRequestDocument, options);
      }
export type CompleteParrotRequestMutationHookResult = ReturnType<typeof useCompleteParrotRequestMutation>;
export type CompleteParrotRequestMutationResult = Apollo.MutationResult<CompleteParrotRequestMutation>;
export type CompleteParrotRequestMutationOptions = Apollo.BaseMutationOptions<CompleteParrotRequestMutation, CompleteParrotRequestMutationVariables>;
export const ReopenParrotRequestDocument = gql`
    mutation ReopenParrotRequest($requestId: uuid!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {status: IN_PROGRESS}
  ) {
    id
    status
  }
  update_assignments(
    where: {parrotRequestId: {_eq: $requestId}}
    _set: {visible: false}
  ) {
    returning {
      id
      visible
    }
  }
  deletedStudentAssignments: delete_student_assignments(
    where: {assignment: {parrotRequestId: {_eq: $requestId}}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type ReopenParrotRequestMutationFn = Apollo.MutationFunction<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>;

/**
 * __useReopenParrotRequestMutation__
 *
 * To run a mutation, you first call `useReopenParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenParrotRequestMutation, { data, loading, error }] = useReopenParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useReopenParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>(ReopenParrotRequestDocument, options);
      }
export type ReopenParrotRequestMutationHookResult = ReturnType<typeof useReopenParrotRequestMutation>;
export type ReopenParrotRequestMutationResult = Apollo.MutationResult<ReopenParrotRequestMutation>;
export type ReopenParrotRequestMutationOptions = Apollo.BaseMutationOptions<ReopenParrotRequestMutation, ReopenParrotRequestMutationVariables>;
export const ClaimParrotRequestDocument = gql`
    mutation ClaimParrotRequest($requestId: uuid!, $claimerId: String!) {
  parrotRequest: update_parrot_request(
    pk_columns: {id: $requestId}
    _set: {queuePosition: null, status: IN_PROGRESS, claimerId: $claimerId}
  ) {
    ...ParrotRequestInfo
    course {
      ...ClaimedParrotRequestCourseInfo
      numberOfDaysPerWeek
      assignments {
        ...CoursePlanCardAssignment
      }
    }
    claimerId
  }
}
    ${ParrotRequestInfoFragmentDoc}
${ClaimedParrotRequestCourseInfoFragmentDoc}
${StudentsEventsFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}`;
export type ClaimParrotRequestMutationFn = Apollo.MutationFunction<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>;

/**
 * __useClaimParrotRequestMutation__
 *
 * To run a mutation, you first call `useClaimParrotRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimParrotRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimParrotRequestMutation, { data, loading, error }] = useClaimParrotRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      claimerId: // value for 'claimerId'
 *   },
 * });
 */
export function useClaimParrotRequestMutation(baseOptions?: Apollo.MutationHookOptions<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>(ClaimParrotRequestDocument, options);
      }
export type ClaimParrotRequestMutationHookResult = ReturnType<typeof useClaimParrotRequestMutation>;
export type ClaimParrotRequestMutationResult = Apollo.MutationResult<ClaimParrotRequestMutation>;
export type ClaimParrotRequestMutationOptions = Apollo.BaseMutationOptions<ClaimParrotRequestMutation, ClaimParrotRequestMutationVariables>;
export const UpdateRescheduleActionDocument = gql`
    mutation UpdateRescheduleAction($id: uuid!, $status: reschedule_action_statuses_enum, $data: jsonb) {
  rescheduleAction: update_reschedule_action(
    pk_columns: {id: $id}
    _set: {status: $status, data: $data}
  ) {
    ...RescheduleAction
  }
}
    ${RescheduleActionFragmentDoc}`;
export type UpdateRescheduleActionMutationFn = Apollo.MutationFunction<UpdateRescheduleActionMutation, UpdateRescheduleActionMutationVariables>;

/**
 * __useUpdateRescheduleActionMutation__
 *
 * To run a mutation, you first call `useUpdateRescheduleActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRescheduleActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRescheduleActionMutation, { data, loading, error }] = useUpdateRescheduleActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRescheduleActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRescheduleActionMutation, UpdateRescheduleActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRescheduleActionMutation, UpdateRescheduleActionMutationVariables>(UpdateRescheduleActionDocument, options);
      }
export type UpdateRescheduleActionMutationHookResult = ReturnType<typeof useUpdateRescheduleActionMutation>;
export type UpdateRescheduleActionMutationResult = Apollo.MutationResult<UpdateRescheduleActionMutation>;
export type UpdateRescheduleActionMutationOptions = Apollo.BaseMutationOptions<UpdateRescheduleActionMutation, UpdateRescheduleActionMutationVariables>;
export const UpdateStudentDocument = gql`
    mutation UpdateStudent($studentId: String!, $name: String!, $schoolYear: school_year_enum) {
  update_student(
    _set: {name: $name, schoolYear: $schoolYear}
    pk_columns: {id: $studentId}
  ) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;
export type UpdateStudentMutationFn = Apollo.MutationFunction<UpdateStudentMutation, UpdateStudentMutationVariables>;

/**
 * __useUpdateStudentMutation__
 *
 * To run a mutation, you first call `useUpdateStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentMutation, { data, loading, error }] = useUpdateStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      name: // value for 'name'
 *      schoolYear: // value for 'schoolYear'
 *   },
 * });
 */
export function useUpdateStudentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentMutation, UpdateStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentMutation, UpdateStudentMutationVariables>(UpdateStudentDocument, options);
      }
export type UpdateStudentMutationHookResult = ReturnType<typeof useUpdateStudentMutation>;
export type UpdateStudentMutationResult = Apollo.MutationResult<UpdateStudentMutation>;
export type UpdateStudentMutationOptions = Apollo.BaseMutationOptions<UpdateStudentMutation, UpdateStudentMutationVariables>;
export const UpdateStudentAccountDocument = gql`
    mutation UpdateStudentAccount($studentAccountId: String!, $email: String!, $name: String, $picture: String) {
  update_student_account(
    _set: {email: $email, name: $name, picture: $picture}
    pk_columns: {id: $studentAccountId}
  ) {
    id
    email
    name
    picture
  }
}
    `;
export type UpdateStudentAccountMutationFn = Apollo.MutationFunction<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>;

/**
 * __useUpdateStudentAccountMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAccountMutation, { data, loading, error }] = useUpdateStudentAccountMutation({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateStudentAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>(UpdateStudentAccountDocument, options);
      }
export type UpdateStudentAccountMutationHookResult = ReturnType<typeof useUpdateStudentAccountMutation>;
export type UpdateStudentAccountMutationResult = Apollo.MutationResult<UpdateStudentAccountMutation>;
export type UpdateStudentAccountMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAccountMutation, UpdateStudentAccountMutationVariables>;
export const UpdateStudentAssignmentDatesDocument = gql`
    mutation UpdateStudentAssignmentDates($studentAssignmentId: uuid!, $start: date, $end: date, $courseDayOffset: Int) {
  update_student_assignment(
    _set: {start: $start, end: $end, courseDayOffset: $courseDayOffset}
    pk_columns: {id: $studentAssignmentId}
  ) {
    ...PlanningStudentAssignment
  }
}
    ${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}`;
export type UpdateStudentAssignmentDatesMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>;

/**
 * __useUpdateStudentAssignmentDatesMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentDatesMutation, { data, loading, error }] = useUpdateStudentAssignmentDatesMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      courseDayOffset: // value for 'courseDayOffset'
 *   },
 * });
 */
export function useUpdateStudentAssignmentDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>(UpdateStudentAssignmentDatesDocument, options);
      }
export type UpdateStudentAssignmentDatesMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentDatesMutation>;
export type UpdateStudentAssignmentDatesMutationResult = Apollo.MutationResult<UpdateStudentAssignmentDatesMutation>;
export type UpdateStudentAssignmentDatesMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentDatesMutation, UpdateStudentAssignmentDatesMutationVariables>;
export const UpdateStudentAssignmentDatesOnRescheduleDocument = gql`
    mutation UpdateStudentAssignmentDatesOnReschedule($studentAssignmentId: uuid!, $start: date!, $end: date!, $freeForm: Boolean, $courseDayOffset: Int, $displayOrder: Int, $endDisplayOrder: Int) {
  update_student_assignment(
    _set: {start: $start, end: $end, freeForm: $freeForm, courseDayOffset: $courseDayOffset, displayOrder: $displayOrder, endDisplayOrder: $endDisplayOrder}
    pk_columns: {id: $studentAssignmentId}
  ) {
    ...PlanningStudentAssignment
    displayOrder
    endDisplayOrder
  }
}
    ${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}`;
export type UpdateStudentAssignmentDatesOnRescheduleMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>;

/**
 * __useUpdateStudentAssignmentDatesOnRescheduleMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentDatesOnRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentDatesOnRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentDatesOnRescheduleMutation, { data, loading, error }] = useUpdateStudentAssignmentDatesOnRescheduleMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      freeForm: // value for 'freeForm'
 *      courseDayOffset: // value for 'courseDayOffset'
 *      displayOrder: // value for 'displayOrder'
 *      endDisplayOrder: // value for 'endDisplayOrder'
 *   },
 * });
 */
export function useUpdateStudentAssignmentDatesOnRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>(UpdateStudentAssignmentDatesOnRescheduleDocument, options);
      }
export type UpdateStudentAssignmentDatesOnRescheduleMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentDatesOnRescheduleMutation>;
export type UpdateStudentAssignmentDatesOnRescheduleMutationResult = Apollo.MutationResult<UpdateStudentAssignmentDatesOnRescheduleMutation>;
export type UpdateStudentAssignmentDatesOnRescheduleMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentDatesOnRescheduleMutation, UpdateStudentAssignmentDatesOnRescheduleMutationVariables>;
export const UpdateStudentAssignmentDisplayOrdersDocument = gql`
    mutation UpdateStudentAssignmentDisplayOrders($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [displayOrder, endDisplayOrder]}
  ) {
    returning {
      id
      displayOrder
      endDisplayOrder
    }
  }
}
    `;
export type UpdateStudentAssignmentDisplayOrdersMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentDisplayOrdersMutation, UpdateStudentAssignmentDisplayOrdersMutationVariables>;

/**
 * __useUpdateStudentAssignmentDisplayOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentDisplayOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentDisplayOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentDisplayOrdersMutation, { data, loading, error }] = useUpdateStudentAssignmentDisplayOrdersMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateStudentAssignmentDisplayOrdersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentDisplayOrdersMutation, UpdateStudentAssignmentDisplayOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentDisplayOrdersMutation, UpdateStudentAssignmentDisplayOrdersMutationVariables>(UpdateStudentAssignmentDisplayOrdersDocument, options);
      }
export type UpdateStudentAssignmentDisplayOrdersMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentDisplayOrdersMutation>;
export type UpdateStudentAssignmentDisplayOrdersMutationResult = Apollo.MutationResult<UpdateStudentAssignmentDisplayOrdersMutation>;
export type UpdateStudentAssignmentDisplayOrdersMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentDisplayOrdersMutation, UpdateStudentAssignmentDisplayOrdersMutationVariables>;
export const UpdateStudentAssignmentGradeDocument = gql`
    mutation UpdateStudentAssignmentGrade($studentAssignmentId: uuid!, $pointsEarned: numeric!, $pointsAvailable: numeric!) {
  update_student_assignment(
    _set: {pointsEarned: $pointsEarned, pointsAvailable: $pointsAvailable}
    pk_columns: {id: $studentAssignmentId}
  ) {
    id
    pointsEarned
    pointsAvailable
  }
}
    `;
export type UpdateStudentAssignmentGradeMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;

/**
 * __useUpdateStudentAssignmentGradeMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentGradeMutation, { data, loading, error }] = useUpdateStudentAssignmentGradeMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      pointsEarned: // value for 'pointsEarned'
 *      pointsAvailable: // value for 'pointsAvailable'
 *   },
 * });
 */
export function useUpdateStudentAssignmentGradeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>(UpdateStudentAssignmentGradeDocument, options);
      }
export type UpdateStudentAssignmentGradeMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationResult = Apollo.MutationResult<UpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;
export const UpdateStudentAssignmentStatusDocument = gql`
    mutation UpdateStudentAssignmentStatus($studentAssignmentId: uuid!, $status: student_assignment_status_enum!, $completed: timestamptz) {
  update_student_assignment(
    _set: {status: $status, completed: $completed}
    pk_columns: {id: $studentAssignmentId}
  ) {
    __typename
    id
    status
    completed
  }
}
    `;
export type UpdateStudentAssignmentStatusMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>;

/**
 * __useUpdateStudentAssignmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentStatusMutation, { data, loading, error }] = useUpdateStudentAssignmentStatusMutation({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      status: // value for 'status'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateStudentAssignmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>(UpdateStudentAssignmentStatusDocument, options);
      }
export type UpdateStudentAssignmentStatusMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentStatusMutation>;
export type UpdateStudentAssignmentStatusMutationResult = Apollo.MutationResult<UpdateStudentAssignmentStatusMutation>;
export type UpdateStudentAssignmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentStatusMutation, UpdateStudentAssignmentStatusMutationVariables>;
export const UpdateStudentAssignmentsStatusDocument = gql`
    mutation UpdateStudentAssignmentsStatus($studentAssignmentIds: [uuid!]!, $status: student_assignment_status_enum!, $completed: timestamptz) {
  update_student_assignments(
    _set: {status: $status, completed: $completed}
    where: {id: {_in: $studentAssignmentIds}}
  ) {
    returning {
      id
      status
      completed
    }
  }
}
    `;
export type UpdateStudentAssignmentsStatusMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>;

/**
 * __useUpdateStudentAssignmentsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentsStatusMutation, { data, loading, error }] = useUpdateStudentAssignmentsStatusMutation({
 *   variables: {
 *      studentAssignmentIds: // value for 'studentAssignmentIds'
 *      status: // value for 'status'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateStudentAssignmentsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>(UpdateStudentAssignmentsStatusDocument, options);
      }
export type UpdateStudentAssignmentsStatusMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentsStatusMutation>;
export type UpdateStudentAssignmentsStatusMutationResult = Apollo.MutationResult<UpdateStudentAssignmentsStatusMutation>;
export type UpdateStudentAssignmentsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentsStatusMutation, UpdateStudentAssignmentsStatusMutationVariables>;
export const UpdateStudentCourseDayOffsetsDocument = gql`
    mutation UpdateStudentCourseDayOffsets($studentCourseId: uuid!, $studentCourseDayOffsets: jsonb!, $studentAssignments: [student_assignments_insert_input!]!) {
  update_student_course(
    _set: {courseDayOffsets: $studentCourseDayOffsets}
    pk_columns: {id: $studentCourseId}
  ) {
    id
    courseDayOffsets
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end, courseDayOffset]}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
}
    `;
export type UpdateStudentCourseDayOffsetsMutationFn = Apollo.MutationFunction<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>;

/**
 * __useUpdateStudentCourseDayOffsetsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCourseDayOffsetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCourseDayOffsetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCourseDayOffsetsMutation, { data, loading, error }] = useUpdateStudentCourseDayOffsetsMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      studentCourseDayOffsets: // value for 'studentCourseDayOffsets'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateStudentCourseDayOffsetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>(UpdateStudentCourseDayOffsetsDocument, options);
      }
export type UpdateStudentCourseDayOffsetsMutationHookResult = ReturnType<typeof useUpdateStudentCourseDayOffsetsMutation>;
export type UpdateStudentCourseDayOffsetsMutationResult = Apollo.MutationResult<UpdateStudentCourseDayOffsetsMutation>;
export type UpdateStudentCourseDayOffsetsMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCourseDayOffsetsMutation, UpdateStudentCourseDayOffsetsMutationVariables>;
export const UpdateStudentCourseScheduleDocument = gql`
    mutation UpdateStudentCourseSchedule($studentCourseId: uuid!, $daysOfTheWeek: jsonb!, $start: date!, $studentAssignments: [student_assignments_insert_input!]!) {
  update_student_course(
    _set: {daysOfTheWeek: $daysOfTheWeek, start: $start}
    pk_columns: {id: $studentCourseId}
  ) {
    id
    daysOfTheWeek
    start
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    `;
export type UpdateStudentCourseScheduleMutationFn = Apollo.MutationFunction<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>;

/**
 * __useUpdateStudentCourseScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCourseScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCourseScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCourseScheduleMutation, { data, loading, error }] = useUpdateStudentCourseScheduleMutation({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *      daysOfTheWeek: // value for 'daysOfTheWeek'
 *      start: // value for 'start'
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpdateStudentCourseScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>(UpdateStudentCourseScheduleDocument, options);
      }
export type UpdateStudentCourseScheduleMutationHookResult = ReturnType<typeof useUpdateStudentCourseScheduleMutation>;
export type UpdateStudentCourseScheduleMutationResult = Apollo.MutationResult<UpdateStudentCourseScheduleMutation>;
export type UpdateStudentCourseScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCourseScheduleMutation, UpdateStudentCourseScheduleMutationVariables>;
export const UpdateStudentCoursesDailyOrderDocument = gql`
    mutation UpdateStudentCoursesDailyOrder($studentCourses: [student_courses_insert_input!]!) {
  insert_student_courses(
    objects: $studentCourses
    on_conflict: {constraint: student_courses_pkey, update_columns: [dailySortOrder]}
  ) {
    returning {
      id
      dailySortOrder
    }
  }
}
    `;
export type UpdateStudentCoursesDailyOrderMutationFn = Apollo.MutationFunction<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>;

/**
 * __useUpdateStudentCoursesDailyOrderMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCoursesDailyOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCoursesDailyOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentCoursesDailyOrderMutation, { data, loading, error }] = useUpdateStudentCoursesDailyOrderMutation({
 *   variables: {
 *      studentCourses: // value for 'studentCourses'
 *   },
 * });
 */
export function useUpdateStudentCoursesDailyOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>(UpdateStudentCoursesDailyOrderDocument, options);
      }
export type UpdateStudentCoursesDailyOrderMutationHookResult = ReturnType<typeof useUpdateStudentCoursesDailyOrderMutation>;
export type UpdateStudentCoursesDailyOrderMutationResult = Apollo.MutationResult<UpdateStudentCoursesDailyOrderMutation>;
export type UpdateStudentCoursesDailyOrderMutationOptions = Apollo.BaseMutationOptions<UpdateStudentCoursesDailyOrderMutation, UpdateStudentCoursesDailyOrderMutationVariables>;
export const UpdateStudentPictureDocument = gql`
    mutation UpdateStudentPicture($studentId: String!, $picture: String) {
  update_student(_set: {picture: $picture}, pk_columns: {id: $studentId}) {
    id
    picture
  }
}
    `;
export type UpdateStudentPictureMutationFn = Apollo.MutationFunction<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>;

/**
 * __useUpdateStudentPictureMutation__
 *
 * To run a mutation, you first call `useUpdateStudentPictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentPictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentPictureMutation, { data, loading, error }] = useUpdateStudentPictureMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateStudentPictureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>(UpdateStudentPictureDocument, options);
      }
export type UpdateStudentPictureMutationHookResult = ReturnType<typeof useUpdateStudentPictureMutation>;
export type UpdateStudentPictureMutationResult = Apollo.MutationResult<UpdateStudentPictureMutation>;
export type UpdateStudentPictureMutationOptions = Apollo.BaseMutationOptions<UpdateStudentPictureMutation, UpdateStudentPictureMutationVariables>;
export const UpdateTeacherDocument = gql`
    mutation UpdateTeacher($teacherId: String!, $email: String!, $name: String, $picture: String) {
  update_teacher(
    _set: {email: $email, name: $name, picture: $picture}
    pk_columns: {id: $teacherId}
  ) {
    ...TeacherInfo
  }
}
    ${TeacherInfoFragmentDoc}
${OrganizationFragmentDoc}`;
export type UpdateTeacherMutationFn = Apollo.MutationFunction<UpdateTeacherMutation, UpdateTeacherMutationVariables>;

/**
 * __useUpdateTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeacherMutation, { data, loading, error }] = useUpdateTeacherMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      picture: // value for 'picture'
 *   },
 * });
 */
export function useUpdateTeacherMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeacherMutation, UpdateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeacherMutation, UpdateTeacherMutationVariables>(UpdateTeacherDocument, options);
      }
export type UpdateTeacherMutationHookResult = ReturnType<typeof useUpdateTeacherMutation>;
export type UpdateTeacherMutationResult = Apollo.MutationResult<UpdateTeacherMutation>;
export type UpdateTeacherMutationOptions = Apollo.BaseMutationOptions<UpdateTeacherMutation, UpdateTeacherMutationVariables>;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($themeId: uuid!, $name: String, $visible: Boolean, $headerBackground: String, $headerForeground: String, $headerForegroundActive: String, $primary: String, $primaryContrast: String, $appBackground: String, $contentBackground: String, $faintBorder: String, $mediumBorder: String, $elementBorder: String, $elementBackground: String, $surfaceBorder: String, $colorPalette: jsonb, $contentContrast: String, $contentPrimary: String, $contentSecondary: String, $contentTertiary: String, $positive: String, $negative: String, $info: String, $vacation: String, $logoUrl: String, $portalIconUrl: String, $rescheduleNormal: String, $rescheduleShift: String, $rescheduleFreeform: String, $rescheduleSetEnd: String) {
  update_themes_by_pk(
    pk_columns: {id: $themeId}
    _set: {name: $name, visible: $visible, headerBackground: $headerBackground, headerForeground: $headerForeground, headerForegroundActive: $headerForegroundActive, primary: $primary, primaryContrast: $primaryContrast, appBackground: $appBackground, contentBackground: $contentBackground, faintBorder: $faintBorder, mediumBorder: $mediumBorder, elementBorder: $elementBorder, elementBackground: $elementBackground, surfaceBorder: $surfaceBorder, colorPalette: $colorPalette, contentContrast: $contentContrast, contentPrimary: $contentPrimary, contentSecondary: $contentSecondary, contentTertiary: $contentTertiary, positive: $positive, negative: $negative, info: $info, vacation: $vacation, logoUrl: $logoUrl, portalIconUrl: $portalIconUrl, rescheduleNormal: $rescheduleNormal, rescheduleShift: $rescheduleShift, rescheduleFreeform: $rescheduleFreeform, rescheduleSetEnd: $rescheduleSetEnd}
  ) {
    ...ThemeDetails
  }
}
    ${ThemeDetailsFragmentDoc}`;
export type UpdateThemeMutationFn = Apollo.MutationFunction<UpdateThemeMutation, UpdateThemeMutationVariables>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      name: // value for 'name'
 *      visible: // value for 'visible'
 *      headerBackground: // value for 'headerBackground'
 *      headerForeground: // value for 'headerForeground'
 *      headerForegroundActive: // value for 'headerForegroundActive'
 *      primary: // value for 'primary'
 *      primaryContrast: // value for 'primaryContrast'
 *      appBackground: // value for 'appBackground'
 *      contentBackground: // value for 'contentBackground'
 *      faintBorder: // value for 'faintBorder'
 *      mediumBorder: // value for 'mediumBorder'
 *      elementBorder: // value for 'elementBorder'
 *      elementBackground: // value for 'elementBackground'
 *      surfaceBorder: // value for 'surfaceBorder'
 *      colorPalette: // value for 'colorPalette'
 *      contentContrast: // value for 'contentContrast'
 *      contentPrimary: // value for 'contentPrimary'
 *      contentSecondary: // value for 'contentSecondary'
 *      contentTertiary: // value for 'contentTertiary'
 *      positive: // value for 'positive'
 *      negative: // value for 'negative'
 *      info: // value for 'info'
 *      vacation: // value for 'vacation'
 *      logoUrl: // value for 'logoUrl'
 *      portalIconUrl: // value for 'portalIconUrl'
 *      rescheduleNormal: // value for 'rescheduleNormal'
 *      rescheduleShift: // value for 'rescheduleShift'
 *      rescheduleFreeform: // value for 'rescheduleFreeform'
 *      rescheduleSetEnd: // value for 'rescheduleSetEnd'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeDocument, options);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationResult = Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;
export const UpdateVacationDocument = gql`
    mutation UpdateVacation($eventId: uuid!, $start: date!, $end: date!, $name: String, $studentEvents: [student_events_insert_input!]!, $studentAssignments: [student_assignments_insert_input!]!, $ignoredCourses: [event_ignored_courses_insert_input!]!) {
  update_event(
    _set: {start: $start, end: $end, name: $name}
    pk_columns: {id: $eventId}
  ) {
    ...EventInfo
  }
  deletedStudentEvents: delete_student_events(where: {eventId: {_eq: $eventId}}) {
    returning {
      id
    }
  }
  deletedIgnoredCourses: delete_event_ignored_courses(
    where: {eventId: {_eq: $eventId}}
  ) {
    returning {
      courseId
    }
  }
  insert_event_ignored_courses(objects: $ignoredCourses) {
    returning {
      courseId
    }
  }
  newStudentEvents: insert_student_events(objects: $studentEvents) {
    returning {
      id
      student {
        id
        name
        picture
        ...StudentsEvents
      }
      event {
        id
        ...EventInfo
      }
    }
  }
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end]}
  ) {
    returning {
      id
      start
      end
    }
  }
}
    ${EventInfoFragmentDoc}
${StudentsEventsFragmentDoc}`;
export type UpdateVacationMutationFn = Apollo.MutationFunction<UpdateVacationMutation, UpdateVacationMutationVariables>;

/**
 * __useUpdateVacationMutation__
 *
 * To run a mutation, you first call `useUpdateVacationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVacationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVacationMutation, { data, loading, error }] = useUpdateVacationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      name: // value for 'name'
 *      studentEvents: // value for 'studentEvents'
 *      studentAssignments: // value for 'studentAssignments'
 *      ignoredCourses: // value for 'ignoredCourses'
 *   },
 * });
 */
export function useUpdateVacationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVacationMutation, UpdateVacationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVacationMutation, UpdateVacationMutationVariables>(UpdateVacationDocument, options);
      }
export type UpdateVacationMutationHookResult = ReturnType<typeof useUpdateVacationMutation>;
export type UpdateVacationMutationResult = Apollo.MutationResult<UpdateVacationMutation>;
export type UpdateVacationMutationOptions = Apollo.BaseMutationOptions<UpdateVacationMutation, UpdateVacationMutationVariables>;
export const UpsertStudentAssignmentsDatesDocument = gql`
    mutation UpsertStudentAssignmentsDates($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [start, end, courseDayOffset]}
  ) {
    returning {
      id
      start
      end
      courseDayOffset
    }
  }
}
    `;
export type UpsertStudentAssignmentsDatesMutationFn = Apollo.MutationFunction<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>;

/**
 * __useUpsertStudentAssignmentsDatesMutation__
 *
 * To run a mutation, you first call `useUpsertStudentAssignmentsDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentAssignmentsDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentAssignmentsDatesMutation, { data, loading, error }] = useUpsertStudentAssignmentsDatesMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpsertStudentAssignmentsDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>(UpsertStudentAssignmentsDatesDocument, options);
      }
export type UpsertStudentAssignmentsDatesMutationHookResult = ReturnType<typeof useUpsertStudentAssignmentsDatesMutation>;
export type UpsertStudentAssignmentsDatesMutationResult = Apollo.MutationResult<UpsertStudentAssignmentsDatesMutation>;
export type UpsertStudentAssignmentsDatesMutationOptions = Apollo.BaseMutationOptions<UpsertStudentAssignmentsDatesMutation, UpsertStudentAssignmentsDatesMutationVariables>;
export const UpsertStudentAssignmentsGradingStylesDocument = gql`
    mutation UpsertStudentAssignmentsGradingStyles($studentAssignments: [student_assignments_insert_input!]!) {
  insert_student_assignments(
    objects: $studentAssignments
    on_conflict: {constraint: student_assignments_pkey, update_columns: [pointsEarned, pointsAvailable]}
  ) {
    returning {
      id
      pointsEarned
      pointsAvailable
    }
  }
}
    `;
export type UpsertStudentAssignmentsGradingStylesMutationFn = Apollo.MutationFunction<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>;

/**
 * __useUpsertStudentAssignmentsGradingStylesMutation__
 *
 * To run a mutation, you first call `useUpsertStudentAssignmentsGradingStylesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentAssignmentsGradingStylesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentAssignmentsGradingStylesMutation, { data, loading, error }] = useUpsertStudentAssignmentsGradingStylesMutation({
 *   variables: {
 *      studentAssignments: // value for 'studentAssignments'
 *   },
 * });
 */
export function useUpsertStudentAssignmentsGradingStylesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>(UpsertStudentAssignmentsGradingStylesDocument, options);
      }
export type UpsertStudentAssignmentsGradingStylesMutationHookResult = ReturnType<typeof useUpsertStudentAssignmentsGradingStylesMutation>;
export type UpsertStudentAssignmentsGradingStylesMutationResult = Apollo.MutationResult<UpsertStudentAssignmentsGradingStylesMutation>;
export type UpsertStudentAssignmentsGradingStylesMutationOptions = Apollo.BaseMutationOptions<UpsertStudentAssignmentsGradingStylesMutation, UpsertStudentAssignmentsGradingStylesMutationVariables>;
export const UpsertTranscriptDraftDocument = gql`
    mutation UpsertTranscriptDraft($studentId: String!, $teacherId: String!, $draftData: jsonb!) {
  transcriptDraft: insert_transcript_draft(
    object: {studentId: $studentId, teacherId: $teacherId, draftData: $draftData}
    on_conflict: {constraint: transcript_drafts_student_id_teacher_id_key, update_columns: [draftData]}
  ) {
    id
    studentId
    teacherId
    draftData
    updated
  }
}
    `;
export type UpsertTranscriptDraftMutationFn = Apollo.MutationFunction<UpsertTranscriptDraftMutation, UpsertTranscriptDraftMutationVariables>;

/**
 * __useUpsertTranscriptDraftMutation__
 *
 * To run a mutation, you first call `useUpsertTranscriptDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTranscriptDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTranscriptDraftMutation, { data, loading, error }] = useUpsertTranscriptDraftMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *      draftData: // value for 'draftData'
 *   },
 * });
 */
export function useUpsertTranscriptDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTranscriptDraftMutation, UpsertTranscriptDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTranscriptDraftMutation, UpsertTranscriptDraftMutationVariables>(UpsertTranscriptDraftDocument, options);
      }
export type UpsertTranscriptDraftMutationHookResult = ReturnType<typeof useUpsertTranscriptDraftMutation>;
export type UpsertTranscriptDraftMutationResult = Apollo.MutationResult<UpsertTranscriptDraftMutation>;
export type UpsertTranscriptDraftMutationOptions = Apollo.BaseMutationOptions<UpsertTranscriptDraftMutation, UpsertTranscriptDraftMutationVariables>;
export const UpsertTeacherSettingsDocument = gql`
    mutation UpsertTeacherSettings($teacherId: String!, $userSettings: user_settings_insert_input!) {
  insert_teacher(
    object: {id: $teacherId, userSettings: {data: $userSettings, on_conflict: {constraint: user_settings_pkey, update_columns: [showEmptyAssignmentDays, weekStartDay, selectedThemeId]}}}
    on_conflict: {constraint: teachers_pkey, update_columns: settingsId}
  ) {
    id
    userSettings {
      ...UserSettings
    }
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpsertTeacherSettingsMutationFn = Apollo.MutationFunction<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>;

/**
 * __useUpsertTeacherSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertTeacherSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTeacherSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTeacherSettingsMutation, { data, loading, error }] = useUpsertTeacherSettingsMutation({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpsertTeacherSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>(UpsertTeacherSettingsDocument, options);
      }
export type UpsertTeacherSettingsMutationHookResult = ReturnType<typeof useUpsertTeacherSettingsMutation>;
export type UpsertTeacherSettingsMutationResult = Apollo.MutationResult<UpsertTeacherSettingsMutation>;
export type UpsertTeacherSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertTeacherSettingsMutation, UpsertTeacherSettingsMutationVariables>;
export const UpsertStudentSettingsDocument = gql`
    mutation UpsertStudentSettings($userId: String!, $userSettings: user_settings_insert_input!) {
  insert_student_account(
    object: {id: $userId, studentId: "", email: "", userSettings: {data: $userSettings, on_conflict: {constraint: user_settings_pkey, update_columns: [showEmptyAssignmentDays, weekStartDay, selectedThemeId]}}}
    on_conflict: {constraint: student_accounts_pkey, update_columns: settingsId}
  ) {
    id
    userSettings {
      ...UserSettings
    }
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpsertStudentSettingsMutationFn = Apollo.MutationFunction<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>;

/**
 * __useUpsertStudentSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertStudentSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStudentSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStudentSettingsMutation, { data, loading, error }] = useUpsertStudentSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useUpsertStudentSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>(UpsertStudentSettingsDocument, options);
      }
export type UpsertStudentSettingsMutationHookResult = ReturnType<typeof useUpsertStudentSettingsMutation>;
export type UpsertStudentSettingsMutationResult = Apollo.MutationResult<UpsertStudentSettingsMutation>;
export type UpsertStudentSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertStudentSettingsMutation, UpsertStudentSettingsMutationVariables>;
export const GetActiveCourseStudentsDocument = gql`
    query GetActiveCourseStudents($courseId: uuid!) {
  course(id: $courseId) {
    id
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...CourseStudentCardInfo
      student {
        id
        name
        picture
      }
      ...StudentCourseInfo
    }
  }
}
    ${CourseStudentCardInfoFragmentDoc}
${StudentCourseInfoFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;

/**
 * __useGetActiveCourseStudentsQuery__
 *
 * To run a query within a React component, call `useGetActiveCourseStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCourseStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCourseStudentsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetActiveCourseStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables> & ({ variables: GetActiveCourseStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
      }
export function useGetActiveCourseStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
        }
// @ts-ignore
export function useGetActiveCourseStudentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>;
export function useGetActiveCourseStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCourseStudentsQuery | undefined, GetActiveCourseStudentsQueryVariables>;
export function useGetActiveCourseStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>(GetActiveCourseStudentsDocument, options);
        }
export type GetActiveCourseStudentsQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsQuery>;
export type GetActiveCourseStudentsLazyQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsLazyQuery>;
export type GetActiveCourseStudentsSuspenseQueryHookResult = ReturnType<typeof useGetActiveCourseStudentsSuspenseQuery>;
export type GetActiveCourseStudentsQueryResult = Apollo.QueryResult<GetActiveCourseStudentsQuery, GetActiveCourseStudentsQueryVariables>;
export const GetActiveCourseOptionsDocument = gql`
    query GetActiveCourseOptions {
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CourseOption
  }
}
    ${CourseOptionFragmentDoc}`;

/**
 * __useGetActiveCourseOptionsQuery__
 *
 * To run a query within a React component, call `useGetActiveCourseOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCourseOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCourseOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCourseOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
      }
export function useGetActiveCourseOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
        }
// @ts-ignore
export function useGetActiveCourseOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>;
export function useGetActiveCourseOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveCourseOptionsQuery | undefined, GetActiveCourseOptionsQueryVariables>;
export function useGetActiveCourseOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>(GetActiveCourseOptionsDocument, options);
        }
export type GetActiveCourseOptionsQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsQuery>;
export type GetActiveCourseOptionsLazyQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsLazyQuery>;
export type GetActiveCourseOptionsSuspenseQueryHookResult = ReturnType<typeof useGetActiveCourseOptionsSuspenseQuery>;
export type GetActiveCourseOptionsQueryResult = Apollo.QueryResult<GetActiveCourseOptionsQuery, GetActiveCourseOptionsQueryVariables>;
export const GetActiveStudentCoursesDocument = gql`
    query GetActiveStudentCourses($studentId: String!) {
  student(id: $studentId) {
    id
    name
    picture
    ...StudentsEvents
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...ActiveStudentCourseCardInfo
    }
  }
}
    ${StudentsEventsFragmentDoc}
${ActiveStudentCourseCardInfoFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;

/**
 * __useGetActiveStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetActiveStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveStudentCoursesQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetActiveStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables> & ({ variables: GetActiveStudentCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
      }
export function useGetActiveStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
        }
// @ts-ignore
export function useGetActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>;
export function useGetActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveStudentCoursesQuery | undefined, GetActiveStudentCoursesQueryVariables>;
export function useGetActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>(GetActiveStudentCoursesDocument, options);
        }
export type GetActiveStudentCoursesQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesQuery>;
export type GetActiveStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesLazyQuery>;
export type GetActiveStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesSuspenseQuery>;
export type GetActiveStudentCoursesQueryResult = Apollo.QueryResult<GetActiveStudentCoursesQuery, GetActiveStudentCoursesQueryVariables>;
export const GetActiveStudentCoursesForTranscriptDocument = gql`
    query GetActiveStudentCoursesForTranscript($studentId: String!) {
  student(id: $studentId) {
    id
    studentCourses(where: {status: {_eq: ENROLLED}}) {
      ...ActiveStudentTranscriptCourse
    }
  }
}
    ${ActiveStudentTranscriptCourseFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}`;

/**
 * __useGetActiveStudentCoursesForTranscriptQuery__
 *
 * To run a query within a React component, call `useGetActiveStudentCoursesForTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveStudentCoursesForTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveStudentCoursesForTranscriptQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetActiveStudentCoursesForTranscriptQuery(baseOptions: Apollo.QueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables> & ({ variables: GetActiveStudentCoursesForTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
      }
export function useGetActiveStudentCoursesForTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
        }
// @ts-ignore
export function useGetActiveStudentCoursesForTranscriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>;
export function useGetActiveStudentCoursesForTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveStudentCoursesForTranscriptQuery | undefined, GetActiveStudentCoursesForTranscriptQueryVariables>;
export function useGetActiveStudentCoursesForTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>(GetActiveStudentCoursesForTranscriptDocument, options);
        }
export type GetActiveStudentCoursesForTranscriptQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptQuery>;
export type GetActiveStudentCoursesForTranscriptLazyQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptLazyQuery>;
export type GetActiveStudentCoursesForTranscriptSuspenseQueryHookResult = ReturnType<typeof useGetActiveStudentCoursesForTranscriptSuspenseQuery>;
export type GetActiveStudentCoursesForTranscriptQueryResult = Apollo.QueryResult<GetActiveStudentCoursesForTranscriptQuery, GetActiveStudentCoursesForTranscriptQueryVariables>;
export const GetAllActiveStudentCoursesDocument = gql`
    query GetAllActiveStudentCourses {
  studentCourses: student_courses(where: {status: {_eq: ENROLLED}}) {
    id
    start
    daysOfTheWeek
    courseDayOffsets
    course {
      id
      numberOfWeeks
      numberOfDaysPerWeek
    }
    student {
      id
      ...StudentsEvents
    }
  }
}
    ${StudentsEventsFragmentDoc}`;

/**
 * __useGetAllActiveStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllActiveStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveStudentCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllActiveStudentCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
      }
export function useGetAllActiveStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
        }
// @ts-ignore
export function useGetAllActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>;
export function useGetAllActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllActiveStudentCoursesQuery | undefined, GetAllActiveStudentCoursesQueryVariables>;
export function useGetAllActiveStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>(GetAllActiveStudentCoursesDocument, options);
        }
export type GetAllActiveStudentCoursesQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesQuery>;
export type GetAllActiveStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesLazyQuery>;
export type GetAllActiveStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllActiveStudentCoursesSuspenseQuery>;
export type GetAllActiveStudentCoursesQueryResult = Apollo.QueryResult<GetAllActiveStudentCoursesQuery, GetAllActiveStudentCoursesQueryVariables>;
export const GetAllEventsInfoDocument = gql`
    query GetAllEventsInfo {
  events(order_by: {start: desc}) {
    ...EventInfo
  }
}
    ${EventInfoFragmentDoc}`;

/**
 * __useGetAllEventsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllEventsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEventsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEventsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
      }
export function useGetAllEventsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
        }
// @ts-ignore
export function useGetAllEventsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>;
export function useGetAllEventsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEventsInfoQuery | undefined, GetAllEventsInfoQueryVariables>;
export function useGetAllEventsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>(GetAllEventsInfoDocument, options);
        }
export type GetAllEventsInfoQueryHookResult = ReturnType<typeof useGetAllEventsInfoQuery>;
export type GetAllEventsInfoLazyQueryHookResult = ReturnType<typeof useGetAllEventsInfoLazyQuery>;
export type GetAllEventsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllEventsInfoSuspenseQuery>;
export type GetAllEventsInfoQueryResult = Apollo.QueryResult<GetAllEventsInfoQuery, GetAllEventsInfoQueryVariables>;
export const GetAllParrotRequestsInfoDocument = gql`
    query GetAllParrotRequestsInfo {
  parrotRequests: parrot_requests(order_by: {updated: desc}) {
    ...ParrotRequestInfo
  }
}
    ${ParrotRequestInfoFragmentDoc}`;

/**
 * __useGetAllParrotRequestsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllParrotRequestsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllParrotRequestsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllParrotRequestsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllParrotRequestsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
      }
export function useGetAllParrotRequestsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
        }
// @ts-ignore
export function useGetAllParrotRequestsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>;
export function useGetAllParrotRequestsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllParrotRequestsInfoQuery | undefined, GetAllParrotRequestsInfoQueryVariables>;
export function useGetAllParrotRequestsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>(GetAllParrotRequestsInfoDocument, options);
        }
export type GetAllParrotRequestsInfoQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoQuery>;
export type GetAllParrotRequestsInfoLazyQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoLazyQuery>;
export type GetAllParrotRequestsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllParrotRequestsInfoSuspenseQuery>;
export type GetAllParrotRequestsInfoQueryResult = Apollo.QueryResult<GetAllParrotRequestsInfoQuery, GetAllParrotRequestsInfoQueryVariables>;
export const GetAllParrotRequestsByClaimerIdDocument = gql`
    query GetAllParrotRequestsByClaimerId($claimerId: String!) {
  parrotRequests: parrot_requests(
    order_by: {updated: desc}
    where: {claimerId: {_eq: $claimerId}}
  ) {
    ...ParrotRequestInfo
    course {
      ...ClaimedParrotRequestCourseInfo
    }
  }
}
    ${ParrotRequestInfoFragmentDoc}
${ClaimedParrotRequestCourseInfoFragmentDoc}
${StudentsEventsFragmentDoc}`;

/**
 * __useGetAllParrotRequestsByClaimerIdQuery__
 *
 * To run a query within a React component, call `useGetAllParrotRequestsByClaimerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllParrotRequestsByClaimerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllParrotRequestsByClaimerIdQuery({
 *   variables: {
 *      claimerId: // value for 'claimerId'
 *   },
 * });
 */
export function useGetAllParrotRequestsByClaimerIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables> & ({ variables: GetAllParrotRequestsByClaimerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
      }
export function useGetAllParrotRequestsByClaimerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
        }
// @ts-ignore
export function useGetAllParrotRequestsByClaimerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>;
export function useGetAllParrotRequestsByClaimerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllParrotRequestsByClaimerIdQuery | undefined, GetAllParrotRequestsByClaimerIdQueryVariables>;
export function useGetAllParrotRequestsByClaimerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>(GetAllParrotRequestsByClaimerIdDocument, options);
        }
export type GetAllParrotRequestsByClaimerIdQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdQuery>;
export type GetAllParrotRequestsByClaimerIdLazyQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdLazyQuery>;
export type GetAllParrotRequestsByClaimerIdSuspenseQueryHookResult = ReturnType<typeof useGetAllParrotRequestsByClaimerIdSuspenseQuery>;
export type GetAllParrotRequestsByClaimerIdQueryResult = Apollo.QueryResult<GetAllParrotRequestsByClaimerIdQuery, GetAllParrotRequestsByClaimerIdQueryVariables>;
export const GetAllStudentsInfoDocument = gql`
    query GetAllStudentsInfo {
  students(order_by: {name: asc}) {
    ...StudentInfo
    studentCourses {
      id
      status
    }
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetAllStudentsInfoQuery__
 *
 * To run a query within a React component, call `useGetAllStudentsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudentsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudentsInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStudentsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
      }
export function useGetAllStudentsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
        }
// @ts-ignore
export function useGetAllStudentsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>;
export function useGetAllStudentsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllStudentsInfoQuery | undefined, GetAllStudentsInfoQueryVariables>;
export function useGetAllStudentsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>(GetAllStudentsInfoDocument, options);
        }
export type GetAllStudentsInfoQueryHookResult = ReturnType<typeof useGetAllStudentsInfoQuery>;
export type GetAllStudentsInfoLazyQueryHookResult = ReturnType<typeof useGetAllStudentsInfoLazyQuery>;
export type GetAllStudentsInfoSuspenseQueryHookResult = ReturnType<typeof useGetAllStudentsInfoSuspenseQuery>;
export type GetAllStudentsInfoQueryResult = Apollo.QueryResult<GetAllStudentsInfoQuery, GetAllStudentsInfoQueryVariables>;
export const GetAssignmentTypesDocument = gql`
    query GetAssignmentTypes {
  assignmentTypes: assignment_type {
    value
  }
}
    `;

/**
 * __useGetAssignmentTypesQuery__
 *
 * To run a query within a React component, call `useGetAssignmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssignmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
      }
export function useGetAssignmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
        }
// @ts-ignore
export function useGetAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>;
export function useGetAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentTypesQuery | undefined, GetAssignmentTypesQueryVariables>;
export function useGetAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>(GetAssignmentTypesDocument, options);
        }
export type GetAssignmentTypesQueryHookResult = ReturnType<typeof useGetAssignmentTypesQuery>;
export type GetAssignmentTypesLazyQueryHookResult = ReturnType<typeof useGetAssignmentTypesLazyQuery>;
export type GetAssignmentTypesSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentTypesSuspenseQuery>;
export type GetAssignmentTypesQueryResult = Apollo.QueryResult<GetAssignmentTypesQuery, GetAssignmentTypesQueryVariables>;
export const GetAttendanceDayCountDocument = gql`
    query GetAttendanceDayCount($studentId: String!) {
  student_assignments_aggregate(
    where: {_and: [{completed: {_is_null: false}}, {studentId: {_eq: $studentId}}, {studentCourse: {status: {_eq: ENROLLED}}}]}
    distinct_on: end
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAttendanceDayCountQuery__
 *
 * To run a query within a React component, call `useGetAttendanceDayCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceDayCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceDayCountQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetAttendanceDayCountQuery(baseOptions: Apollo.QueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables> & ({ variables: GetAttendanceDayCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
      }
export function useGetAttendanceDayCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
        }
// @ts-ignore
export function useGetAttendanceDayCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>;
export function useGetAttendanceDayCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAttendanceDayCountQuery | undefined, GetAttendanceDayCountQueryVariables>;
export function useGetAttendanceDayCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>(GetAttendanceDayCountDocument, options);
        }
export type GetAttendanceDayCountQueryHookResult = ReturnType<typeof useGetAttendanceDayCountQuery>;
export type GetAttendanceDayCountLazyQueryHookResult = ReturnType<typeof useGetAttendanceDayCountLazyQuery>;
export type GetAttendanceDayCountSuspenseQueryHookResult = ReturnType<typeof useGetAttendanceDayCountSuspenseQuery>;
export type GetAttendanceDayCountQueryResult = Apollo.QueryResult<GetAttendanceDayCountQuery, GetAttendanceDayCountQueryVariables>;
export const GetCalendarMonthDataDocument = gql`
    query GetCalendarMonthData($startDay: date!, $endDay: date!) {
  courses(where: {studentCourses: {status: {_eq: ENROLLED}}}) {
    ...CalendarMonthCourse
  }
  events(
    where: {_and: [{eventType: {_eq: VACATION}}, {start: {_lte: $endDay}}, {end: {_gte: $startDay}}]}
  ) {
    ...CalendarWeekVacation
  }
}
    ${CalendarMonthCourseFragmentDoc}
${CalendarMonthStudentCourseFragmentDoc}
${CalendarMonthStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${CalendarWeekVacationFragmentDoc}`;

/**
 * __useGetCalendarMonthDataQuery__
 *
 * To run a query within a React component, call `useGetCalendarMonthDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarMonthDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarMonthDataQuery({
 *   variables: {
 *      startDay: // value for 'startDay'
 *      endDay: // value for 'endDay'
 *   },
 * });
 */
export function useGetCalendarMonthDataQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables> & ({ variables: GetCalendarMonthDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>(GetCalendarMonthDataDocument, options);
      }
export function useGetCalendarMonthDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>(GetCalendarMonthDataDocument, options);
        }
// @ts-ignore
export function useGetCalendarMonthDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>;
export function useGetCalendarMonthDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarMonthDataQuery | undefined, GetCalendarMonthDataQueryVariables>;
export function useGetCalendarMonthDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>(GetCalendarMonthDataDocument, options);
        }
export type GetCalendarMonthDataQueryHookResult = ReturnType<typeof useGetCalendarMonthDataQuery>;
export type GetCalendarMonthDataLazyQueryHookResult = ReturnType<typeof useGetCalendarMonthDataLazyQuery>;
export type GetCalendarMonthDataSuspenseQueryHookResult = ReturnType<typeof useGetCalendarMonthDataSuspenseQuery>;
export type GetCalendarMonthDataQueryResult = Apollo.QueryResult<GetCalendarMonthDataQuery, GetCalendarMonthDataQueryVariables>;
export const GetCalendarStudentAssignmentsDocument = gql`
    query GetCalendarStudentAssignments($day: date!) {
  courses(where: {studentCourses: {status: {_eq: ENROLLED}}}) {
    ...CalendarCourse
  }
}
    ${CalendarCourseFragmentDoc}
${CalendarStudentCourseFragmentDoc}
${CalendarStudentAssignmentsFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetCalendarStudentAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetCalendarStudentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarStudentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarStudentAssignmentsQuery({
 *   variables: {
 *      day: // value for 'day'
 *   },
 * });
 */
export function useGetCalendarStudentAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables> & ({ variables: GetCalendarStudentAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
      }
export function useGetCalendarStudentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetCalendarStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>;
export function useGetCalendarStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarStudentAssignmentsQuery | undefined, GetCalendarStudentAssignmentsQueryVariables>;
export function useGetCalendarStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>(GetCalendarStudentAssignmentsDocument, options);
        }
export type GetCalendarStudentAssignmentsQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsQuery>;
export type GetCalendarStudentAssignmentsLazyQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsLazyQuery>;
export type GetCalendarStudentAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarStudentAssignmentsSuspenseQuery>;
export type GetCalendarStudentAssignmentsQueryResult = Apollo.QueryResult<GetCalendarStudentAssignmentsQuery, GetCalendarStudentAssignmentsQueryVariables>;
export const GetStudentOptionsDocument = gql`
    query GetStudentOptions {
  students(order_by: {name: asc}) {
    ...StudentOption
  }
}
    ${StudentOptionFragmentDoc}`;

/**
 * __useGetStudentOptionsQuery__
 *
 * To run a query within a React component, call `useGetStudentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
      }
export function useGetStudentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
        }
// @ts-ignore
export function useGetStudentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>;
export function useGetStudentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentOptionsQuery | undefined, GetStudentOptionsQueryVariables>;
export function useGetStudentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>(GetStudentOptionsDocument, options);
        }
export type GetStudentOptionsQueryHookResult = ReturnType<typeof useGetStudentOptionsQuery>;
export type GetStudentOptionsLazyQueryHookResult = ReturnType<typeof useGetStudentOptionsLazyQuery>;
export type GetStudentOptionsSuspenseQueryHookResult = ReturnType<typeof useGetStudentOptionsSuspenseQuery>;
export type GetStudentOptionsQueryResult = Apollo.QueryResult<GetStudentOptionsQuery, GetStudentOptionsQueryVariables>;
export const GetCalendarVacationsDocument = gql`
    query GetCalendarVacations($day: date!) {
  events(
    where: {_and: [{eventType: {_eq: VACATION}}, {_and: [{start: {_lte: $day}}, {end: {_gte: $day}}]}]}
  ) {
    ...CalendarVacation
  }
}
    ${CalendarVacationFragmentDoc}`;

/**
 * __useGetCalendarVacationsQuery__
 *
 * To run a query within a React component, call `useGetCalendarVacationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarVacationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarVacationsQuery({
 *   variables: {
 *      day: // value for 'day'
 *   },
 * });
 */
export function useGetCalendarVacationsQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables> & ({ variables: GetCalendarVacationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
      }
export function useGetCalendarVacationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
        }
// @ts-ignore
export function useGetCalendarVacationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>;
export function useGetCalendarVacationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarVacationsQuery | undefined, GetCalendarVacationsQueryVariables>;
export function useGetCalendarVacationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>(GetCalendarVacationsDocument, options);
        }
export type GetCalendarVacationsQueryHookResult = ReturnType<typeof useGetCalendarVacationsQuery>;
export type GetCalendarVacationsLazyQueryHookResult = ReturnType<typeof useGetCalendarVacationsLazyQuery>;
export type GetCalendarVacationsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarVacationsSuspenseQuery>;
export type GetCalendarVacationsQueryResult = Apollo.QueryResult<GetCalendarVacationsQuery, GetCalendarVacationsQueryVariables>;
export const GetCalendarWeekDataDocument = gql`
    query GetCalendarWeekData($days: [date!]!, $startDay: date!, $endDay: date!) {
  courses(where: {studentCourses: {status: {_eq: ENROLLED}}}) {
    ...CalendarWeekCourse
  }
  events(
    where: {_and: [{eventType: {_eq: VACATION}}, {start: {_lte: $endDay}}, {end: {_gte: $startDay}}]}
  ) {
    ...CalendarWeekVacation
  }
}
    ${CalendarWeekCourseFragmentDoc}
${CalendarWeekStudentCourseFragmentDoc}
${CalendarStudentAssignmentsFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${CalendarWeekVacationFragmentDoc}`;

/**
 * __useGetCalendarWeekDataQuery__
 *
 * To run a query within a React component, call `useGetCalendarWeekDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarWeekDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarWeekDataQuery({
 *   variables: {
 *      days: // value for 'days'
 *      startDay: // value for 'startDay'
 *      endDay: // value for 'endDay'
 *   },
 * });
 */
export function useGetCalendarWeekDataQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables> & ({ variables: GetCalendarWeekDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>(GetCalendarWeekDataDocument, options);
      }
export function useGetCalendarWeekDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>(GetCalendarWeekDataDocument, options);
        }
// @ts-ignore
export function useGetCalendarWeekDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>;
export function useGetCalendarWeekDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalendarWeekDataQuery | undefined, GetCalendarWeekDataQueryVariables>;
export function useGetCalendarWeekDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>(GetCalendarWeekDataDocument, options);
        }
export type GetCalendarWeekDataQueryHookResult = ReturnType<typeof useGetCalendarWeekDataQuery>;
export type GetCalendarWeekDataLazyQueryHookResult = ReturnType<typeof useGetCalendarWeekDataLazyQuery>;
export type GetCalendarWeekDataSuspenseQueryHookResult = ReturnType<typeof useGetCalendarWeekDataSuspenseQuery>;
export type GetCalendarWeekDataQueryResult = Apollo.QueryResult<GetCalendarWeekDataQuery, GetCalendarWeekDataQueryVariables>;
export const GetCompletedCourseStudentsDocument = gql`
    query GetCompletedCourseStudents($courseId: uuid!) {
  studentCourses: student_courses(
    where: {_and: [{status: {_eq: COMPLETED}}, {courseSnapshot: {_contains: {course: {id: $courseId}}}}]}
  ) {
    id
    student {
      id
      name
      picture
    }
    ...CompletedStudentCourseCardInfo
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;

/**
 * __useGetCompletedCourseStudentsQuery__
 *
 * To run a query within a React component, call `useGetCompletedCourseStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedCourseStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedCourseStudentsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCompletedCourseStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables> & ({ variables: GetCompletedCourseStudentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
      }
export function useGetCompletedCourseStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
        }
// @ts-ignore
export function useGetCompletedCourseStudentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>;
export function useGetCompletedCourseStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedCourseStudentsQuery | undefined, GetCompletedCourseStudentsQueryVariables>;
export function useGetCompletedCourseStudentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>(GetCompletedCourseStudentsDocument, options);
        }
export type GetCompletedCourseStudentsQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsQuery>;
export type GetCompletedCourseStudentsLazyQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsLazyQuery>;
export type GetCompletedCourseStudentsSuspenseQueryHookResult = ReturnType<typeof useGetCompletedCourseStudentsSuspenseQuery>;
export type GetCompletedCourseStudentsQueryResult = Apollo.QueryResult<GetCompletedCourseStudentsQuery, GetCompletedCourseStudentsQueryVariables>;
export const GetCompletedStudentCourseInfoDocument = gql`
    query GetCompletedStudentCourseInfo($studentCourseId: uuid!) {
  studentCourse: student_course(id: $studentCourseId) {
    id
    ...CourseSnapshot
  }
}
    ${CourseSnapshotFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${CommentInfoFragmentDoc}`;

/**
 * __useGetCompletedStudentCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCourseInfoQuery({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useGetCompletedStudentCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables> & ({ variables: GetCompletedStudentCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
      }
export function useGetCompletedStudentCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
        }
// @ts-ignore
export function useGetCompletedStudentCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>;
export function useGetCompletedStudentCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCourseInfoQuery | undefined, GetCompletedStudentCourseInfoQueryVariables>;
export function useGetCompletedStudentCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>(GetCompletedStudentCourseInfoDocument, options);
        }
export type GetCompletedStudentCourseInfoQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoQuery>;
export type GetCompletedStudentCourseInfoLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoLazyQuery>;
export type GetCompletedStudentCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCourseInfoSuspenseQuery>;
export type GetCompletedStudentCourseInfoQueryResult = Apollo.QueryResult<GetCompletedStudentCourseInfoQuery, GetCompletedStudentCourseInfoQueryVariables>;
export const GetCompletedStudentCoursesDocument = gql`
    query GetCompletedStudentCourses($studentId: String!) {
  student(id: $studentId) {
    id
    name
    picture
    studentCourses(where: {status: {_eq: COMPLETED}}) {
      ...CompletedStudentCourseCardInfo
    }
  }
}
    ${CompletedStudentCourseCardInfoFragmentDoc}`;

/**
 * __useGetCompletedStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCoursesQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetCompletedStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables> & ({ variables: GetCompletedStudentCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
      }
export function useGetCompletedStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
        }
// @ts-ignore
export function useGetCompletedStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>;
export function useGetCompletedStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCoursesQuery | undefined, GetCompletedStudentCoursesQueryVariables>;
export function useGetCompletedStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>(GetCompletedStudentCoursesDocument, options);
        }
export type GetCompletedStudentCoursesQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesQuery>;
export type GetCompletedStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesLazyQuery>;
export type GetCompletedStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesSuspenseQuery>;
export type GetCompletedStudentCoursesQueryResult = Apollo.QueryResult<GetCompletedStudentCoursesQuery, GetCompletedStudentCoursesQueryVariables>;
export const GetCompletedStudentCoursesForYearDocument = gql`
    query GetCompletedStudentCoursesForYear($studentId: String!, $calendarYears: [String!]!) {
  student(id: $studentId) {
    id
    studentCourses(
      where: {status: {_eq: COMPLETED}, calendarYear: {_in: $calendarYears}}
    ) {
      ...CompletedStudentTranscriptCourse
    }
  }
}
    ${CompletedStudentTranscriptCourseFragmentDoc}`;

/**
 * __useGetCompletedStudentCoursesForYearQuery__
 *
 * To run a query within a React component, call `useGetCompletedStudentCoursesForYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedStudentCoursesForYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedStudentCoursesForYearQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      calendarYears: // value for 'calendarYears'
 *   },
 * });
 */
export function useGetCompletedStudentCoursesForYearQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables> & ({ variables: GetCompletedStudentCoursesForYearQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
      }
export function useGetCompletedStudentCoursesForYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
        }
// @ts-ignore
export function useGetCompletedStudentCoursesForYearSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>;
export function useGetCompletedStudentCoursesForYearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletedStudentCoursesForYearQuery | undefined, GetCompletedStudentCoursesForYearQueryVariables>;
export function useGetCompletedStudentCoursesForYearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>(GetCompletedStudentCoursesForYearDocument, options);
        }
export type GetCompletedStudentCoursesForYearQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearQuery>;
export type GetCompletedStudentCoursesForYearLazyQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearLazyQuery>;
export type GetCompletedStudentCoursesForYearSuspenseQueryHookResult = ReturnType<typeof useGetCompletedStudentCoursesForYearSuspenseQuery>;
export type GetCompletedStudentCoursesForYearQueryResult = Apollo.QueryResult<GetCompletedStudentCoursesForYearQuery, GetCompletedStudentCoursesForYearQueryVariables>;
export const GetCourseAssignmentsScheduleDocument = gql`
    query GetCourseAssignmentsSchedule($courseId: uuid!) {
  course(id: $courseId) {
    id
    assignments {
      ...CourseAssignmentSchedule
    }
  }
}
    ${CourseAssignmentScheduleFragmentDoc}`;

/**
 * __useGetCourseAssignmentsScheduleQuery__
 *
 * To run a query within a React component, call `useGetCourseAssignmentsScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAssignmentsScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAssignmentsScheduleQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseAssignmentsScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables> & ({ variables: GetCourseAssignmentsScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
      }
export function useGetCourseAssignmentsScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
        }
// @ts-ignore
export function useGetCourseAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>;
export function useGetCourseAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAssignmentsScheduleQuery | undefined, GetCourseAssignmentsScheduleQueryVariables>;
export function useGetCourseAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>(GetCourseAssignmentsScheduleDocument, options);
        }
export type GetCourseAssignmentsScheduleQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleQuery>;
export type GetCourseAssignmentsScheduleLazyQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleLazyQuery>;
export type GetCourseAssignmentsScheduleSuspenseQueryHookResult = ReturnType<typeof useGetCourseAssignmentsScheduleSuspenseQuery>;
export type GetCourseAssignmentsScheduleQueryResult = Apollo.QueryResult<GetCourseAssignmentsScheduleQuery, GetCourseAssignmentsScheduleQueryVariables>;
export const GetCoursesAssignmentsScheduleDocument = gql`
    query GetCoursesAssignmentsSchedule($courseIds: [uuid!]!) {
  courses(where: {id: {_in: $courseIds}}) {
    id
    numberOfDaysPerWeek
    numberOfWeeks
    assignments {
      ...CourseAssignmentSchedule
    }
  }
}
    ${CourseAssignmentScheduleFragmentDoc}`;

/**
 * __useGetCoursesAssignmentsScheduleQuery__
 *
 * To run a query within a React component, call `useGetCoursesAssignmentsScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesAssignmentsScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesAssignmentsScheduleQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetCoursesAssignmentsScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables> & ({ variables: GetCoursesAssignmentsScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
      }
export function useGetCoursesAssignmentsScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
        }
// @ts-ignore
export function useGetCoursesAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>;
export function useGetCoursesAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesAssignmentsScheduleQuery | undefined, GetCoursesAssignmentsScheduleQueryVariables>;
export function useGetCoursesAssignmentsScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>(GetCoursesAssignmentsScheduleDocument, options);
        }
export type GetCoursesAssignmentsScheduleQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleQuery>;
export type GetCoursesAssignmentsScheduleLazyQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleLazyQuery>;
export type GetCoursesAssignmentsScheduleSuspenseQueryHookResult = ReturnType<typeof useGetCoursesAssignmentsScheduleSuspenseQuery>;
export type GetCoursesAssignmentsScheduleQueryResult = Apollo.QueryResult<GetCoursesAssignmentsScheduleQuery, GetCoursesAssignmentsScheduleQueryVariables>;
export const GetCourseCardsDocument = gql`
    query GetCourseCards($includeStudentData: Boolean = true, $includeOrganizationCourseGroups: Boolean = false) {
  courses(order_by: {name: asc}) {
    ...CourseCardInfo
  }
}
    ${CourseCardInfoFragmentDoc}
${CourseStudentCardInfoFragmentDoc}`;

/**
 * __useGetCourseCardsQuery__
 *
 * To run a query within a React component, call `useGetCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCardsQuery({
 *   variables: {
 *      includeStudentData: // value for 'includeStudentData'
 *      includeOrganizationCourseGroups: // value for 'includeOrganizationCourseGroups'
 *   },
 * });
 */
export function useGetCourseCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
      }
export function useGetCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
        }
// @ts-ignore
export function useGetCourseCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCardsQuery, GetCourseCardsQueryVariables>;
export function useGetCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCardsQuery | undefined, GetCourseCardsQueryVariables>;
export function useGetCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCardsQuery, GetCourseCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseCardsQuery, GetCourseCardsQueryVariables>(GetCourseCardsDocument, options);
        }
export type GetCourseCardsQueryHookResult = ReturnType<typeof useGetCourseCardsQuery>;
export type GetCourseCardsLazyQueryHookResult = ReturnType<typeof useGetCourseCardsLazyQuery>;
export type GetCourseCardsSuspenseQueryHookResult = ReturnType<typeof useGetCourseCardsSuspenseQuery>;
export type GetCourseCardsQueryResult = Apollo.QueryResult<GetCourseCardsQuery, GetCourseCardsQueryVariables>;
export const GetCourseInfoDocument = gql`
    query GetCourseInfo($courseId: uuid!, $includeStudentData: Boolean = true, $includeOrganizationCourseGroups: Boolean = false) {
  course(id: $courseId) {
    ...CourseInfo
  }
}
    ${CourseInfoFragmentDoc}
${CourseInfoAssignmentFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${CourseInfoStudentCourseFragmentDoc}
${RequiredStudentCourseInfoFragmentDoc}`;

/**
 * __useGetCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseInfoQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      includeStudentData: // value for 'includeStudentData'
 *      includeOrganizationCourseGroups: // value for 'includeOrganizationCourseGroups'
 *   },
 * });
 */
export function useGetCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables> & ({ variables: GetCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
      }
export function useGetCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
        }
// @ts-ignore
export function useGetCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseInfoQuery, GetCourseInfoQueryVariables>;
export function useGetCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseInfoQuery | undefined, GetCourseInfoQueryVariables>;
export function useGetCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseInfoQuery, GetCourseInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseInfoQuery, GetCourseInfoQueryVariables>(GetCourseInfoDocument, options);
        }
export type GetCourseInfoQueryHookResult = ReturnType<typeof useGetCourseInfoQuery>;
export type GetCourseInfoLazyQueryHookResult = ReturnType<typeof useGetCourseInfoLazyQuery>;
export type GetCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetCourseInfoSuspenseQuery>;
export type GetCourseInfoQueryResult = Apollo.QueryResult<GetCourseInfoQuery, GetCourseInfoQueryVariables>;
export const GetCourseLabelsDocument = gql`
    query GetCourseLabels {
  courses {
    id
    labels
  }
}
    `;

/**
 * __useGetCourseLabelsQuery__
 *
 * To run a query within a React component, call `useGetCourseLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseLabelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>(GetCourseLabelsDocument, options);
      }
export function useGetCourseLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>(GetCourseLabelsDocument, options);
        }
// @ts-ignore
export function useGetCourseLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>;
export function useGetCourseLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseLabelsQuery | undefined, GetCourseLabelsQueryVariables>;
export function useGetCourseLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>(GetCourseLabelsDocument, options);
        }
export type GetCourseLabelsQueryHookResult = ReturnType<typeof useGetCourseLabelsQuery>;
export type GetCourseLabelsLazyQueryHookResult = ReturnType<typeof useGetCourseLabelsLazyQuery>;
export type GetCourseLabelsSuspenseQueryHookResult = ReturnType<typeof useGetCourseLabelsSuspenseQuery>;
export type GetCourseLabelsQueryResult = Apollo.QueryResult<GetCourseLabelsQuery, GetCourseLabelsQueryVariables>;
export const GetCoursePlanCardDocument = gql`
    query GetCoursePlanCard($courseId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments {
      ...CoursePlanCardAssignment
    }
  }
}
    ${CoursePlanCardAssignmentFragmentDoc}`;

/**
 * __useGetCoursePlanCardQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCoursePlanCardQuery(baseOptions: Apollo.QueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables> & ({ variables: GetCoursePlanCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
      }
export function useGetCoursePlanCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
        }
// @ts-ignore
export function useGetCoursePlanCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>;
export function useGetCoursePlanCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardQuery | undefined, GetCoursePlanCardQueryVariables>;
export function useGetCoursePlanCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>(GetCoursePlanCardDocument, options);
        }
export type GetCoursePlanCardQueryHookResult = ReturnType<typeof useGetCoursePlanCardQuery>;
export type GetCoursePlanCardLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardLazyQuery>;
export type GetCoursePlanCardSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardSuspenseQuery>;
export type GetCoursePlanCardQueryResult = Apollo.QueryResult<GetCoursePlanCardQuery, GetCoursePlanCardQueryVariables>;
export const GetCoursePlanCardsDocument = gql`
    query GetCoursePlanCards($includeStudentData: Boolean = false) {
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CoursePlanCardInfo
  }
}
    ${CoursePlanCardInfoFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}
${CoursePlanCardStudentCourseFragmentDoc}
${StudentsEventsFragmentDoc}`;

/**
 * __useGetCoursePlanCardsQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardsQuery({
 *   variables: {
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useGetCoursePlanCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
      }
export function useGetCoursePlanCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
        }
// @ts-ignore
export function useGetCoursePlanCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>;
export function useGetCoursePlanCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardsQuery | undefined, GetCoursePlanCardsQueryVariables>;
export function useGetCoursePlanCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>(GetCoursePlanCardsDocument, options);
        }
export type GetCoursePlanCardsQueryHookResult = ReturnType<typeof useGetCoursePlanCardsQuery>;
export type GetCoursePlanCardsLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardsLazyQuery>;
export type GetCoursePlanCardsSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardsSuspenseQuery>;
export type GetCoursePlanCardsQueryResult = Apollo.QueryResult<GetCoursePlanCardsQuery, GetCoursePlanCardsQueryVariables>;
export const GetCoursePlanCardsFromParrotRequestsDocument = gql`
    query GetCoursePlanCardsFromParrotRequests($userId: String!, $includeStudentData: Boolean = false) {
  parrotRequests: parrot_requests(
    order_by: {created: asc}
    where: {_and: [{claimerId: {_eq: $userId}}, {status: {_neq: COMPLETE}}, {status: {_neq: BLOCKED}}]}
  ) {
    id
    status
    course {
      ...CoursePlanCardInfo
    }
  }
}
    ${CoursePlanCardInfoFragmentDoc}
${CoursePlanCardAssignmentFragmentDoc}
${CoursePlanCardStudentCourseFragmentDoc}
${StudentsEventsFragmentDoc}`;

/**
 * __useGetCoursePlanCardsFromParrotRequestsQuery__
 *
 * To run a query within a React component, call `useGetCoursePlanCardsFromParrotRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursePlanCardsFromParrotRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursePlanCardsFromParrotRequestsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useGetCoursePlanCardsFromParrotRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables> & ({ variables: GetCoursePlanCardsFromParrotRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
      }
export function useGetCoursePlanCardsFromParrotRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
        }
// @ts-ignore
export function useGetCoursePlanCardsFromParrotRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>;
export function useGetCoursePlanCardsFromParrotRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursePlanCardsFromParrotRequestsQuery | undefined, GetCoursePlanCardsFromParrotRequestsQueryVariables>;
export function useGetCoursePlanCardsFromParrotRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>(GetCoursePlanCardsFromParrotRequestsDocument, options);
        }
export type GetCoursePlanCardsFromParrotRequestsQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsQuery>;
export type GetCoursePlanCardsFromParrotRequestsLazyQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsLazyQuery>;
export type GetCoursePlanCardsFromParrotRequestsSuspenseQueryHookResult = ReturnType<typeof useGetCoursePlanCardsFromParrotRequestsSuspenseQuery>;
export type GetCoursePlanCardsFromParrotRequestsQueryResult = Apollo.QueryResult<GetCoursePlanCardsFromParrotRequestsQuery, GetCoursePlanCardsFromParrotRequestsQueryVariables>;
export const GetCourseRescheduleInfoDocument = gql`
    query GetCourseRescheduleInfo($courseId: uuid!, $studentCourseIds: [uuid!] = [], $includeStudentData: Boolean = true) {
  course(id: $courseId) {
    id
    assignments {
      ...CourseInfoAssignment
    }
    studentCourses(where: {id: {_in: $studentCourseIds}, status: {_eq: ENROLLED}}) @include(if: $includeStudentData) {
      id
      ...RequiredStudentCourseInfo
      studentAssignments {
        ...CourseInfoStudentAssignment
      }
      student {
        id
        name
        picture
        studentEvents {
          id
          event {
            id
            start
            end
            ignoredCourses {
              course {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${CourseInfoAssignmentFragmentDoc}
${RequiredStudentCourseInfoFragmentDoc}
${CourseInfoStudentAssignmentFragmentDoc}`;

/**
 * __useGetCourseRescheduleInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseRescheduleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseRescheduleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseRescheduleInfoQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      studentCourseIds: // value for 'studentCourseIds'
 *      includeStudentData: // value for 'includeStudentData'
 *   },
 * });
 */
export function useGetCourseRescheduleInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables> & ({ variables: GetCourseRescheduleInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
      }
export function useGetCourseRescheduleInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
        }
// @ts-ignore
export function useGetCourseRescheduleInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>;
export function useGetCourseRescheduleInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseRescheduleInfoQuery | undefined, GetCourseRescheduleInfoQueryVariables>;
export function useGetCourseRescheduleInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>(GetCourseRescheduleInfoDocument, options);
        }
export type GetCourseRescheduleInfoQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoQuery>;
export type GetCourseRescheduleInfoLazyQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoLazyQuery>;
export type GetCourseRescheduleInfoSuspenseQueryHookResult = ReturnType<typeof useGetCourseRescheduleInfoSuspenseQuery>;
export type GetCourseRescheduleInfoQueryResult = Apollo.QueryResult<GetCourseRescheduleInfoQuery, GetCourseRescheduleInfoQueryVariables>;
export const GetCourseShareLinksDocument = gql`
    query GetCourseShareLinks($courseId: uuid!) {
  courseShareLinks: course_share_links(
    where: {courseId: {_eq: $courseId}}
    order_by: {created: desc}
  ) {
    id
    code
    label
    public
    maxUses
    remainingUses
  }
}
    `;

/**
 * __useGetCourseShareLinksQuery__
 *
 * To run a query within a React component, call `useGetCourseShareLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseShareLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseShareLinksQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseShareLinksQuery(baseOptions: Apollo.QueryHookOptions<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables> & ({ variables: GetCourseShareLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>(GetCourseShareLinksDocument, options);
      }
export function useGetCourseShareLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>(GetCourseShareLinksDocument, options);
        }
// @ts-ignore
export function useGetCourseShareLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>;
export function useGetCourseShareLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseShareLinksQuery | undefined, GetCourseShareLinksQueryVariables>;
export function useGetCourseShareLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>(GetCourseShareLinksDocument, options);
        }
export type GetCourseShareLinksQueryHookResult = ReturnType<typeof useGetCourseShareLinksQuery>;
export type GetCourseShareLinksLazyQueryHookResult = ReturnType<typeof useGetCourseShareLinksLazyQuery>;
export type GetCourseShareLinksSuspenseQueryHookResult = ReturnType<typeof useGetCourseShareLinksSuspenseQuery>;
export type GetCourseShareLinksQueryResult = Apollo.QueryResult<GetCourseShareLinksQuery, GetCourseShareLinksQueryVariables>;
export const GetCourseSubjectsDocument = gql`
    query GetCourseSubjects {
  courses {
    id
    subjects
  }
}
    `;

/**
 * __useGetCourseSubjectsQuery__
 *
 * To run a query within a React component, call `useGetCourseSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
      }
export function useGetCourseSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
        }
// @ts-ignore
export function useGetCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>;
export function useGetCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseSubjectsQuery | undefined, GetCourseSubjectsQueryVariables>;
export function useGetCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>(GetCourseSubjectsDocument, options);
        }
export type GetCourseSubjectsQueryHookResult = ReturnType<typeof useGetCourseSubjectsQuery>;
export type GetCourseSubjectsLazyQueryHookResult = ReturnType<typeof useGetCourseSubjectsLazyQuery>;
export type GetCourseSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetCourseSubjectsSuspenseQuery>;
export type GetCourseSubjectsQueryResult = Apollo.QueryResult<GetCourseSubjectsQuery, GetCourseSubjectsQueryVariables>;
export const GetCoursesByAssignmentTypeDocument = gql`
    query GetCoursesByAssignmentType($customAssignmentTypeId: uuid!) {
  courses(
    where: {assignmentTypeWeights: {customAssignmentTypeId: {_eq: $customAssignmentTypeId}}}
  ) {
    id
    assignmentTypeWeights {
      id
      customAssignmentTypeId
    }
  }
}
    `;

/**
 * __useGetCoursesByAssignmentTypeQuery__
 *
 * To run a query within a React component, call `useGetCoursesByAssignmentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByAssignmentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByAssignmentTypeQuery({
 *   variables: {
 *      customAssignmentTypeId: // value for 'customAssignmentTypeId'
 *   },
 * });
 */
export function useGetCoursesByAssignmentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables> & ({ variables: GetCoursesByAssignmentTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
      }
export function useGetCoursesByAssignmentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
        }
// @ts-ignore
export function useGetCoursesByAssignmentTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>;
export function useGetCoursesByAssignmentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByAssignmentTypeQuery | undefined, GetCoursesByAssignmentTypeQueryVariables>;
export function useGetCoursesByAssignmentTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>(GetCoursesByAssignmentTypeDocument, options);
        }
export type GetCoursesByAssignmentTypeQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeQuery>;
export type GetCoursesByAssignmentTypeLazyQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeLazyQuery>;
export type GetCoursesByAssignmentTypeSuspenseQueryHookResult = ReturnType<typeof useGetCoursesByAssignmentTypeSuspenseQuery>;
export type GetCoursesByAssignmentTypeQueryResult = Apollo.QueryResult<GetCoursesByAssignmentTypeQuery, GetCoursesByAssignmentTypeQueryVariables>;
export const GetCustomAssignmentTypesDocument = gql`
    query GetCustomAssignmentTypes {
  customAssignmentTypes: custom_assignment_types(order_by: {sortOrder: asc}) {
    ...CustomAssignmentType
  }
}
    ${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetCustomAssignmentTypesQuery__
 *
 * To run a query within a React component, call `useGetCustomAssignmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomAssignmentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomAssignmentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomAssignmentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
      }
export function useGetCustomAssignmentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
        }
// @ts-ignore
export function useGetCustomAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>;
export function useGetCustomAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomAssignmentTypesQuery | undefined, GetCustomAssignmentTypesQueryVariables>;
export function useGetCustomAssignmentTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>(GetCustomAssignmentTypesDocument, options);
        }
export type GetCustomAssignmentTypesQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesQuery>;
export type GetCustomAssignmentTypesLazyQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesLazyQuery>;
export type GetCustomAssignmentTypesSuspenseQueryHookResult = ReturnType<typeof useGetCustomAssignmentTypesSuspenseQuery>;
export type GetCustomAssignmentTypesQueryResult = Apollo.QueryResult<GetCustomAssignmentTypesQuery, GetCustomAssignmentTypesQueryVariables>;
export const GetCustomerInfoDocument = gql`
    query GetCustomerInfo($teacherId: String!) {
  teacher(id: $teacherId) {
    id
    needsDemoData
    customer {
      id
      subscriptionStatus
      freeTrialEnd
      planTier
      parrotCredits
      extendedTrial
    }
  }
}
    `;

/**
 * __useGetCustomerInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInfoQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetCustomerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables> & ({ variables: GetCustomerInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
      }
export function useGetCustomerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
// @ts-ignore
export function useGetCustomerInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>;
export function useGetCustomerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerInfoQuery | undefined, GetCustomerInfoQueryVariables>;
export function useGetCustomerInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
export type GetCustomerInfoQueryHookResult = ReturnType<typeof useGetCustomerInfoQuery>;
export type GetCustomerInfoLazyQueryHookResult = ReturnType<typeof useGetCustomerInfoLazyQuery>;
export type GetCustomerInfoSuspenseQueryHookResult = ReturnType<typeof useGetCustomerInfoSuspenseQuery>;
export type GetCustomerInfoQueryResult = Apollo.QueryResult<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>;
export const GetCustomerInfoByStudentDocument = gql`
    query GetCustomerInfoByStudent($studentId: String!) {
  student(id: $studentId) {
    id
    teachers {
      teacher {
        id
        customer {
          id
          subscriptionStatus
          planTier
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerInfoByStudentQuery__
 *
 * To run a query within a React component, call `useGetCustomerInfoByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInfoByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInfoByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetCustomerInfoByStudentQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables> & ({ variables: GetCustomerInfoByStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
      }
export function useGetCustomerInfoByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
        }
// @ts-ignore
export function useGetCustomerInfoByStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>;
export function useGetCustomerInfoByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerInfoByStudentQuery | undefined, GetCustomerInfoByStudentQueryVariables>;
export function useGetCustomerInfoByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>(GetCustomerInfoByStudentDocument, options);
        }
export type GetCustomerInfoByStudentQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentQuery>;
export type GetCustomerInfoByStudentLazyQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentLazyQuery>;
export type GetCustomerInfoByStudentSuspenseQueryHookResult = ReturnType<typeof useGetCustomerInfoByStudentSuspenseQuery>;
export type GetCustomerInfoByStudentQueryResult = Apollo.QueryResult<GetCustomerInfoByStudentQuery, GetCustomerInfoByStudentQueryVariables>;
export const GetEventsInfoDocument = gql`
    query GetEventsInfo($studentIds: [String!]) {
  events(
    where: {studentEvents: {student: {id: {_in: $studentIds}}}}
    order_by: {start: desc}
  ) {
    ...EventInfo
  }
}
    ${EventInfoFragmentDoc}`;

/**
 * __useGetEventsInfoQuery__
 *
 * To run a query within a React component, call `useGetEventsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsInfoQuery({
 *   variables: {
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useGetEventsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
      }
export function useGetEventsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
        }
// @ts-ignore
export function useGetEventsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsInfoQuery, GetEventsInfoQueryVariables>;
export function useGetEventsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetEventsInfoQuery | undefined, GetEventsInfoQueryVariables>;
export function useGetEventsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventsInfoQuery, GetEventsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsInfoQuery, GetEventsInfoQueryVariables>(GetEventsInfoDocument, options);
        }
export type GetEventsInfoQueryHookResult = ReturnType<typeof useGetEventsInfoQuery>;
export type GetEventsInfoLazyQueryHookResult = ReturnType<typeof useGetEventsInfoLazyQuery>;
export type GetEventsInfoSuspenseQueryHookResult = ReturnType<typeof useGetEventsInfoSuspenseQuery>;
export type GetEventsInfoQueryResult = Apollo.QueryResult<GetEventsInfoQuery, GetEventsInfoQueryVariables>;
export const GetFilterOptionsDocument = gql`
    query GetFilterOptions {
  students(order_by: {name: asc}) {
    ...StudentOption
  }
  courses(where: {archived: {_eq: false}}, order_by: {name: asc}) {
    ...CourseOption
  }
  customAssignmentTypes: custom_assignment_types {
    ...CustomAssignmentType
  }
}
    ${StudentOptionFragmentDoc}
${CourseOptionFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
      }
export function useGetFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilterOptionsQuery | undefined, GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
export type GetFilterOptionsQueryHookResult = ReturnType<typeof useGetFilterOptionsQuery>;
export type GetFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetFilterOptionsLazyQuery>;
export type GetFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetFilterOptionsSuspenseQuery>;
export type GetFilterOptionsQueryResult = Apollo.QueryResult<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>;
export const GetHomeStudentAssignmentsDocument = gql`
    query GetHomeStudentAssignments($isStudent: Boolean!, $dueDateBounds: date_comparison_exp!, $startBounds: date_comparison_exp!, $completedTodayFilter: student_assignments_bool_exp!) {
  studentAssignments: student_assignments(
    where: {_or: [{_and: [{status: {_eq: INCOMPLETE}}, {end: $dueDateBounds}, {start: $startBounds}]}, $completedTodayFilter]}
  ) {
    ...StudentAssignmentDetails
  }
  studentAssignmentsForGrading: student_assignments(
    where: {_and: [{pointsEarned: {_is_null: true}}, {assignment: {graded: {_eq: true}}}, {status: {_eq: COMPLETE}}, {end: $dueDateBounds}]}
  ) {
    ...StudentAssignmentDetails
  }
}
    ${StudentAssignmentDetailsFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentsEventsFragmentDoc}
${CommentInfoFragmentDoc}`;

/**
 * __useGetHomeStudentAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetHomeStudentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeStudentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeStudentAssignmentsQuery({
 *   variables: {
 *      isStudent: // value for 'isStudent'
 *      dueDateBounds: // value for 'dueDateBounds'
 *      startBounds: // value for 'startBounds'
 *      completedTodayFilter: // value for 'completedTodayFilter'
 *   },
 * });
 */
export function useGetHomeStudentAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables> & ({ variables: GetHomeStudentAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
      }
export function useGetHomeStudentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetHomeStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>;
export function useGetHomeStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHomeStudentAssignmentsQuery | undefined, GetHomeStudentAssignmentsQueryVariables>;
export function useGetHomeStudentAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>(GetHomeStudentAssignmentsDocument, options);
        }
export type GetHomeStudentAssignmentsQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsQuery>;
export type GetHomeStudentAssignmentsLazyQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsLazyQuery>;
export type GetHomeStudentAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetHomeStudentAssignmentsSuspenseQuery>;
export type GetHomeStudentAssignmentsQueryResult = Apollo.QueryResult<GetHomeStudentAssignmentsQuery, GetHomeStudentAssignmentsQueryVariables>;
export const GetOrganizationAdminInfoDocument = gql`
    query GetOrganizationAdminInfo($organizationAdminId: String!) {
  organizationAdmin: organization_admin(id: $organizationAdminId) {
    ...OrganizationAdminInfo
  }
}
    ${OrganizationAdminInfoFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationAdminInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAdminInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAdminInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAdminInfoQuery({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *   },
 * });
 */
export function useGetOrganizationAdminInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables> & ({ variables: GetOrganizationAdminInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
      }
export function useGetOrganizationAdminInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
        }
// @ts-ignore
export function useGetOrganizationAdminInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>;
export function useGetOrganizationAdminInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationAdminInfoQuery | undefined, GetOrganizationAdminInfoQueryVariables>;
export function useGetOrganizationAdminInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>(GetOrganizationAdminInfoDocument, options);
        }
export type GetOrganizationAdminInfoQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoQuery>;
export type GetOrganizationAdminInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoLazyQuery>;
export type GetOrganizationAdminInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationAdminInfoSuspenseQuery>;
export type GetOrganizationAdminInfoQueryResult = Apollo.QueryResult<GetOrganizationAdminInfoQuery, GetOrganizationAdminInfoQueryVariables>;
export const GetOrganizationCourseCardsDocument = gql`
    query GetOrganizationCourseCards($organizationId: uuid!) {
  organizationCourses(organizationId: $organizationId) {
    ...OrganizationCourseCardInfo
  }
}
    ${OrganizationCourseCardInfoFragmentDoc}`;

/**
 * __useGetOrganizationCourseCardsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseCardsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationCourseCardsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables> & ({ variables: GetOrganizationCourseCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
      }
export function useGetOrganizationCourseCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>;
export function useGetOrganizationCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseCardsQuery | undefined, GetOrganizationCourseCardsQueryVariables>;
export function useGetOrganizationCourseCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>(GetOrganizationCourseCardsDocument, options);
        }
export type GetOrganizationCourseCardsQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsQuery>;
export type GetOrganizationCourseCardsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsLazyQuery>;
export type GetOrganizationCourseCardsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseCardsSuspenseQuery>;
export type GetOrganizationCourseCardsQueryResult = Apollo.QueryResult<GetOrganizationCourseCardsQuery, GetOrganizationCourseCardsQueryVariables>;
export const GetOrganizationCourseGroupsDocument = gql`
    query GetOrganizationCourseGroups {
  organizationCourseGroups: organization_course_groups(order_by: {name: asc}) {
    ...OrganizationCourseGroupInfo
  }
}
    ${OrganizationCourseGroupInfoFragmentDoc}`;

/**
 * __useGetOrganizationCourseGroupsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationCourseGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>(GetOrganizationCourseGroupsDocument, options);
      }
export function useGetOrganizationCourseGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>(GetOrganizationCourseGroupsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>;
export function useGetOrganizationCourseGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseGroupsQuery | undefined, GetOrganizationCourseGroupsQueryVariables>;
export function useGetOrganizationCourseGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>(GetOrganizationCourseGroupsDocument, options);
        }
export type GetOrganizationCourseGroupsQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsQuery>;
export type GetOrganizationCourseGroupsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsLazyQuery>;
export type GetOrganizationCourseGroupsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsSuspenseQuery>;
export type GetOrganizationCourseGroupsQueryResult = Apollo.QueryResult<GetOrganizationCourseGroupsQuery, GetOrganizationCourseGroupsQueryVariables>;
export const GetOrganizationCourseGroupsWithCoursesAndMembersDocument = gql`
    query GetOrganizationCourseGroupsWithCoursesAndMembers {
  organizationCourseGroups: organization_course_groups {
    ...OrganizationCourseGroupInfoWithCoursesAndMembers
  }
}
    ${OrganizationCourseGroupInfoWithCoursesAndMembersFragmentDoc}`;

/**
 * __useGetOrganizationCourseGroupsWithCoursesAndMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseGroupsWithCoursesAndMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseGroupsWithCoursesAndMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseGroupsWithCoursesAndMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationCourseGroupsWithCoursesAndMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>(GetOrganizationCourseGroupsWithCoursesAndMembersDocument, options);
      }
export function useGetOrganizationCourseGroupsWithCoursesAndMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>(GetOrganizationCourseGroupsWithCoursesAndMembersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseGroupsWithCoursesAndMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>;
export function useGetOrganizationCourseGroupsWithCoursesAndMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseGroupsWithCoursesAndMembersQuery | undefined, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>;
export function useGetOrganizationCourseGroupsWithCoursesAndMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>(GetOrganizationCourseGroupsWithCoursesAndMembersDocument, options);
        }
export type GetOrganizationCourseGroupsWithCoursesAndMembersQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsWithCoursesAndMembersQuery>;
export type GetOrganizationCourseGroupsWithCoursesAndMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsWithCoursesAndMembersLazyQuery>;
export type GetOrganizationCourseGroupsWithCoursesAndMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseGroupsWithCoursesAndMembersSuspenseQuery>;
export type GetOrganizationCourseGroupsWithCoursesAndMembersQueryResult = Apollo.QueryResult<GetOrganizationCourseGroupsWithCoursesAndMembersQuery, GetOrganizationCourseGroupsWithCoursesAndMembersQueryVariables>;
export const GetOrganizationCourseInfoDocument = gql`
    query GetOrganizationCourseInfo($organizationId: uuid!, $courseId: uuid!) {
  organizationCourse(courseId: $courseId, organizationId: $organizationId) {
    ...OrganizationCourseInfo
  }
}
    ${OrganizationCourseInfoFragmentDoc}`;

/**
 * __useGetOrganizationCourseInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetOrganizationCourseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables> & ({ variables: GetOrganizationCourseInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
      }
export function useGetOrganizationCourseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>;
export function useGetOrganizationCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseInfoQuery | undefined, GetOrganizationCourseInfoQueryVariables>;
export function useGetOrganizationCourseInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>(GetOrganizationCourseInfoDocument, options);
        }
export type GetOrganizationCourseInfoQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoQuery>;
export type GetOrganizationCourseInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoLazyQuery>;
export type GetOrganizationCourseInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseInfoSuspenseQuery>;
export type GetOrganizationCourseInfoQueryResult = Apollo.QueryResult<GetOrganizationCourseInfoQuery, GetOrganizationCourseInfoQueryVariables>;
export const GetOrganizationCourseLabelsDocument = gql`
    query GetOrganizationCourseLabels($organizationId: uuid!) {
  organizationCourses(organizationId: $organizationId) {
    id
    labels
  }
}
    `;

/**
 * __useGetOrganizationCourseLabelsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseLabelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationCourseLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables> & ({ variables: GetOrganizationCourseLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>(GetOrganizationCourseLabelsDocument, options);
      }
export function useGetOrganizationCourseLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>(GetOrganizationCourseLabelsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>;
export function useGetOrganizationCourseLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseLabelsQuery | undefined, GetOrganizationCourseLabelsQueryVariables>;
export function useGetOrganizationCourseLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>(GetOrganizationCourseLabelsDocument, options);
        }
export type GetOrganizationCourseLabelsQueryHookResult = ReturnType<typeof useGetOrganizationCourseLabelsQuery>;
export type GetOrganizationCourseLabelsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseLabelsLazyQuery>;
export type GetOrganizationCourseLabelsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseLabelsSuspenseQuery>;
export type GetOrganizationCourseLabelsQueryResult = Apollo.QueryResult<GetOrganizationCourseLabelsQuery, GetOrganizationCourseLabelsQueryVariables>;
export const GetOrganizationCourseSubjectsDocument = gql`
    query GetOrganizationCourseSubjects($organizationId: uuid!) {
  organizationCourses(organizationId: $organizationId) {
    id
    subjects
  }
}
    `;

/**
 * __useGetOrganizationCourseSubjectsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationCourseSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationCourseSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationCourseSubjectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationCourseSubjectsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables> & ({ variables: GetOrganizationCourseSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
      }
export function useGetOrganizationCourseSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>;
export function useGetOrganizationCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationCourseSubjectsQuery | undefined, GetOrganizationCourseSubjectsQueryVariables>;
export function useGetOrganizationCourseSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>(GetOrganizationCourseSubjectsDocument, options);
        }
export type GetOrganizationCourseSubjectsQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsQuery>;
export type GetOrganizationCourseSubjectsLazyQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsLazyQuery>;
export type GetOrganizationCourseSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationCourseSubjectsSuspenseQuery>;
export type GetOrganizationCourseSubjectsQueryResult = Apollo.QueryResult<GetOrganizationCourseSubjectsQuery, GetOrganizationCourseSubjectsQueryVariables>;
export const GetOrganizationInfoDocument = gql`
    query GetOrganizationInfo($organizationId: uuid!) {
  organization(id: $organizationId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables> & ({ variables: GetOrganizationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
      }
export function useGetOrganizationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
        }
// @ts-ignore
export function useGetOrganizationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>;
export function useGetOrganizationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationInfoQuery | undefined, GetOrganizationInfoQueryVariables>;
export function useGetOrganizationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>(GetOrganizationInfoDocument, options);
        }
export type GetOrganizationInfoQueryHookResult = ReturnType<typeof useGetOrganizationInfoQuery>;
export type GetOrganizationInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationInfoLazyQuery>;
export type GetOrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationInfoSuspenseQuery>;
export type GetOrganizationInfoQueryResult = Apollo.QueryResult<GetOrganizationInfoQuery, GetOrganizationInfoQueryVariables>;
export const GetOrganizationMembersDocument = gql`
    query GetOrganizationMembers {
  organizationCodes: organization_codes(order_by: {created: desc}) {
    id
    code
    originalUserEmail
    subscriptionExpiration
    organizationCourseGroups {
      organizationCourseGroup {
        id
        name
      }
    }
    teacher {
      id
      email
      name
      customer {
        id
        subscriptionStatus
        organizationSubscriptionExpiration
      }
      organizationCourseGroups {
        organizationCourseGroup {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
      }
export function useGetOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationMembersQuery | undefined, GetOrganizationMembersQueryVariables>;
export function useGetOrganizationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
export type GetOrganizationMembersQueryHookResult = ReturnType<typeof useGetOrganizationMembersQuery>;
export type GetOrganizationMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationMembersLazyQuery>;
export type GetOrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationMembersSuspenseQuery>;
export type GetOrganizationMembersQueryResult = Apollo.QueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const GetOrganizationSeatUsageInfoDocument = gql`
    query GetOrganizationSeatUsageInfo($adminId: String!) {
  organizationAdmin: organization_admin(id: $adminId) {
    organization {
      id
      ignoredEmails
      freeEmails
      numberOfSeatsAvailable
    }
  }
}
    `;

/**
 * __useGetOrganizationSeatUsageInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSeatUsageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSeatUsageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSeatUsageInfoQuery({
 *   variables: {
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useGetOrganizationSeatUsageInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables> & ({ variables: GetOrganizationSeatUsageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>(GetOrganizationSeatUsageInfoDocument, options);
      }
export function useGetOrganizationSeatUsageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>(GetOrganizationSeatUsageInfoDocument, options);
        }
// @ts-ignore
export function useGetOrganizationSeatUsageInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>;
export function useGetOrganizationSeatUsageInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationSeatUsageInfoQuery | undefined, GetOrganizationSeatUsageInfoQueryVariables>;
export function useGetOrganizationSeatUsageInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>(GetOrganizationSeatUsageInfoDocument, options);
        }
export type GetOrganizationSeatUsageInfoQueryHookResult = ReturnType<typeof useGetOrganizationSeatUsageInfoQuery>;
export type GetOrganizationSeatUsageInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationSeatUsageInfoLazyQuery>;
export type GetOrganizationSeatUsageInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSeatUsageInfoSuspenseQuery>;
export type GetOrganizationSeatUsageInfoQueryResult = Apollo.QueryResult<GetOrganizationSeatUsageInfoQuery, GetOrganizationSeatUsageInfoQueryVariables>;
export const GetOrganizationThemeForOrganizationAdminDocument = gql`
    query GetOrganizationThemeForOrganizationAdmin($organizationAdminId: String!) {
  organizationAdmin: organization_admin(id: $organizationAdminId) {
    id
    organization {
      id
      themes(where: {isPrimary: {_eq: true}}, order_by: {id: asc}, limit: 1) {
        ...ThemeDetails
      }
    }
  }
}
    ${ThemeDetailsFragmentDoc}`;

/**
 * __useGetOrganizationThemeForOrganizationAdminQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForOrganizationAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForOrganizationAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForOrganizationAdminQuery({
 *   variables: {
 *      organizationAdminId: // value for 'organizationAdminId'
 *   },
 * });
 */
export function useGetOrganizationThemeForOrganizationAdminQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables> & ({ variables: GetOrganizationThemeForOrganizationAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
      }
export function useGetOrganizationThemeForOrganizationAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
        }
// @ts-ignore
export function useGetOrganizationThemeForOrganizationAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>;
export function useGetOrganizationThemeForOrganizationAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForOrganizationAdminQuery | undefined, GetOrganizationThemeForOrganizationAdminQueryVariables>;
export function useGetOrganizationThemeForOrganizationAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>(GetOrganizationThemeForOrganizationAdminDocument, options);
        }
export type GetOrganizationThemeForOrganizationAdminQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminQuery>;
export type GetOrganizationThemeForOrganizationAdminLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminLazyQuery>;
export type GetOrganizationThemeForOrganizationAdminSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForOrganizationAdminSuspenseQuery>;
export type GetOrganizationThemeForOrganizationAdminQueryResult = Apollo.QueryResult<GetOrganizationThemeForOrganizationAdminQuery, GetOrganizationThemeForOrganizationAdminQueryVariables>;
export const GetOrganizationThemeForStudentDocument = gql`
    query GetOrganizationThemeForStudent($studentAccountId: String!) {
  studentAccount: student_account(id: $studentAccountId) {
    id
    student {
      id
      teachers {
        teacher {
          id
          organization {
            id
            themes(where: {isPrimary: {_eq: true}}, order_by: {id: asc}, limit: 1) {
              ...ThemeDetails
            }
          }
        }
      }
    }
    userSettings {
      id
      selectedTheme {
        ...ThemeDetails
      }
    }
  }
}
    ${ThemeDetailsFragmentDoc}`;

/**
 * __useGetOrganizationThemeForStudentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForStudentQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetOrganizationThemeForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables> & ({ variables: GetOrganizationThemeForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
      }
export function useGetOrganizationThemeForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
        }
// @ts-ignore
export function useGetOrganizationThemeForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>;
export function useGetOrganizationThemeForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForStudentQuery | undefined, GetOrganizationThemeForStudentQueryVariables>;
export function useGetOrganizationThemeForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>(GetOrganizationThemeForStudentDocument, options);
        }
export type GetOrganizationThemeForStudentQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentQuery>;
export type GetOrganizationThemeForStudentLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentLazyQuery>;
export type GetOrganizationThemeForStudentSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForStudentSuspenseQuery>;
export type GetOrganizationThemeForStudentQueryResult = Apollo.QueryResult<GetOrganizationThemeForStudentQuery, GetOrganizationThemeForStudentQueryVariables>;
export const GetOrganizationThemeForTeacherDocument = gql`
    query GetOrganizationThemeForTeacher($teacherId: String!) {
  teacher(id: $teacherId) {
    id
    organization {
      id
      themes(where: {isPrimary: {_eq: true}}, order_by: {id: asc}, limit: 1) {
        ...ThemeDetails
      }
    }
    userSettings {
      id
      selectedTheme {
        ...ThemeDetails
      }
    }
  }
}
    ${ThemeDetailsFragmentDoc}`;

/**
 * __useGetOrganizationThemeForTeacherQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemeForTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemeForTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemeForTeacherQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetOrganizationThemeForTeacherQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables> & ({ variables: GetOrganizationThemeForTeacherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
      }
export function useGetOrganizationThemeForTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
        }
// @ts-ignore
export function useGetOrganizationThemeForTeacherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>;
export function useGetOrganizationThemeForTeacherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemeForTeacherQuery | undefined, GetOrganizationThemeForTeacherQueryVariables>;
export function useGetOrganizationThemeForTeacherSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>(GetOrganizationThemeForTeacherDocument, options);
        }
export type GetOrganizationThemeForTeacherQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherQuery>;
export type GetOrganizationThemeForTeacherLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherLazyQuery>;
export type GetOrganizationThemeForTeacherSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemeForTeacherSuspenseQuery>;
export type GetOrganizationThemeForTeacherQueryResult = Apollo.QueryResult<GetOrganizationThemeForTeacherQuery, GetOrganizationThemeForTeacherQueryVariables>;
export const GetOrganizationThemesDocument = gql`
    query GetOrganizationThemes($organizationId: uuid!) {
  organization(id: $organizationId) {
    id
    allowDefaultSyllabirdThemes
    themes(order_by: [{created: asc_nulls_last}, {id: asc}]) {
      ...ThemeDetails
    }
  }
}
    ${ThemeDetailsFragmentDoc}`;

/**
 * __useGetOrganizationThemesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationThemesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationThemesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables> & ({ variables: GetOrganizationThemesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>(GetOrganizationThemesDocument, options);
      }
export function useGetOrganizationThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>(GetOrganizationThemesDocument, options);
        }
// @ts-ignore
export function useGetOrganizationThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>;
export function useGetOrganizationThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationThemesQuery | undefined, GetOrganizationThemesQueryVariables>;
export function useGetOrganizationThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>(GetOrganizationThemesDocument, options);
        }
export type GetOrganizationThemesQueryHookResult = ReturnType<typeof useGetOrganizationThemesQuery>;
export type GetOrganizationThemesLazyQueryHookResult = ReturnType<typeof useGetOrganizationThemesLazyQuery>;
export type GetOrganizationThemesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationThemesSuspenseQuery>;
export type GetOrganizationThemesQueryResult = Apollo.QueryResult<GetOrganizationThemesQuery, GetOrganizationThemesQueryVariables>;
export const GetParrotRequestQueueDocument = gql`
    query GetParrotRequestQueue {
  parrotRequests: parrot_requests(
    order_by: {queuePosition: asc}
    where: {status: {_eq: PENDING}}
  ) {
    ...ParrotRequestInfo
    teacher {
      id
      email
    }
  }
}
    ${ParrotRequestInfoFragmentDoc}`;

/**
 * __useGetParrotRequestQueueQuery__
 *
 * To run a query within a React component, call `useGetParrotRequestQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParrotRequestQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParrotRequestQueueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParrotRequestQueueQuery(baseOptions?: Apollo.QueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
      }
export function useGetParrotRequestQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
        }
// @ts-ignore
export function useGetParrotRequestQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>;
export function useGetParrotRequestQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetParrotRequestQueueQuery | undefined, GetParrotRequestQueueQueryVariables>;
export function useGetParrotRequestQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>(GetParrotRequestQueueDocument, options);
        }
export type GetParrotRequestQueueQueryHookResult = ReturnType<typeof useGetParrotRequestQueueQuery>;
export type GetParrotRequestQueueLazyQueryHookResult = ReturnType<typeof useGetParrotRequestQueueLazyQuery>;
export type GetParrotRequestQueueSuspenseQueryHookResult = ReturnType<typeof useGetParrotRequestQueueSuspenseQuery>;
export type GetParrotRequestQueueQueryResult = Apollo.QueryResult<GetParrotRequestQueueQuery, GetParrotRequestQueueQueryVariables>;
export const GetPlanningAssignmentDocument = gql`
    query GetPlanningAssignment($assignmentId: uuid!) {
  assignment(id: $assignmentId) {
    ...PlanningAssignmentDetail
  }
}
    ${PlanningAssignmentDetailFragmentDoc}
${PlanningAssignmentStudentAssignmentFragmentDoc}
${PlanningStudentAssignmentFragmentDoc}
${StudentsEventsFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}`;

/**
 * __useGetPlanningAssignmentQuery__
 *
 * To run a query within a React component, call `useGetPlanningAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningAssignmentQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetPlanningAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables> & ({ variables: GetPlanningAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
      }
export function useGetPlanningAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
        }
// @ts-ignore
export function useGetPlanningAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>;
export function useGetPlanningAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningAssignmentQuery | undefined, GetPlanningAssignmentQueryVariables>;
export function useGetPlanningAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>(GetPlanningAssignmentDocument, options);
        }
export type GetPlanningAssignmentQueryHookResult = ReturnType<typeof useGetPlanningAssignmentQuery>;
export type GetPlanningAssignmentLazyQueryHookResult = ReturnType<typeof useGetPlanningAssignmentLazyQuery>;
export type GetPlanningAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetPlanningAssignmentSuspenseQuery>;
export type GetPlanningAssignmentQueryResult = Apollo.QueryResult<GetPlanningAssignmentQuery, GetPlanningAssignmentQueryVariables>;
export const GetPlanningCourseDocument = gql`
    query GetPlanningCourse($courseId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments(order_by: {created: asc}) {
      ...PlanningAssignmentBase
    }
  }
}
    ${PlanningAssignmentBaseFragmentDoc}`;

/**
 * __useGetPlanningCourseQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetPlanningCourseQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables> & ({ variables: GetPlanningCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
      }
export function useGetPlanningCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
        }
// @ts-ignore
export function useGetPlanningCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>;
export function useGetPlanningCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseQuery | undefined, GetPlanningCourseQueryVariables>;
export function useGetPlanningCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>(GetPlanningCourseDocument, options);
        }
export type GetPlanningCourseQueryHookResult = ReturnType<typeof useGetPlanningCourseQuery>;
export type GetPlanningCourseLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseLazyQuery>;
export type GetPlanningCourseSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseSuspenseQuery>;
export type GetPlanningCourseQueryResult = Apollo.QueryResult<GetPlanningCourseQuery, GetPlanningCourseQueryVariables>;
export const GetPlanningCourseForParrotDocument = gql`
    query GetPlanningCourseForParrot($courseId: uuid!, $parrotRequestId: uuid!) {
  course(id: $courseId) {
    id
    name
    color
    numberOfWeeks
    numberOfDaysPerWeek
    assignments(
      where: {_and: [{parrotRequestId: {_is_null: false}}, {parrotRequestId: {_eq: $parrotRequestId}}]}
    ) {
      ...PlanningAssignmentBase
    }
  }
}
    ${PlanningAssignmentBaseFragmentDoc}`;

/**
 * __useGetPlanningCourseForParrotQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseForParrotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseForParrotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseForParrotQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      parrotRequestId: // value for 'parrotRequestId'
 *   },
 * });
 */
export function useGetPlanningCourseForParrotQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables> & ({ variables: GetPlanningCourseForParrotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
      }
export function useGetPlanningCourseForParrotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
        }
// @ts-ignore
export function useGetPlanningCourseForParrotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>;
export function useGetPlanningCourseForParrotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseForParrotQuery | undefined, GetPlanningCourseForParrotQueryVariables>;
export function useGetPlanningCourseForParrotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>(GetPlanningCourseForParrotDocument, options);
        }
export type GetPlanningCourseForParrotQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotQuery>;
export type GetPlanningCourseForParrotLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotLazyQuery>;
export type GetPlanningCourseForParrotSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseForParrotSuspenseQuery>;
export type GetPlanningCourseForParrotQueryResult = Apollo.QueryResult<GetPlanningCourseForParrotQuery, GetPlanningCourseForParrotQueryVariables>;
export const GetPlanningCourseStudentCoursesDocument = gql`
    query GetPlanningCourseStudentCourses($courseId: uuid!) {
  course(id: $courseId) {
    id
    studentCourses {
      ...PlanningStudentCourse
    }
  }
}
    ${PlanningStudentCourseFragmentDoc}
${StudentsEventsFragmentDoc}`;

/**
 * __useGetPlanningCourseStudentCoursesQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseStudentCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseStudentCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseStudentCoursesQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetPlanningCourseStudentCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables> & ({ variables: GetPlanningCourseStudentCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>(GetPlanningCourseStudentCoursesDocument, options);
      }
export function useGetPlanningCourseStudentCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>(GetPlanningCourseStudentCoursesDocument, options);
        }
// @ts-ignore
export function useGetPlanningCourseStudentCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>;
export function useGetPlanningCourseStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseStudentCoursesQuery | undefined, GetPlanningCourseStudentCoursesQueryVariables>;
export function useGetPlanningCourseStudentCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>(GetPlanningCourseStudentCoursesDocument, options);
        }
export type GetPlanningCourseStudentCoursesQueryHookResult = ReturnType<typeof useGetPlanningCourseStudentCoursesQuery>;
export type GetPlanningCourseStudentCoursesLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseStudentCoursesLazyQuery>;
export type GetPlanningCourseStudentCoursesSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseStudentCoursesSuspenseQuery>;
export type GetPlanningCourseStudentCoursesQueryResult = Apollo.QueryResult<GetPlanningCourseStudentCoursesQuery, GetPlanningCourseStudentCoursesQueryVariables>;
export const GetPlanningCourseAssignmentTypeWeightsDocument = gql`
    query GetPlanningCourseAssignmentTypeWeights($courseId: uuid!) {
  course(id: $courseId) {
    id
    ...AssignmentTypeWeightsInfo
  }
}
    ${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}`;

/**
 * __useGetPlanningCourseAssignmentTypeWeightsQuery__
 *
 * To run a query within a React component, call `useGetPlanningCourseAssignmentTypeWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanningCourseAssignmentTypeWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanningCourseAssignmentTypeWeightsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetPlanningCourseAssignmentTypeWeightsQuery(baseOptions: Apollo.QueryHookOptions<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables> & ({ variables: GetPlanningCourseAssignmentTypeWeightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>(GetPlanningCourseAssignmentTypeWeightsDocument, options);
      }
export function useGetPlanningCourseAssignmentTypeWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>(GetPlanningCourseAssignmentTypeWeightsDocument, options);
        }
// @ts-ignore
export function useGetPlanningCourseAssignmentTypeWeightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>;
export function useGetPlanningCourseAssignmentTypeWeightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlanningCourseAssignmentTypeWeightsQuery | undefined, GetPlanningCourseAssignmentTypeWeightsQueryVariables>;
export function useGetPlanningCourseAssignmentTypeWeightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>(GetPlanningCourseAssignmentTypeWeightsDocument, options);
        }
export type GetPlanningCourseAssignmentTypeWeightsQueryHookResult = ReturnType<typeof useGetPlanningCourseAssignmentTypeWeightsQuery>;
export type GetPlanningCourseAssignmentTypeWeightsLazyQueryHookResult = ReturnType<typeof useGetPlanningCourseAssignmentTypeWeightsLazyQuery>;
export type GetPlanningCourseAssignmentTypeWeightsSuspenseQueryHookResult = ReturnType<typeof useGetPlanningCourseAssignmentTypeWeightsSuspenseQuery>;
export type GetPlanningCourseAssignmentTypeWeightsQueryResult = Apollo.QueryResult<GetPlanningCourseAssignmentTypeWeightsQuery, GetPlanningCourseAssignmentTypeWeightsQueryVariables>;
export const GetPreviousPrintingJobsDocument = gql`
    query GetPreviousPrintingJobs($printingJobType: printing_job_type_enum) {
  exports: printing_jobs(
    where: {_and: [{status: {_eq: COMPLETE}}, {type: {_eq: $printingJobType}}]}
    limit: 10
    order_by: {created: desc}
  ) {
    id
    file {
      id
      url
    }
  }
}
    `;

/**
 * __useGetPreviousPrintingJobsQuery__
 *
 * To run a query within a React component, call `useGetPreviousPrintingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousPrintingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousPrintingJobsQuery({
 *   variables: {
 *      printingJobType: // value for 'printingJobType'
 *   },
 * });
 */
export function useGetPreviousPrintingJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
      }
export function useGetPreviousPrintingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
        }
// @ts-ignore
export function useGetPreviousPrintingJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>;
export function useGetPreviousPrintingJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviousPrintingJobsQuery | undefined, GetPreviousPrintingJobsQueryVariables>;
export function useGetPreviousPrintingJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>(GetPreviousPrintingJobsDocument, options);
        }
export type GetPreviousPrintingJobsQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsQuery>;
export type GetPreviousPrintingJobsLazyQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsLazyQuery>;
export type GetPreviousPrintingJobsSuspenseQueryHookResult = ReturnType<typeof useGetPreviousPrintingJobsSuspenseQuery>;
export type GetPreviousPrintingJobsQueryResult = Apollo.QueryResult<GetPreviousPrintingJobsQuery, GetPreviousPrintingJobsQueryVariables>;
export const GetQuotasUsageDocument = gql`
    query GetQuotasUsage($teacherId: String!) {
  files: files_aggregate(where: {parrotRequestId: {_is_null: true}}) {
    aggregate {
      sum {
        size
      }
    }
  }
  teacher(id: $teacherId) {
    id
    customer {
      id
      parrotCredits
    }
  }
}
    `;

/**
 * __useGetQuotasUsageQuery__
 *
 * To run a query within a React component, call `useGetQuotasUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotasUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotasUsageQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetQuotasUsageQuery(baseOptions: Apollo.QueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables> & ({ variables: GetQuotasUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
      }
export function useGetQuotasUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
        }
// @ts-ignore
export function useGetQuotasUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>;
export function useGetQuotasUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotasUsageQuery | undefined, GetQuotasUsageQueryVariables>;
export function useGetQuotasUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>(GetQuotasUsageDocument, options);
        }
export type GetQuotasUsageQueryHookResult = ReturnType<typeof useGetQuotasUsageQuery>;
export type GetQuotasUsageLazyQueryHookResult = ReturnType<typeof useGetQuotasUsageLazyQuery>;
export type GetQuotasUsageSuspenseQueryHookResult = ReturnType<typeof useGetQuotasUsageSuspenseQuery>;
export type GetQuotasUsageQueryResult = Apollo.QueryResult<GetQuotasUsageQuery, GetQuotasUsageQueryVariables>;
export const GetRecentRescheduleActionsDocument = gql`
    query GetRecentRescheduleActions($since: timestamptz!) {
  rescheduleActions: reschedule_actions(
    where: {created: {_gte: $since}}
    order_by: {created: desc}
  ) {
    ...RescheduleAction
  }
}
    ${RescheduleActionFragmentDoc}`;

/**
 * __useGetRecentRescheduleActionsQuery__
 *
 * To run a query within a React component, call `useGetRecentRescheduleActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentRescheduleActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentRescheduleActionsQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useGetRecentRescheduleActionsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables> & ({ variables: GetRecentRescheduleActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>(GetRecentRescheduleActionsDocument, options);
      }
export function useGetRecentRescheduleActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>(GetRecentRescheduleActionsDocument, options);
        }
// @ts-ignore
export function useGetRecentRescheduleActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>;
export function useGetRecentRescheduleActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentRescheduleActionsQuery | undefined, GetRecentRescheduleActionsQueryVariables>;
export function useGetRecentRescheduleActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>(GetRecentRescheduleActionsDocument, options);
        }
export type GetRecentRescheduleActionsQueryHookResult = ReturnType<typeof useGetRecentRescheduleActionsQuery>;
export type GetRecentRescheduleActionsLazyQueryHookResult = ReturnType<typeof useGetRecentRescheduleActionsLazyQuery>;
export type GetRecentRescheduleActionsSuspenseQueryHookResult = ReturnType<typeof useGetRecentRescheduleActionsSuspenseQuery>;
export type GetRecentRescheduleActionsQueryResult = Apollo.QueryResult<GetRecentRescheduleActionsQuery, GetRecentRescheduleActionsQueryVariables>;
export const GetSelectableThemesDocument = gql`
    query GetSelectableThemes {
  organizations {
    id
    allowDefaultSyllabirdThemes
  }
  syllabirdThemes: themes(
    where: {isSyllabirdTheme: {_eq: true}}
    order_by: {id: asc}
  ) {
    ...ThemeDetails
  }
  organizationThemes: themes(
    where: {isSyllabirdTheme: {_eq: false}, visible: {_eq: true}}
    order_by: [{isPrimary: desc}, {created: asc_nulls_last}, {id: asc}]
  ) {
    ...ThemeDetails
  }
}
    ${ThemeDetailsFragmentDoc}`;

/**
 * __useGetSelectableThemesQuery__
 *
 * To run a query within a React component, call `useGetSelectableThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectableThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectableThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectableThemesQuery(baseOptions?: Apollo.QueryHookOptions<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>(GetSelectableThemesDocument, options);
      }
export function useGetSelectableThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>(GetSelectableThemesDocument, options);
        }
// @ts-ignore
export function useGetSelectableThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>;
export function useGetSelectableThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSelectableThemesQuery | undefined, GetSelectableThemesQueryVariables>;
export function useGetSelectableThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>(GetSelectableThemesDocument, options);
        }
export type GetSelectableThemesQueryHookResult = ReturnType<typeof useGetSelectableThemesQuery>;
export type GetSelectableThemesLazyQueryHookResult = ReturnType<typeof useGetSelectableThemesLazyQuery>;
export type GetSelectableThemesSuspenseQueryHookResult = ReturnType<typeof useGetSelectableThemesSuspenseQuery>;
export type GetSelectableThemesQueryResult = Apollo.QueryResult<GetSelectableThemesQuery, GetSelectableThemesQueryVariables>;
export const GetStorageUsageDocument = gql`
    query GetStorageUsage {
  files: files_aggregate(where: {parrotRequestId: {_is_null: true}}) {
    aggregate {
      sum {
        size
      }
    }
  }
}
    `;

/**
 * __useGetStorageUsageQuery__
 *
 * To run a query within a React component, call `useGetStorageUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageUsageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStorageUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
      }
export function useGetStorageUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
        }
// @ts-ignore
export function useGetStorageUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetStorageUsageQuery, GetStorageUsageQueryVariables>;
export function useGetStorageUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetStorageUsageQuery | undefined, GetStorageUsageQueryVariables>;
export function useGetStorageUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageUsageQuery, GetStorageUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageUsageQuery, GetStorageUsageQueryVariables>(GetStorageUsageDocument, options);
        }
export type GetStorageUsageQueryHookResult = ReturnType<typeof useGetStorageUsageQuery>;
export type GetStorageUsageLazyQueryHookResult = ReturnType<typeof useGetStorageUsageLazyQuery>;
export type GetStorageUsageSuspenseQueryHookResult = ReturnType<typeof useGetStorageUsageSuspenseQuery>;
export type GetStorageUsageQueryResult = Apollo.QueryResult<GetStorageUsageQuery, GetStorageUsageQueryVariables>;
export const GetStudentAccountInfoDocument = gql`
    query GetStudentAccountInfo($studentAccountId: String!) {
  studentAccount: student_account(id: $studentAccountId) {
    id
    email
    name
    picture
    userSettings {
      ...UserSettings
    }
    student {
      teachers {
        teacher {
          id
          organization {
            ...Organization
          }
        }
      }
    }
  }
}
    ${UserSettingsFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetStudentAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetStudentAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAccountInfoQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetStudentAccountInfoQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables> & ({ variables: GetStudentAccountInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
      }
export function useGetStudentAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
        }
// @ts-ignore
export function useGetStudentAccountInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>;
export function useGetStudentAccountInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAccountInfoQuery | undefined, GetStudentAccountInfoQueryVariables>;
export function useGetStudentAccountInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>(GetStudentAccountInfoDocument, options);
        }
export type GetStudentAccountInfoQueryHookResult = ReturnType<typeof useGetStudentAccountInfoQuery>;
export type GetStudentAccountInfoLazyQueryHookResult = ReturnType<typeof useGetStudentAccountInfoLazyQuery>;
export type GetStudentAccountInfoSuspenseQueryHookResult = ReturnType<typeof useGetStudentAccountInfoSuspenseQuery>;
export type GetStudentAccountInfoQueryResult = Apollo.QueryResult<GetStudentAccountInfoQuery, GetStudentAccountInfoQueryVariables>;
export const GetStudentAssignmentDocument = gql`
    query GetStudentAssignment($studentAssignmentId: uuid!, $isStudent: Boolean!) {
  studentAssignment: student_assignment(id: $studentAssignmentId) {
    ...StudentAssignmentDetails
  }
}
    ${StudentAssignmentDetailsFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentsEventsFragmentDoc}
${CommentInfoFragmentDoc}`;

/**
 * __useGetStudentAssignmentQuery__
 *
 * To run a query within a React component, call `useGetStudentAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAssignmentQuery({
 *   variables: {
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *      isStudent: // value for 'isStudent'
 *   },
 * });
 */
export function useGetStudentAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables> & ({ variables: GetStudentAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
      }
export function useGetStudentAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
        }
// @ts-ignore
export function useGetStudentAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>;
export function useGetStudentAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAssignmentQuery | undefined, GetStudentAssignmentQueryVariables>;
export function useGetStudentAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>(GetStudentAssignmentDocument, options);
        }
export type GetStudentAssignmentQueryHookResult = ReturnType<typeof useGetStudentAssignmentQuery>;
export type GetStudentAssignmentLazyQueryHookResult = ReturnType<typeof useGetStudentAssignmentLazyQuery>;
export type GetStudentAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetStudentAssignmentSuspenseQuery>;
export type GetStudentAssignmentQueryResult = Apollo.QueryResult<GetStudentAssignmentQuery, GetStudentAssignmentQueryVariables>;
export const GetStudentAssignmentsForRescheduleDocument = gql`
    query GetStudentAssignmentsForReschedule($courseId: uuid!, $assignmentIds: [uuid!]!) {
  course(id: $courseId) {
    id
    studentCourses {
      id
      start
      daysOfTheWeek
      courseDayOffsets
      student {
        id
        studentEvents {
          ...StudentEventInfo
        }
      }
      studentAssignments(where: {assignmentId: {_in: $assignmentIds}}) {
        ...PlanningStudentAssignmentReschedule
      }
    }
  }
}
    ${StudentEventInfoFragmentDoc}
${PlanningStudentAssignmentRescheduleFragmentDoc}`;

/**
 * __useGetStudentAssignmentsForRescheduleQuery__
 *
 * To run a query within a React component, call `useGetStudentAssignmentsForRescheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAssignmentsForRescheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAssignmentsForRescheduleQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      assignmentIds: // value for 'assignmentIds'
 *   },
 * });
 */
export function useGetStudentAssignmentsForRescheduleQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables> & ({ variables: GetStudentAssignmentsForRescheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>(GetStudentAssignmentsForRescheduleDocument, options);
      }
export function useGetStudentAssignmentsForRescheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>(GetStudentAssignmentsForRescheduleDocument, options);
        }
// @ts-ignore
export function useGetStudentAssignmentsForRescheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>;
export function useGetStudentAssignmentsForRescheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAssignmentsForRescheduleQuery | undefined, GetStudentAssignmentsForRescheduleQueryVariables>;
export function useGetStudentAssignmentsForRescheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>(GetStudentAssignmentsForRescheduleDocument, options);
        }
export type GetStudentAssignmentsForRescheduleQueryHookResult = ReturnType<typeof useGetStudentAssignmentsForRescheduleQuery>;
export type GetStudentAssignmentsForRescheduleLazyQueryHookResult = ReturnType<typeof useGetStudentAssignmentsForRescheduleLazyQuery>;
export type GetStudentAssignmentsForRescheduleSuspenseQueryHookResult = ReturnType<typeof useGetStudentAssignmentsForRescheduleSuspenseQuery>;
export type GetStudentAssignmentsForRescheduleQueryResult = Apollo.QueryResult<GetStudentAssignmentsForRescheduleQuery, GetStudentAssignmentsForRescheduleQueryVariables>;
export const GetStudentCardsDocument = gql`
    query GetStudentCards {
  students(order_by: {name: asc}) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentCardsQuery__
 *
 * To run a query within a React component, call `useGetStudentCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudentCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
      }
export function useGetStudentCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
        }
// @ts-ignore
export function useGetStudentCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCardsQuery, GetStudentCardsQueryVariables>;
export function useGetStudentCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCardsQuery | undefined, GetStudentCardsQueryVariables>;
export function useGetStudentCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCardsQuery, GetStudentCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCardsQuery, GetStudentCardsQueryVariables>(GetStudentCardsDocument, options);
        }
export type GetStudentCardsQueryHookResult = ReturnType<typeof useGetStudentCardsQuery>;
export type GetStudentCardsLazyQueryHookResult = ReturnType<typeof useGetStudentCardsLazyQuery>;
export type GetStudentCardsSuspenseQueryHookResult = ReturnType<typeof useGetStudentCardsSuspenseQuery>;
export type GetStudentCardsQueryResult = Apollo.QueryResult<GetStudentCardsQuery, GetStudentCardsQueryVariables>;
export const GetStudentCourseDocument = gql`
    query GetStudentCourse($studentCourseId: uuid!) {
  studentCourse: student_course(id: $studentCourseId) {
    student {
      id
      name
      picture
    }
    ...StudentCourseInfo
  }
}
    ${StudentCourseInfoFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;

/**
 * __useGetStudentCourseQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseQuery({
 *   variables: {
 *      studentCourseId: // value for 'studentCourseId'
 *   },
 * });
 */
export function useGetStudentCourseQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables> & ({ variables: GetStudentCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
      }
export function useGetStudentCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
        }
// @ts-ignore
export function useGetStudentCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseQuery, GetStudentCourseQueryVariables>;
export function useGetStudentCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseQuery | undefined, GetStudentCourseQueryVariables>;
export function useGetStudentCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseQuery, GetStudentCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCourseQuery, GetStudentCourseQueryVariables>(GetStudentCourseDocument, options);
        }
export type GetStudentCourseQueryHookResult = ReturnType<typeof useGetStudentCourseQuery>;
export type GetStudentCourseLazyQueryHookResult = ReturnType<typeof useGetStudentCourseLazyQuery>;
export type GetStudentCourseSuspenseQueryHookResult = ReturnType<typeof useGetStudentCourseSuspenseQuery>;
export type GetStudentCourseQueryResult = Apollo.QueryResult<GetStudentCourseQuery, GetStudentCourseQueryVariables>;
export const GetStudentCourseToRescheduleForCourseShiftDocument = gql`
    query GetStudentCourseToRescheduleForCourseShift($date: date!, $week: Int!, $day: Int!, $courseId: uuid!, $studentAssignmentId: uuid!) {
  studentCourseToReschedule: student_course(id: $courseId) {
    ...StudentCourseToReschedule
  }
  studentCourseToReoffset: student_course(id: $courseId) {
    ...StudentCourseToReoffset
  }
}
    ${StudentCourseToRescheduleFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${StudentCourseToReoffsetFragmentDoc}`;

/**
 * __useGetStudentCourseToRescheduleForCourseShiftQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseToRescheduleForCourseShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseToRescheduleForCourseShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseToRescheduleForCourseShiftQuery({
 *   variables: {
 *      date: // value for 'date'
 *      week: // value for 'week'
 *      day: // value for 'day'
 *      courseId: // value for 'courseId'
 *      studentAssignmentId: // value for 'studentAssignmentId'
 *   },
 * });
 */
export function useGetStudentCourseToRescheduleForCourseShiftQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables> & ({ variables: GetStudentCourseToRescheduleForCourseShiftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
      }
export function useGetStudentCourseToRescheduleForCourseShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
        }
// @ts-ignore
export function useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>;
export function useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseToRescheduleForCourseShiftQuery | undefined, GetStudentCourseToRescheduleForCourseShiftQueryVariables>;
export function useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>(GetStudentCourseToRescheduleForCourseShiftDocument, options);
        }
export type GetStudentCourseToRescheduleForCourseShiftQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftQuery>;
export type GetStudentCourseToRescheduleForCourseShiftLazyQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftLazyQuery>;
export type GetStudentCourseToRescheduleForCourseShiftSuspenseQueryHookResult = ReturnType<typeof useGetStudentCourseToRescheduleForCourseShiftSuspenseQuery>;
export type GetStudentCourseToRescheduleForCourseShiftQueryResult = Apollo.QueryResult<GetStudentCourseToRescheduleForCourseShiftQuery, GetStudentCourseToRescheduleForCourseShiftQueryVariables>;
export const GetStudentCoursesByIdsDocument = gql`
    query GetStudentCoursesByIds($ids: [uuid!]!) {
  studentCourses: student_courses(where: {id: {_in: $ids}}) {
    ...ActiveStudentTranscriptCourse
  }
}
    ${ActiveStudentTranscriptCourseFragmentDoc}
${GradebookStudentAssignmentFragmentDoc}
${CustomAssignmentTypeFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}
${AssignmentTypeWeightsInfoFragmentDoc}
${AssignmentTypeWeightInfoFragmentDoc}`;

/**
 * __useGetStudentCoursesByIdsQuery__
 *
 * To run a query within a React component, call `useGetStudentCoursesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCoursesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCoursesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStudentCoursesByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables> & ({ variables: GetStudentCoursesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>(GetStudentCoursesByIdsDocument, options);
      }
export function useGetStudentCoursesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>(GetStudentCoursesByIdsDocument, options);
        }
// @ts-ignore
export function useGetStudentCoursesByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>;
export function useGetStudentCoursesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesByIdsQuery | undefined, GetStudentCoursesByIdsQueryVariables>;
export function useGetStudentCoursesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>(GetStudentCoursesByIdsDocument, options);
        }
export type GetStudentCoursesByIdsQueryHookResult = ReturnType<typeof useGetStudentCoursesByIdsQuery>;
export type GetStudentCoursesByIdsLazyQueryHookResult = ReturnType<typeof useGetStudentCoursesByIdsLazyQuery>;
export type GetStudentCoursesByIdsSuspenseQueryHookResult = ReturnType<typeof useGetStudentCoursesByIdsSuspenseQuery>;
export type GetStudentCoursesByIdsQueryResult = Apollo.QueryResult<GetStudentCoursesByIdsQuery, GetStudentCoursesByIdsQueryVariables>;
export const GetStudentCoursesToConvertGradingStyleDocument = gql`
    query GetStudentCoursesToConvertGradingStyle($courseId: uuid!) {
  studentCourses: student_courses(where: {courseId: {_eq: $courseId}}) {
    ...StudentCoursesToUpdateGradingStyle
  }
}
    ${StudentCoursesToUpdateGradingStyleFragmentDoc}
${StudentAssignmentToUpdateGradingStyleFragmentDoc}`;

/**
 * __useGetStudentCoursesToConvertGradingStyleQuery__
 *
 * To run a query within a React component, call `useGetStudentCoursesToConvertGradingStyleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCoursesToConvertGradingStyleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCoursesToConvertGradingStyleQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetStudentCoursesToConvertGradingStyleQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables> & ({ variables: GetStudentCoursesToConvertGradingStyleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
      }
export function useGetStudentCoursesToConvertGradingStyleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
        }
// @ts-ignore
export function useGetStudentCoursesToConvertGradingStyleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>;
export function useGetStudentCoursesToConvertGradingStyleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesToConvertGradingStyleQuery | undefined, GetStudentCoursesToConvertGradingStyleQueryVariables>;
export function useGetStudentCoursesToConvertGradingStyleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>(GetStudentCoursesToConvertGradingStyleDocument, options);
        }
export type GetStudentCoursesToConvertGradingStyleQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleQuery>;
export type GetStudentCoursesToConvertGradingStyleLazyQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleLazyQuery>;
export type GetStudentCoursesToConvertGradingStyleSuspenseQueryHookResult = ReturnType<typeof useGetStudentCoursesToConvertGradingStyleSuspenseQuery>;
export type GetStudentCoursesToConvertGradingStyleQueryResult = Apollo.QueryResult<GetStudentCoursesToConvertGradingStyleQuery, GetStudentCoursesToConvertGradingStyleQueryVariables>;
export const GetStudentCoursesToRescheduleDocument = gql`
    query GetStudentCoursesToReschedule($date: date!, $studentIds: [String!]) {
  studentCourses: student_courses(where: {student: {id: {_in: $studentIds}}}) {
    ...StudentCourseToReschedule
  }
}
    ${StudentCourseToRescheduleFragmentDoc}
${StudentAssignmentToRescheduleFragmentDoc}`;

/**
 * __useGetStudentCoursesToRescheduleQuery__
 *
 * To run a query within a React component, call `useGetStudentCoursesToRescheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCoursesToRescheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCoursesToRescheduleQuery({
 *   variables: {
 *      date: // value for 'date'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useGetStudentCoursesToRescheduleQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables> & ({ variables: GetStudentCoursesToRescheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
      }
export function useGetStudentCoursesToRescheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
        }
// @ts-ignore
export function useGetStudentCoursesToRescheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>;
export function useGetStudentCoursesToRescheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCoursesToRescheduleQuery | undefined, GetStudentCoursesToRescheduleQueryVariables>;
export function useGetStudentCoursesToRescheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>(GetStudentCoursesToRescheduleDocument, options);
        }
export type GetStudentCoursesToRescheduleQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleQuery>;
export type GetStudentCoursesToRescheduleLazyQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleLazyQuery>;
export type GetStudentCoursesToRescheduleSuspenseQueryHookResult = ReturnType<typeof useGetStudentCoursesToRescheduleSuspenseQuery>;
export type GetStudentCoursesToRescheduleQueryResult = Apollo.QueryResult<GetStudentCoursesToRescheduleQuery, GetStudentCoursesToRescheduleQueryVariables>;
export const GetStudentInfoDocument = gql`
    query GetStudentInfo($studentId: String!) {
  student(id: $studentId) {
    ...StudentInfo
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentInfoQuery__
 *
 * To run a query within a React component, call `useGetStudentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentInfoQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetStudentInfoQuery(baseOptions: Apollo.QueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables> & ({ variables: GetStudentInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
      }
export function useGetStudentInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
        }
// @ts-ignore
export function useGetStudentInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentInfoQuery, GetStudentInfoQueryVariables>;
export function useGetStudentInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentInfoQuery | undefined, GetStudentInfoQueryVariables>;
export function useGetStudentInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentInfoQuery, GetStudentInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentInfoQuery, GetStudentInfoQueryVariables>(GetStudentInfoDocument, options);
        }
export type GetStudentInfoQueryHookResult = ReturnType<typeof useGetStudentInfoQuery>;
export type GetStudentInfoLazyQueryHookResult = ReturnType<typeof useGetStudentInfoLazyQuery>;
export type GetStudentInfoSuspenseQueryHookResult = ReturnType<typeof useGetStudentInfoSuspenseQuery>;
export type GetStudentInfoQueryResult = Apollo.QueryResult<GetStudentInfoQuery, GetStudentInfoQueryVariables>;
export const GetStudentInfoForStudentAccountDocument = gql`
    query GetStudentInfoForStudentAccount($studentAccountId: String!) {
  student_account(id: $studentAccountId) {
    student {
      ...StudentInfo
    }
  }
}
    ${StudentInfoFragmentDoc}`;

/**
 * __useGetStudentInfoForStudentAccountQuery__
 *
 * To run a query within a React component, call `useGetStudentInfoForStudentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentInfoForStudentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentInfoForStudentAccountQuery({
 *   variables: {
 *      studentAccountId: // value for 'studentAccountId'
 *   },
 * });
 */
export function useGetStudentInfoForStudentAccountQuery(baseOptions: Apollo.QueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables> & ({ variables: GetStudentInfoForStudentAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
      }
export function useGetStudentInfoForStudentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
        }
// @ts-ignore
export function useGetStudentInfoForStudentAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>;
export function useGetStudentInfoForStudentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentInfoForStudentAccountQuery | undefined, GetStudentInfoForStudentAccountQueryVariables>;
export function useGetStudentInfoForStudentAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>(GetStudentInfoForStudentAccountDocument, options);
        }
export type GetStudentInfoForStudentAccountQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountQuery>;
export type GetStudentInfoForStudentAccountLazyQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountLazyQuery>;
export type GetStudentInfoForStudentAccountSuspenseQueryHookResult = ReturnType<typeof useGetStudentInfoForStudentAccountSuspenseQuery>;
export type GetStudentInfoForStudentAccountQueryResult = Apollo.QueryResult<GetStudentInfoForStudentAccountQuery, GetStudentInfoForStudentAccountQueryVariables>;
export const GetTeacherInfoDocument = gql`
    query GetTeacherInfo($teacherId: String!) {
  teacher(id: $teacherId) {
    ...TeacherInfo
    userSettings {
      ...UserSettings
    }
    customer {
      id
      subscriptionStatus
      freeTrialEnd
      planTier
    }
  }
}
    ${TeacherInfoFragmentDoc}
${OrganizationFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useGetTeacherInfoQuery__
 *
 * To run a query within a React component, call `useGetTeacherInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeacherInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeacherInfoQuery({
 *   variables: {
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetTeacherInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables> & ({ variables: GetTeacherInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
      }
export function useGetTeacherInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
// @ts-ignore
export function useGetTeacherInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>;
export function useGetTeacherInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeacherInfoQuery | undefined, GetTeacherInfoQueryVariables>;
export function useGetTeacherInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>(GetTeacherInfoDocument, options);
        }
export type GetTeacherInfoQueryHookResult = ReturnType<typeof useGetTeacherInfoQuery>;
export type GetTeacherInfoLazyQueryHookResult = ReturnType<typeof useGetTeacherInfoLazyQuery>;
export type GetTeacherInfoSuspenseQueryHookResult = ReturnType<typeof useGetTeacherInfoSuspenseQuery>;
export type GetTeacherInfoQueryResult = Apollo.QueryResult<GetTeacherInfoQuery, GetTeacherInfoQueryVariables>;
export const GetTranscriptDraftDocument = gql`
    query GetTranscriptDraft($studentId: String!, $teacherId: String!) {
  transcriptDrafts: transcript_drafts(
    where: {studentId: {_eq: $studentId}, teacherId: {_eq: $teacherId}}
    order_by: {updated: desc}
    limit: 1
  ) {
    id
    studentId
    teacherId
    draftData
    created
    updated
  }
}
    `;

/**
 * __useGetTranscriptDraftQuery__
 *
 * To run a query within a React component, call `useGetTranscriptDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptDraftQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      teacherId: // value for 'teacherId'
 *   },
 * });
 */
export function useGetTranscriptDraftQuery(baseOptions: Apollo.QueryHookOptions<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables> & ({ variables: GetTranscriptDraftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>(GetTranscriptDraftDocument, options);
      }
export function useGetTranscriptDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>(GetTranscriptDraftDocument, options);
        }
// @ts-ignore
export function useGetTranscriptDraftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>;
export function useGetTranscriptDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranscriptDraftQuery | undefined, GetTranscriptDraftQueryVariables>;
export function useGetTranscriptDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>(GetTranscriptDraftDocument, options);
        }
export type GetTranscriptDraftQueryHookResult = ReturnType<typeof useGetTranscriptDraftQuery>;
export type GetTranscriptDraftLazyQueryHookResult = ReturnType<typeof useGetTranscriptDraftLazyQuery>;
export type GetTranscriptDraftSuspenseQueryHookResult = ReturnType<typeof useGetTranscriptDraftSuspenseQuery>;
export type GetTranscriptDraftQueryResult = Apollo.QueryResult<GetTranscriptDraftQuery, GetTranscriptDraftQueryVariables>;
export const GetPrintingJobsByIdsDocument = gql`
    subscription GetPrintingJobsByIds($ids: [uuid!]!) {
  printingJobs: printing_jobs(where: {id: {_in: $ids}}) {
    ...PrintingJobInfo
  }
}
    ${PrintingJobInfoFragmentDoc}`;

/**
 * __useGetPrintingJobsByIdsSubscription__
 *
 * To run a query within a React component, call `useGetPrintingJobsByIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintingJobsByIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintingJobsByIdsSubscription({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPrintingJobsByIdsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPrintingJobsByIdsSubscription, GetPrintingJobsByIdsSubscriptionVariables> & ({ variables: GetPrintingJobsByIdsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPrintingJobsByIdsSubscription, GetPrintingJobsByIdsSubscriptionVariables>(GetPrintingJobsByIdsDocument, options);
      }
export type GetPrintingJobsByIdsSubscriptionHookResult = ReturnType<typeof useGetPrintingJobsByIdsSubscription>;
export type GetPrintingJobsByIdsSubscriptionResult = Apollo.SubscriptionResult<GetPrintingJobsByIdsSubscription>;